var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        require('regenerator-runtime/runtime');

        // window.modalConsts = require("../../../../../mobile-lite/include/modal/_js/helpers/options/constant");
        //
        // if (!window.brxModal) {
        //     window.brxModal = require('../../../../../mobile-lite/include/modal/_js/modal');
        // }
    }, { "regenerator-runtime/runtime": 2 }], 2: [function (require, module, exports) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var runtime = function (exports) {
            "use strict";

            var Op = Object.prototype;
            var hasOwn = Op.hasOwnProperty;
            var defineProperty = Object.defineProperty || function (obj, key, desc) {
                obj[key] = desc.value;
            };
            var undefined; // More compressible than void 0.
            var $Symbol = typeof Symbol === "function" ? Symbol : {};
            var iteratorSymbol = $Symbol.iterator || "@@iterator";
            var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
            var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

            function define(obj, key, value) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                return obj[key];
            }
            try {
                // IE 8 has a broken Object.defineProperty that only works on DOM objects.
                define({}, "");
            } catch (err) {
                define = function define(obj, key, value) {
                    return obj[key] = value;
                };
            }

            function wrap(innerFn, outerFn, self, tryLocsList) {
                // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
                var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                var generator = Object.create(protoGenerator.prototype);
                var context = new Context(tryLocsList || []);

                // The ._invoke method unifies the implementations of the .next,
                // .throw, and .return methods.
                defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

                return generator;
            }
            exports.wrap = wrap;

            // Try/catch helper to minimize deoptimizations. Returns a completion
            // record like context.tryEntries[i].completion. This interface could
            // have been (and was previously) designed to take a closure to be
            // invoked without arguments, but in all the cases we care about we
            // already have an existing method we want to call, so there's no need
            // to create a new function object. We can even get away with assuming
            // the method takes exactly one argument, since that happens to be true
            // in every case, so we don't have to touch the arguments object. The
            // only additional allocation required is the completion record, which
            // has a stable shape and so hopefully should be cheap to allocate.
            function tryCatch(fn, obj, arg) {
                try {
                    return { type: "normal", arg: fn.call(obj, arg) };
                } catch (err) {
                    return { type: "throw", arg: err };
                }
            }

            var GenStateSuspendedStart = "suspendedStart";
            var GenStateSuspendedYield = "suspendedYield";
            var GenStateExecuting = "executing";
            var GenStateCompleted = "completed";

            // Returning this object from the innerFn has the same effect as
            // breaking out of the dispatch switch statement.
            var ContinueSentinel = {};

            // Dummy constructor functions that we use as the .constructor and
            // .constructor.prototype properties for functions that return Generator
            // objects. For full spec compliance, you may wish to configure your
            // minifier not to mangle the names of these two functions.
            function Generator() {}
            function GeneratorFunction() {}
            function GeneratorFunctionPrototype() {}

            // This is a polyfill for %IteratorPrototype% for environments that
            // don't natively support it.
            var IteratorPrototype = {};
            define(IteratorPrototype, iteratorSymbol, function () {
                return this;
            });

            var getProto = Object.getPrototypeOf;
            var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
            if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
                // This environment has a native %IteratorPrototype%; use it instead
                // of the polyfill.
                IteratorPrototype = NativeIteratorPrototype;
            }

            var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
            GeneratorFunction.prototype = GeneratorFunctionPrototype;
            defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
            defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: true });
            GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

            // Helper for defining the .next, .throw, and .return methods of the
            // Iterator interface in terms of a single ._invoke method.
            function defineIteratorMethods(prototype) {
                ["next", "throw", "return"].forEach(function (method) {
                    define(prototype, method, function (arg) {
                        return this._invoke(method, arg);
                    });
                });
            }

            exports.isGeneratorFunction = function (genFun) {
                var ctor = typeof genFun === "function" && genFun.constructor;
                return ctor ? ctor === GeneratorFunction ||
                // For the native GeneratorFunction constructor, the best we can
                // do is to check its .name property.
                (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
            };

            exports.mark = function (genFun) {
                if (Object.setPrototypeOf) {
                    Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                } else {
                    genFun.__proto__ = GeneratorFunctionPrototype;
                    define(genFun, toStringTagSymbol, "GeneratorFunction");
                }
                genFun.prototype = Object.create(Gp);
                return genFun;
            };

            // Within the body of any async function, `await x` is transformed to
            // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
            // `hasOwn.call(value, "__await")` to determine if the yielded value is
            // meant to be awaited.
            exports.awrap = function (arg) {
                return { __await: arg };
            };

            function AsyncIterator(generator, PromiseImpl) {
                function invoke(method, arg, resolve, reject) {
                    var record = tryCatch(generator[method], generator, arg);
                    if (record.type === "throw") {
                        reject(record.arg);
                    } else {
                        var result = record.arg;
                        var value = result.value;
                        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
                            return PromiseImpl.resolve(value.__await).then(function (value) {
                                invoke("next", value, resolve, reject);
                            }, function (err) {
                                invoke("throw", err, resolve, reject);
                            });
                        }

                        return PromiseImpl.resolve(value).then(function (unwrapped) {
                            // When a yielded Promise is resolved, its final value becomes
                            // the .value of the Promise<{value,done}> result for the
                            // current iteration.
                            result.value = unwrapped;
                            resolve(result);
                        }, function (error) {
                            // If a rejected Promise was yielded, throw the rejection back
                            // into the async generator function so it can be handled there.
                            return invoke("throw", error, resolve, reject);
                        });
                    }
                }

                var previousPromise;

                function enqueue(method, arg) {
                    function callInvokeWithMethodAndArg() {
                        return new PromiseImpl(function (resolve, reject) {
                            invoke(method, arg, resolve, reject);
                        });
                    }

                    return previousPromise =
                    // If enqueue has been called before, then we want to wait until
                    // all previous Promises have been resolved before calling invoke,
                    // so that results are always delivered in the correct order. If
                    // enqueue has not been called before, then it is important to
                    // call invoke immediately, without waiting on a callback to fire,
                    // so that the async generator function has the opportunity to do
                    // any necessary setup in a predictable way. This predictability
                    // is why the Promise constructor synchronously invokes its
                    // executor callback, and why async functions synchronously
                    // execute code before the first await. Since we implement simple
                    // async functions in terms of async generators, it is especially
                    // important to get this right, even though it requires care.
                    previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
                    // Avoid propagating failures to Promises returned by later
                    // invocations of the iterator.
                    callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                }

                // Define the unified helper method that is used to implement .next,
                // .throw, and .return (see defineIteratorMethods).
                defineProperty(this, "_invoke", { value: enqueue });
            }

            defineIteratorMethods(AsyncIterator.prototype);
            define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
                return this;
            });
            exports.AsyncIterator = AsyncIterator;

            // Note that simple async functions are implemented on top of
            // AsyncIterator objects; they just return a Promise for the value of
            // the final result produced by the iterator.
            exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
                if (PromiseImpl === void 0) PromiseImpl = Promise;

                var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);

                return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
                : iter.next().then(function (result) {
                    return result.done ? result.value : iter.next();
                });
            };

            function makeInvokeMethod(innerFn, self, context) {
                var state = GenStateSuspendedStart;

                return function invoke(method, arg) {
                    if (state === GenStateExecuting) {
                        throw new Error("Generator is already running");
                    }

                    if (state === GenStateCompleted) {
                        if (method === "throw") {
                            throw arg;
                        }

                        // Be forgiving, per GeneratorResume behavior specified since ES2015:
                        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                        return doneResult();
                    }

                    context.method = method;
                    context.arg = arg;

                    while (true) {
                        var delegate = context.delegate;
                        if (delegate) {
                            var delegateResult = maybeInvokeDelegate(delegate, context);
                            if (delegateResult) {
                                if (delegateResult === ContinueSentinel) continue;
                                return delegateResult;
                            }
                        }

                        if (context.method === "next") {
                            // Setting context._sent for legacy support of Babel's
                            // function.sent implementation.
                            context.sent = context._sent = context.arg;
                        } else if (context.method === "throw") {
                            if (state === GenStateSuspendedStart) {
                                state = GenStateCompleted;
                                throw context.arg;
                            }

                            context.dispatchException(context.arg);
                        } else if (context.method === "return") {
                            context.abrupt("return", context.arg);
                        }

                        state = GenStateExecuting;

                        var record = tryCatch(innerFn, self, context);
                        if (record.type === "normal") {
                            // If an exception is thrown from innerFn, we leave state ===
                            // GenStateExecuting and loop back for another invocation.
                            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                            if (record.arg === ContinueSentinel) {
                                continue;
                            }

                            return {
                                value: record.arg,
                                done: context.done
                            };
                        } else if (record.type === "throw") {
                            state = GenStateCompleted;
                            // Dispatch the exception by looping back around to the
                            // context.dispatchException(context.arg) call above.
                            context.method = "throw";
                            context.arg = record.arg;
                        }
                    }
                };
            }

            // Call delegate.iterator[context.method](context.arg) and handle the
            // result, either by returning a { value, done } result from the
            // delegate iterator, or by modifying context.method and context.arg,
            // setting context.delegate to null, and returning the ContinueSentinel.
            function maybeInvokeDelegate(delegate, context) {
                var methodName = context.method;
                var method = delegate.iterator[methodName];
                if (method === undefined) {
                    // A .throw or .return when the delegate iterator has no .throw
                    // method, or a missing .next method, always terminate the
                    // yield* loop.
                    context.delegate = null;

                    // Note: ["return"] must be used for ES3 parsing compatibility.
                    if (methodName === "throw" && delegate.iterator["return"]) {
                        // If the delegate iterator has a return method, give it a
                        // chance to clean up.
                        context.method = "return";
                        context.arg = undefined;
                        maybeInvokeDelegate(delegate, context);

                        if (context.method === "throw") {
                            // If maybeInvokeDelegate(context) changed context.method from
                            // "return" to "throw", let that override the TypeError below.
                            return ContinueSentinel;
                        }
                    }
                    if (methodName !== "return") {
                        context.method = "throw";
                        context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
                    }

                    return ContinueSentinel;
                }

                var record = tryCatch(method, delegate.iterator, context.arg);

                if (record.type === "throw") {
                    context.method = "throw";
                    context.arg = record.arg;
                    context.delegate = null;
                    return ContinueSentinel;
                }

                var info = record.arg;

                if (!info) {
                    context.method = "throw";
                    context.arg = new TypeError("iterator result is not an object");
                    context.delegate = null;
                    return ContinueSentinel;
                }

                if (info.done) {
                    // Assign the result of the finished delegate to the temporary
                    // variable specified by delegate.resultName (see delegateYield).
                    context[delegate.resultName] = info.value;

                    // Resume execution at the desired location (see delegateYield).
                    context.next = delegate.nextLoc;

                    // If context.method was "throw" but the delegate handled the
                    // exception, let the outer generator proceed normally. If
                    // context.method was "next", forget context.arg since it has been
                    // "consumed" by the delegate iterator. If context.method was
                    // "return", allow the original .return call to continue in the
                    // outer generator.
                    if (context.method !== "return") {
                        context.method = "next";
                        context.arg = undefined;
                    }
                } else {
                    // Re-yield the result returned by the delegate method.
                    return info;
                }

                // The delegate iterator is finished, so forget it and continue with
                // the outer generator.
                context.delegate = null;
                return ContinueSentinel;
            }

            // Define Generator.prototype.{next,throw,return} in terms of the
            // unified ._invoke helper method.
            defineIteratorMethods(Gp);

            define(Gp, toStringTagSymbol, "Generator");

            // A Generator should always return itself as the iterator object when the
            // @@iterator function is called on it. Some browsers' implementations of the
            // iterator prototype chain incorrectly implement this, causing the Generator
            // object to not be returned from this call. This ensures that doesn't happen.
            // See https://github.com/facebook/regenerator/issues/274 for more details.
            define(Gp, iteratorSymbol, function () {
                return this;
            });

            define(Gp, "toString", function () {
                return "[object Generator]";
            });

            function pushTryEntry(locs) {
                var entry = { tryLoc: locs[0] };

                if (1 in locs) {
                    entry.catchLoc = locs[1];
                }

                if (2 in locs) {
                    entry.finallyLoc = locs[2];
                    entry.afterLoc = locs[3];
                }

                this.tryEntries.push(entry);
            }

            function resetTryEntry(entry) {
                var record = entry.completion || {};
                record.type = "normal";
                delete record.arg;
                entry.completion = record;
            }

            function Context(tryLocsList) {
                // The root entry object (effectively a try statement without a catch
                // or a finally block) gives us a place to store values thrown from
                // locations where there is no enclosing try statement.
                this.tryEntries = [{ tryLoc: "root" }];
                tryLocsList.forEach(pushTryEntry, this);
                this.reset(true);
            }

            exports.keys = function (val) {
                var object = Object(val);
                var keys = [];
                for (var key in object) {
                    keys.push(key);
                }
                keys.reverse();

                // Rather than returning an object with a next method, we keep
                // things simple and return the next function itself.
                return function next() {
                    while (keys.length) {
                        var key = keys.pop();
                        if (key in object) {
                            next.value = key;
                            next.done = false;
                            return next;
                        }
                    }

                    // To avoid creating an additional object, we just hang the .value
                    // and .done properties off the next function object itself. This
                    // also ensures that the minifier will not anonymize the function.
                    next.done = true;
                    return next;
                };
            };

            function values(iterable) {
                if (iterable != null) {
                    var iteratorMethod = iterable[iteratorSymbol];
                    if (iteratorMethod) {
                        return iteratorMethod.call(iterable);
                    }

                    if (typeof iterable.next === "function") {
                        return iterable;
                    }

                    if (!isNaN(iterable.length)) {
                        var i = -1,
                            next = function next() {
                            while (++i < iterable.length) {
                                if (hasOwn.call(iterable, i)) {
                                    next.value = iterable[i];
                                    next.done = false;
                                    return next;
                                }
                            }

                            next.value = undefined;
                            next.done = true;

                            return next;
                        };

                        return next.next = next;
                    }
                }

                throw new TypeError((typeof iterable === "undefined" ? "undefined" : _typeof(iterable)) + " is not iterable");
            }
            exports.values = values;

            function doneResult() {
                return { value: undefined, done: true };
            }

            Context.prototype = {
                constructor: Context,

                reset: function reset(skipTempReset) {
                    this.prev = 0;
                    this.next = 0;
                    // Resetting context._sent for legacy support of Babel's
                    // function.sent implementation.
                    this.sent = this._sent = undefined;
                    this.done = false;
                    this.delegate = null;

                    this.method = "next";
                    this.arg = undefined;

                    this.tryEntries.forEach(resetTryEntry);

                    if (!skipTempReset) {
                        for (var name in this) {
                            // Not sure about the optimal order of these conditions:
                            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                                this[name] = undefined;
                            }
                        }
                    }
                },

                stop: function stop() {
                    this.done = true;

                    var rootEntry = this.tryEntries[0];
                    var rootRecord = rootEntry.completion;
                    if (rootRecord.type === "throw") {
                        throw rootRecord.arg;
                    }

                    return this.rval;
                },

                dispatchException: function dispatchException(exception) {
                    if (this.done) {
                        throw exception;
                    }

                    var context = this;
                    function handle(loc, caught) {
                        record.type = "throw";
                        record.arg = exception;
                        context.next = loc;

                        if (caught) {
                            // If the dispatched exception was caught by a catch block,
                            // then let that catch block handle the exception normally.
                            context.method = "next";
                            context.arg = undefined;
                        }

                        return !!caught;
                    }

                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        var record = entry.completion;

                        if (entry.tryLoc === "root") {
                            // Exception thrown outside of any try block that could handle
                            // it, so set the completion value of the entire function to
                            // throw the exception.
                            return handle("end");
                        }

                        if (entry.tryLoc <= this.prev) {
                            var hasCatch = hasOwn.call(entry, "catchLoc");
                            var hasFinally = hasOwn.call(entry, "finallyLoc");

                            if (hasCatch && hasFinally) {
                                if (this.prev < entry.catchLoc) {
                                    return handle(entry.catchLoc, true);
                                } else if (this.prev < entry.finallyLoc) {
                                    return handle(entry.finallyLoc);
                                }
                            } else if (hasCatch) {
                                if (this.prev < entry.catchLoc) {
                                    return handle(entry.catchLoc, true);
                                }
                            } else if (hasFinally) {
                                if (this.prev < entry.finallyLoc) {
                                    return handle(entry.finallyLoc);
                                }
                            } else {
                                throw new Error("try statement without catch or finally");
                            }
                        }
                    }
                },

                abrupt: function abrupt(type, arg) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                            var finallyEntry = entry;
                            break;
                        }
                    }

                    if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                        // Ignore the finally entry if control is not jumping to a
                        // location outside the try/catch block.
                        finallyEntry = null;
                    }

                    var record = finallyEntry ? finallyEntry.completion : {};
                    record.type = type;
                    record.arg = arg;

                    if (finallyEntry) {
                        this.method = "next";
                        this.next = finallyEntry.finallyLoc;
                        return ContinueSentinel;
                    }

                    return this.complete(record);
                },

                complete: function complete(record, afterLoc) {
                    if (record.type === "throw") {
                        throw record.arg;
                    }

                    if (record.type === "break" || record.type === "continue") {
                        this.next = record.arg;
                    } else if (record.type === "return") {
                        this.rval = this.arg = record.arg;
                        this.method = "return";
                        this.next = "end";
                    } else if (record.type === "normal" && afterLoc) {
                        this.next = afterLoc;
                    }

                    return ContinueSentinel;
                },

                finish: function finish(finallyLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        if (entry.finallyLoc === finallyLoc) {
                            this.complete(entry.completion, entry.afterLoc);
                            resetTryEntry(entry);
                            return ContinueSentinel;
                        }
                    }
                },

                "catch": function _catch(tryLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        if (entry.tryLoc === tryLoc) {
                            var record = entry.completion;
                            if (record.type === "throw") {
                                var thrown = record.arg;
                                resetTryEntry(entry);
                            }
                            return thrown;
                        }
                    }

                    // The context.catch method must only be called with a location
                    // argument that corresponds to a known catch block.
                    throw new Error("illegal catch attempt");
                },

                delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                    this.delegate = {
                        iterator: values(iterable),
                        resultName: resultName,
                        nextLoc: nextLoc
                    };

                    if (this.method === "next") {
                        // Deliberately forget the last sent value so that we don't
                        // accidentally pass it on to the delegate.
                        this.arg = undefined;
                    }

                    return ContinueSentinel;
                }
            };

            // Regardless of whether this script is executing as a CommonJS module
            // or not, return the runtime object so that we can declare the variable
            // regeneratorRuntime in the outer scope, which allows this module to be
            // injected easily by `bin/regenerator --include-runtime script.js`.
            return exports;
        }(
        // If this script is executing as a CommonJS module, use module.exports
        // as the regeneratorRuntime namespace. Otherwise create a new empty
        // object. Either way, the resulting object will be used to initialize
        // the regeneratorRuntime variable at the top of this file.
        (typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" ? module.exports : {});

        try {
            regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
            // This module should not be running in strict mode, so the above
            // assignment should always work unless something is misconfigured. Just
            // in case runtime.js accidentally runs in strict mode, in modern engines
            // we can explicitly access globalThis. In older engines we can escape
            // strict mode using a global Function call. This could conceivably fail
            // if a Content Security Policy forbids using Function, but in that case
            // the proper solution is to fix the accidental strict mode problem. If
            // you've misconfigured your bundler to force strict mode and applied a
            // CSP to forbid Function, and you're not willing to fix either of those
            // problems, please detail your unique predicament in a GitHub issue.
            if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
                globalThis.regeneratorRuntime = runtime;
            } else {
                Function("r", "regeneratorRuntime = r")(runtime);
            }
        }
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AVIA_SEARCH_VALUES = 'aviaSearchValues';
        var AVIA_SEARCH_LABELS = 'aviaSearchLabels';

        var AviaRestoreFormParams = function () {
            function AviaRestoreFormParams(params) {
                _classCallCheck(this, AviaRestoreFormParams);

                this.defaultValues = params.values;
                this.defaultLabels = params.labels;
                this.isPreviewMode = Boolean(params.isPreviewMode);
            }

            _createClass(AviaRestoreFormParams, [{
                key: "save",
                value: function save(values, labels) {
                    this._saveStore(labels, AVIA_SEARCH_LABELS);
                    this._saveStore(values, AVIA_SEARCH_VALUES);
                }
            }, {
                key: "_saveStore",
                value: function _saveStore(values, type) {
                    if ((typeof values === "undefined" ? "undefined" : _typeof(values)) === 'object' && values !== null) {
                        try {
                            localStorage.setItem(type, JSON.stringify(values));
                        } catch (e) {
                            console.warn("\u26A0\uFE0F \u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C " + type + ":", e);
                        }
                    } else {
                        console.warn("\u26A0\uFE0F " + values + " \u043D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u043C. \u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u043E.");
                    }
                }
            }, {
                key: "restore",
                value: function restore(directionList, defaultValues, defaultLabels) {
                    var restoredValues = Object.assign({}, defaultValues);
                    var restoredLabels = Object.assign({}, defaultLabels);

                    if (!this.isPreviewMode) {
                        return {
                            values: restoredValues,
                            labels: restoredLabels
                        };
                    }

                    var storeValues = {};
                    var storeLabels = {};

                    try {
                        storeValues = JSON.parse(localStorage.getItem(AVIA_SEARCH_VALUES)) || {};
                        storeLabels = JSON.parse(localStorage.getItem(AVIA_SEARCH_LABELS)) || {};
                    } catch (e) {
                        console.warn('⚠️ Ошибка при чтении из localStorage', e);
                    }

                    var waypoints = this.resolveStoredWaypoints(storeValues, storeLabels);

                    if (waypoints.from) {
                        restoredValues.departure = waypoints.from;

                        if (waypoints.to) {
                            restoredValues.destination = waypoints.to;
                        }

                        if (storeValues.flyType) {
                            restoredValues.flyType = storeValues.flyType;
                        }

                        if (storeValues.departureType) {
                            restoredValues.departureType = this.waypointType(storeValues.departureType);
                        }

                        if (storeValues.destinationType) {
                            restoredValues.destinationType = this.waypointType(storeValues.destinationType);
                        }

                        restoredLabels.departure = this.resolveWaypointLabel(storeLabels && storeLabels.departure ? storeLabels.departure : null, storeValues && storeValues.departure ? storeValues.departure : null, defaultLabels.departure);

                        restoredLabels.destination = this.resolveWaypointLabel(storeLabels && storeLabels.destination ? storeLabels.destination : null, storeValues && storeValues.destination ? storeValues.destination : null, defaultLabels.destination);
                    }

                    // Восстановим туристов, если есть
                    if (storeValues && storeValues.adults) {
                        restoredValues.adults = storeValues.adults;
                        restoredLabels.tourists = storeLabels && storeLabels.tourists ? storeLabels.tourists : defaultLabels.tourists;

                        if (storeValues.children) {
                            restoredValues.children = storeValues.children;
                        }

                        if (Array.isArray(storeValues.childAges) && storeValues.childAges.length > 0) {
                            restoredValues.childAges = storeValues.childAges;
                        }
                    }

                    var today = new Date();
                    today.setHours(0, 0, 0, 0);
                    var storedDepartureDate = new Date(storeValues.dateFrom + 'T00:00:00');

                    if (storedDepartureDate >= today) {
                        restoredValues.dateFrom = storeValues.dateFrom;
                        restoredValues.dateTo = storeValues.dateTo || null;
                        restoredLabels.dates = storeLabels.dates || defaultLabels.dates;
                    }

                    var event = new CustomEvent('_change-avia-departure', {
                        detail: {
                            label: restoredLabels.departure,
                            value: restoredValues.departure,
                            waypointType: restoredValues.departureType,
                            skipDateReset: Boolean(restoredValues.dateFrom)
                        }
                    });
                    document.body.dispatchEvent(event);

                    return {
                        values: restoredValues,
                        labels: restoredLabels
                    };
                }
            }, {
                key: "waypointType",
                value: function waypointType(type) {
                    return type === 'airport' ? 'airport' : 'city';
                }
            }, {
                key: "resolveStoredWaypoints",
                value: function resolveStoredWaypoints(storeValues, storeLabels) {
                    return {
                        from: this.extractIataCode(storeLabels && storeLabels.departure) || this.extractIataCode(storeValues && storeValues.departure),
                        to: this.extractIataCode(storeLabels && storeLabels.destination) || this.extractIataCode(storeValues && storeValues.destination)
                    };
                }
            }, {
                key: "resolveWaypointLabel",
                value: function resolveWaypointLabel(label, value, fallback) {
                    if (label) {
                        return label;
                    }

                    return this.extractIataCode(value) && !this.isIataCode(value) ? value : fallback;
                }
            }, {
                key: "extractIataCode",
                value: function extractIataCode(value) {
                    if (typeof value !== 'string') {
                        return null;
                    }

                    var trimmed = value.trim();
                    if (this.isIataCode(trimmed)) {
                        return trimmed.toUpperCase();
                    }

                    var matchedCode = trimmed.match(/\(([A-Z0-9]{3})\)\s*$/i);
                    return matchedCode ? matchedCode[1].toUpperCase() : null;
                }
            }, {
                key: "isIataCode",
                value: function isIataCode(value) {
                    return typeof value === 'string' && /^[A-Z0-9]{3}$/i.test(value.trim());
                }
            }]);

            return AviaRestoreFormParams;
        }();

        window.AviaRestoreFormParams = AviaRestoreFormParams;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaDirectionsRequest = function () {
            function AviaDirectionsRequest() {
                _classCallCheck(this, AviaDirectionsRequest);

                this.directionsData = null;
                this.directionsSearchResultData = null;

                this._loadedDirections = null;
                this._loadedDirectionsSearchResult = null;
            }

            _createClass(AviaDirectionsRequest, [{
                key: "getDirections",
                value: function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        if (!this._loadedDirections) {
                                            this._loadedDirections = this.loadDirections();
                                        }
                                        _context.next = 3;
                                        return this._loadedDirections;

                                    case 3:
                                        return _context.abrupt("return", this.directionsData && this.directionsData.directions ? this.directionsData.directions : []);

                                    case 4:
                                    case "end":
                                        return _context.stop();
                                }
                            }
                        }, _callee, this);
                    }));

                    function getDirections() {
                        return _ref.apply(this, arguments);
                    }

                    return getDirections;
                }()
            }, {
                key: "getDestinations",
                value: function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                                switch (_context2.prev = _context2.next) {
                                    case 0:
                                        if (!this._loadedDirections) {
                                            this._loadedDirections = this.loadDirections();
                                        }
                                        _context2.next = 3;
                                        return this._loadedDirections;

                                    case 3:
                                        return _context2.abrupt("return", this.directionsData && this.directionsData.destinations ? this.directionsData.destinations : []);

                                    case 4:
                                    case "end":
                                        return _context2.stop();
                                }
                            }
                        }, _callee2, this);
                    }));

                    function getDestinations() {
                        return _ref2.apply(this, arguments);
                    }

                    return getDestinations;
                }()
            }, {
                key: "getDepartures",
                value: function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                        return regeneratorRuntime.wrap(function _callee3$(_context3) {
                            while (1) {
                                switch (_context3.prev = _context3.next) {
                                    case 0:
                                        if (!this._loadedDirections) {
                                            this._loadedDirections = this.loadDirections();
                                        }
                                        _context3.next = 3;
                                        return this._loadedDirections;

                                    case 3:
                                        return _context3.abrupt("return", this.directionsData && this.directionsData.departures ? this.directionsData.departures : []);

                                    case 4:
                                    case "end":
                                        return _context3.stop();
                                }
                            }
                        }, _callee3, this);
                    }));

                    function getDepartures() {
                        return _ref3.apply(this, arguments);
                    }

                    return getDepartures;
                }()
            }, {
                key: "loadDirections",
                value: function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                        var isPreviewMode, response, data;
                        return regeneratorRuntime.wrap(function _callee4$(_context4) {
                            while (1) {
                                switch (_context4.prev = _context4.next) {
                                    case 0:
                                        _context4.prev = 0;
                                        isPreviewMode = Boolean(window.app && window.app.isPreview);
                                        response = null;

                                        if (!isPreviewMode) {
                                            _context4.next = 9;
                                            break;
                                        }

                                        _context4.next = 6;
                                        return fetch('https://dev-api.ht.kz/flights-search/web/search/directions', {
                                            method: 'GET',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Accept': 'application/json'
                                            }
                                        });

                                    case 6:
                                        response = _context4.sent;
                                        _context4.next = 12;
                                        break;

                                    case 9:
                                        _context4.next = 11;
                                        return fetch('/new/charter-flight/directions', {
                                            method: 'POST',
                                            headers: { 'X-Requested-With': 'XMLHttpRequest' }
                                        });

                                    case 11:
                                        response = _context4.sent;

                                    case 12:
                                        if (response.ok) {
                                            _context4.next = 14;
                                            break;
                                        }

                                        throw new Error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0442\u0438 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0439: " + response.status);

                                    case 14:
                                        _context4.next = 16;
                                        return response.json();

                                    case 16:
                                        data = _context4.sent;

                                        this.directionsData = data || {};
                                        return _context4.abrupt("return", data);

                                    case 21:
                                        _context4.prev = 21;
                                        _context4.t0 = _context4["catch"](0);

                                        console.error('🚨 Не удалось загрузить направления:', _context4.t0);
                                        this.directionsData = { departures: [], destinations: [], directions: [] };
                                        return _context4.abrupt("return", this.directionsData);

                                    case 26:
                                    case "end":
                                        return _context4.stop();
                                }
                            }
                        }, _callee4, this, [[0, 21]]);
                    }));

                    function loadDirections() {
                        return _ref4.apply(this, arguments);
                    }

                    return loadDirections;
                }()
            }, {
                key: "getDirectionsSearchResult",
                value: function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(params) {
                        return regeneratorRuntime.wrap(function _callee5$(_context5) {
                            while (1) {
                                switch (_context5.prev = _context5.next) {
                                    case 0:
                                        // если ранее уже был запрос с такими же параметрами, можно не перезапрашивать
                                        if (!this._loadedDirectionsSearchResult) {
                                            this._loadedDirectionsSearchResult = this.loadDirectionsSearchResult(params);
                                        }

                                        _context5.next = 3;
                                        return this._loadedDirectionsSearchResult;

                                    case 3:
                                        return _context5.abrupt("return", this.directionsSearchResultData || {});

                                    case 4:
                                    case "end":
                                        return _context5.stop();
                                }
                            }
                        }, _callee5, this);
                    }));

                    function getDirectionsSearchResult(_x) {
                        return _ref5.apply(this, arguments);
                    }

                    return getDirectionsSearchResult;
                }()
            }, {
                key: "loadDirectionsSearchResult",
                value: function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        var isPreviewMode, formData, key, response, searchParams, _key, result;

                        return regeneratorRuntime.wrap(function _callee6$(_context6) {
                            while (1) {
                                switch (_context6.prev = _context6.next) {
                                    case 0:
                                        _context6.prev = 0;
                                        isPreviewMode = Boolean(window.app && window.app.isPreview);
                                        formData = new FormData();


                                        for (key in params) {
                                            if (Object.prototype.hasOwnProperty.call(params, key)) {
                                                formData.append("AviaFindForm[" + key + "]", params[key]);
                                            }
                                        }

                                        response = null;

                                        if (!isPreviewMode) {
                                            _context6.next = 13;
                                            break;
                                        }

                                        searchParams = [];


                                        for (_key in params) {
                                            if (Object.prototype.hasOwnProperty.call(params, _key)) {
                                                searchParams.push(encodeURIComponent(_key) + "=" + encodeURIComponent(params[_key]));
                                            }
                                        }

                                        _context6.next = 10;
                                        return fetch("https://dev-api.ht.kz/flights-search/web/search/waypoints?" + searchParams.join('&'), {
                                            method: 'GET',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Accept': 'application/json'
                                            }
                                        });

                                    case 10:
                                        response = _context6.sent;
                                        _context6.next = 16;
                                        break;

                                    case 13:
                                        _context6.next = 15;
                                        return fetch('/new/charter-flight/directions-search', {
                                            method: 'POST',
                                            headers: { 'X-Requested-With': 'XMLHttpRequest' },
                                            body: formData
                                        });

                                    case 15:
                                        response = _context6.sent;

                                    case 16:
                                        if (response.ok) {
                                            _context6.next = 18;
                                            break;
                                        }

                                        throw new Error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0442\u0438 \u043F\u0440\u0438 \u043F\u043E\u0438\u0441\u043A\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0439: " + response.status);

                                    case 18:
                                        _context6.next = 20;
                                        return response.json();

                                    case 20:
                                        result = _context6.sent;

                                        this.directionsSearchResultData = result || {};
                                        return _context6.abrupt("return", result);

                                    case 25:
                                        _context6.prev = 25;
                                        _context6.t0 = _context6["catch"](0);

                                        console.error('🚨 Не удалось загрузить результаты поиска направлений:', _context6.t0);
                                        this.directionsSearchResultData = { results: [] };
                                        return _context6.abrupt("return", this.directionsSearchResultData);

                                    case 30:
                                    case "end":
                                        return _context6.stop();
                                }
                            }
                        }, _callee6, this, [[0, 25]]);
                    }));

                    function loadDirectionsSearchResult() {
                        return _ref6.apply(this, arguments);
                    }

                    return loadDirectionsSearchResult;
                }()
            }]);

            return AviaDirectionsRequest;
        }();

        window.AviaDirectionsRequest = AviaDirectionsRequest;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var FindAviaRequestService = window.AviaDirectionsRequest;

        var AviaDirectionSearch = function () {
            function AviaDirectionSearch(params) {
                _classCallCheck(this, AviaDirectionSearch);

                this.translations = params.translations;
                this.elements = {
                    searchWrapper: document.querySelector('.avia-search-direction'),
                    currentSheet: null
                };

                this.directionsSearchResult = null;
                this.aviaRequestService = null;

                this.init();
            }

            _createClass(AviaDirectionSearch, [{
                key: "init",
                value: function init() {
                    this.aviaRequestService = new FindAviaRequestService();
                    this.bindHandlers();
                }
            }, {
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this = this;

                    var debouncedSearch = this.debounce(this.request.bind(this), 300);

                    document.body.addEventListener('input', function (e) {
                        if (e.target.closest('.direction-sheet .search-input')) {
                            debouncedSearch(e);
                        }
                    });

                    document.body.addEventListener('click', function (e) {
                        var clearBtn = e.target.closest('.direction-sheet .clear-search-input');
                        if (clearBtn) {
                            document.querySelectorAll('.clear-search-input').forEach(function (el) {
                                return el.classList.add('hidden');
                            });

                            if (_this.elements.currentSheet) {
                                var input = _this.elements.currentSheet.querySelector('.search-input');
                                if (input) input.value = '';
                            }

                            _this.toggleDefaultDirections();
                            _this.hideSearchResult();
                        }
                    });

                    document.body.addEventListener('_close-direction-modal', function () {
                        _this.hideSearchResult();
                        _this.toggleDefaultDirections();

                        document.querySelectorAll('.direction-sheet .clear-search-input').forEach(function (btn) {
                            return btn.click();
                        });
                    });
                }
            }, {
                key: "renderResults",
                value: function renderResults(type) {
                    if (type === 'departure') this.renderDepartureResults();else this.renderDestinationResults();
                }
            }, {
                key: "request",
                value: function () {
                    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(e) {
                        var input, query, clearInput, type, params, hiddenDepart, result, results;
                        return regeneratorRuntime.wrap(function _callee7$(_context7) {
                            while (1) {
                                switch (_context7.prev = _context7.next) {
                                    case 0:
                                        input = e.target;

                                        this.elements.currentSheet = input.closest('.direction-sheet');

                                        if (this.elements.currentSheet) {
                                            _context7.next = 4;
                                            break;
                                        }

                                        return _context7.abrupt("return");

                                    case 4:
                                        query = input.value.trim();
                                        clearInput = this.elements.currentSheet.querySelector('.clear-search-input');
                                        type = input.dataset.type;


                                        if (clearInput) clearInput.classList.toggle('hidden', query.length <= 1);

                                        if (!(query.length < 3)) {
                                            _context7.next = 13;
                                            break;
                                        }

                                        this.directionsSearchResult = [];
                                        this.hideSearchResult();
                                        this.toggleDefaultDirections();
                                        return _context7.abrupt("return");

                                    case 13:
                                        params = { where: query };


                                        if (type !== 'departure') {
                                            hiddenDepart = document.querySelector('#aviaHiddenDepart');

                                            if (hiddenDepart && hiddenDepart.value) params.from = hiddenDepart.value;
                                        }

                                        _context7.prev = 15;
                                        _context7.next = 18;
                                        return this.aviaRequestService.loadDirectionsSearchResult(params);

                                    case 18:
                                        result = _context7.sent;

                                        this.hideSearchResult();
                                        this.toggleDefaultDirections();

                                        results = this.searchResults(result);


                                        if (results.length > 0) {
                                            this.directionsSearchResult = results;
                                            this.renderResults(type);
                                            this.toggleDefaultDirections(true);
                                        } else {
                                            this.renderEmptyResult();
                                            this.toggleDefaultDirections(true);
                                        }
                                        _context7.next = 30;
                                        break;

                                    case 25:
                                        _context7.prev = 25;
                                        _context7.t0 = _context7["catch"](15);

                                        console.error('Ошибка при поиске направлений:', _context7.t0);
                                        this.renderEmptyResult();
                                        this.toggleDefaultDirections(true);

                                    case 30:
                                    case "end":
                                        return _context7.stop();
                                }
                            }
                        }, _callee7, this, [[15, 25]]);
                    }));

                    function request(_x3) {
                        return _ref7.apply(this, arguments);
                    }

                    return request;
                }()
            }, {
                key: "debounce",
                value: function debounce(fn) {
                    var _this2 = this;

                    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

                    var timer = void 0;
                    return function () {
                        for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
                            args[_key2] = arguments[_key2];
                        }

                        clearTimeout(timer);
                        timer = setTimeout(function () {
                            return fn.apply(_this2, args);
                        }, delay);
                    };
                }
            }, {
                key: "renderDepartureResults",
                value: function renderDepartureResults() {
                    var _this3 = this;

                    if (!this.directionsSearchResult || !this.directionsSearchResult.length) return;

                    var container = document.createElement('div');
                    container.className = 'avia-form-container avia-direction-group avia-direction-search-group';

                    var list = document.createElement('div');
                    list.className = 'group-list';

                    this.directionsSearchResult.forEach(function (direction) {
                        list.appendChild(_this3.renderDepartureSearchItem(direction));
                    });

                    container.appendChild(list);

                    var departureEl = this.elements.currentSheet ? this.elements.currentSheet.querySelector('[data-type="departure"]') : null;
                    if (departureEl) {
                        var wrapper = departureEl.closest('.avia-search-direction');
                        if (wrapper) wrapper.insertAdjacentElement('afterend', container);
                    }
                }
            }, {
                key: "renderDestinationResults",
                value: function renderDestinationResults() {
                    var _this4 = this;

                    if (!this.directionsSearchResult || !this.directionsSearchResult.length) return;

                    var container = document.createElement('div');
                    container.className = 'avia-form-container avia-direction-group avia-direction-search-group';

                    var list = document.createElement('div');
                    list.className = 'group-list';

                    this.directionsSearchResult.forEach(function (direction) {
                        list.appendChild(_this4.renderDestinationSearchItem(direction));
                    });

                    container.appendChild(list);

                    var destinationEl = this.elements.currentSheet ? this.elements.currentSheet.querySelector('[data-type="destination"]') : null;
                    if (destinationEl) {
                        var wrapper = destinationEl.closest('.avia-search-direction');
                        if (wrapper) wrapper.insertAdjacentElement('afterend', container);
                    }
                }
            }, {
                key: "renderEmptyResult",
                value: function renderEmptyResult() {
                    if (!this.elements.currentSheet) return;

                    var old = this.elements.currentSheet.querySelector('.avia-direction-empty-search');
                    if (old) old.remove();

                    var container = document.createElement('div');
                    container.className = 'avia-form-container avia-direction-empty-search';
                    container.innerHTML = "\n            <div class=\"empty-title\">" + this.translations.notFoundAirport + "</div>\n            <div class=\"empty-subtitle\">" + this.translations.isCorrectAirportName + "</div>\n            <button type=\"button\" class=\"clear-search-input\">" + this.translations.clearInput + "</button>\n        ";

                    var target = this.elements.currentSheet.querySelector('.avia-search-direction');
                    if (target) target.insertAdjacentElement('afterend', container);
                }
            }, {
                key: "toggleDefaultDirections",
                value: function toggleDefaultDirections() {
                    var isHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    if (!this.elements.currentSheet) return;

                    this.elements.currentSheet.querySelectorAll('.avia-direction-group-default, .search-destinations-hint').forEach(function (element) {
                        if (isHide) element.classList.add('hide');else element.classList.remove('hide');
                    });
                }
            }, {
                key: "hideSearchResult",
                value: function hideSearchResult() {
                    if (!this.elements.currentSheet) return;
                    this.elements.currentSheet.querySelectorAll('.avia-direction-search-group, .avia-direction-empty-search').forEach(function (el) {
                        return el.remove();
                    });
                }
            }, {
                key: "minPrice",
                value: function minPrice(direction) {
                    return typeof direction.price === 'number' ? "<span class=\"price\">\u043E\u0442 " + direction.price.toLocaleString('ru-RU') + " \u20B8</span>" : '';
                }
            }, {
                key: "renderDepartureSearchItem",
                value: function renderDepartureSearchItem(direction) {
                    var _this5 = this;

                    if (direction.type === 'airport' && !this.airports(direction).length) {
                        return this.renderSingleDepartureAirportItem(direction);
                    }

                    var wrapper = document.createElement('div');
                    wrapper.className = 'search-waypoint-group';

                    var cityItem = document.createElement('div');
                    cityItem.className = 'list-item';

                    var cityName = this.cityName(direction);
                    var countryName = this.countryName(direction);
                    var cityCode = this.cityCode(direction);

                    cityItem.dataset.label = cityName + " (" + cityCode + ")";
                    cityItem.dataset.value = cityCode;
                    cityItem.dataset.waypointType = 'city';
                    cityItem.innerHTML = "\n            <div>\n                <span class=\"item-title\">" + cityName + "</span>\n                <span class=\"item-subtitle\">" + cityName + (countryName ? " (" + countryName + ")" : '') + "</span>\n            </div>\n            <span class=\"airport-code\">" + cityCode + "</span>\n        ";

                    wrapper.appendChild(cityItem);

                    var airports = this.airports(direction);
                    if (airports.length) {
                        var airportsList = document.createElement('div');
                        airportsList.className = 'group-list group-list--nested';

                        airports.forEach(function (airport) {
                            var airportItem = document.createElement('div');
                            airportItem.className = 'list-item list-item--nested';
                            airportItem.dataset.label = _this5.airportName(airport) + " (" + (airport.code || cityCode) + ")";
                            airportItem.dataset.value = airport.code || cityCode;
                            airportItem.dataset.waypointType = 'airport';
                            airportItem.innerHTML = "\n                    <div>\n                        <span class=\"item-title\">" + _this5.airportName(airport) + "</span>\n                        <span class=\"item-subtitle\">" + cityName + (countryName ? " (" + countryName + ")" : '') + "</span>\n                    </div>\n                    <span class=\"airport-code\">" + (airport.code || cityCode) + "</span>\n                ";
                            airportsList.appendChild(airportItem);
                        });

                        wrapper.appendChild(airportsList);
                    }

                    return wrapper;
                }
            }, {
                key: "renderDestinationSearchItem",
                value: function renderDestinationSearchItem(direction) {
                    var _this6 = this;

                    if (direction.type === 'airport' && !this.airports(direction).length) {
                        return this.renderSingleDestinationAirportItem(direction);
                    }

                    var wrapper = document.createElement('div');
                    wrapper.className = 'search-waypoint-group';

                    var cityItem = document.createElement('div');
                    cityItem.className = 'list-item';

                    var cityName = this.cityName(direction);
                    var countryName = this.countryName(direction);
                    var cityCode = this.cityCode(direction);
                    var cityFlyType = this.flyType(direction.availability);

                    cityItem.dataset.label = cityName + " (" + cityCode + ")";
                    cityItem.dataset.value = cityCode;
                    cityItem.dataset.type = cityFlyType;
                    cityItem.dataset.flyType = cityFlyType;
                    cityItem.dataset.waypointType = 'city';

                    var cityTicketCount = typeof direction.qty === 'number' ? "<span class=\"count\">" + direction.qty + " " + this.getTicketWord(direction.qty) + "</span>" : '';

                    cityItem.innerHTML = "\n            <div>\n                <span class=\"item-title\">" + cityName + "</span>\n                <span class=\"item-subtitle\">" + this.availabilitySubtitle(direction.availability, "" + cityName + (countryName ? " (" + countryName + ")" : '')) + "</span>\n            </div>\n            <div class=\"tickets-info\">\n                " + cityTicketCount + "\n                " + this.minPrice(direction) + "\n            </div>\n        ";

                    wrapper.appendChild(cityItem);

                    var airports = this.airports(direction);
                    if (airports.length) {
                        var airportsList = document.createElement('div');
                        airportsList.className = 'group-list group-list--nested';

                        airports.forEach(function (airport) {
                            var airportFlyType = _this6.flyType(airport.availability || direction.availability);
                            var airportTicketCount = typeof airport.qty === 'number' ? "<span class=\"count\">" + airport.qty + " " + _this6.getTicketWord(airport.qty) + "</span>" : '';
                            var airportDirection = Object.assign({}, direction, airport, {
                                price: typeof airport.price === 'number' ? airport.price : direction.price
                            });

                            var airportItem = document.createElement('div');
                            airportItem.className = 'list-item list-item--nested';
                            airportItem.dataset.label = _this6.airportName(airport) + " (" + (airport.code || cityCode) + ")";
                            airportItem.dataset.value = airport.code || cityCode;
                            airportItem.dataset.type = airportFlyType;
                            airportItem.dataset.flyType = airportFlyType;
                            airportItem.dataset.waypointType = 'airport';
                            airportItem.innerHTML = "\n                    <div>\n                        <span class=\"item-title\">" + _this6.airportName(airport) + "</span>\n                        <span class=\"item-subtitle\">" + _this6.availabilitySubtitle(airport.availability || direction.availability, "" + cityName + (countryName ? " (" + countryName + ")" : '')) + "</span>\n                    </div>\n                    <div class=\"tickets-info\">\n                        " + airportTicketCount + "\n                        " + _this6.minPrice(airportDirection) + "\n                    </div>\n                ";
                            airportsList.appendChild(airportItem);
                        });

                        wrapper.appendChild(airportsList);
                    }

                    return wrapper;
                }
            }, {
                key: "renderSingleDepartureAirportItem",
                value: function renderSingleDepartureAirportItem(direction) {
                    var item = document.createElement('div');
                    item.className = 'list-item';

                    var cityName = this.cityName(direction);
                    var countryName = this.countryName(direction);
                    var airportCode = direction.code || this.cityCode(direction);

                    item.dataset.label = this.airportName(direction) + " (" + airportCode + ")";
                    item.dataset.value = airportCode;
                    item.dataset.waypointType = 'airport';
                    item.innerHTML = "\n            <div>\n                <span class=\"item-title\">" + this.airportName(direction) + "</span>\n                <span class=\"item-subtitle\">" + cityName + (countryName ? " (" + countryName + ")" : '') + "</span>\n            </div>\n            <span class=\"airport-code\">" + airportCode + "</span>\n        ";

                    return item;
                }
            }, {
                key: "renderSingleDestinationAirportItem",
                value: function renderSingleDestinationAirportItem(direction) {
                    var item = document.createElement('div');
                    item.className = 'list-item';

                    var cityName = this.cityName(direction);
                    var countryName = this.countryName(direction);
                    var airportCode = direction.code || this.cityCode(direction);
                    var airportFlyType = this.flyType(direction.availability);
                    var airportTicketCount = typeof direction.qty === 'number' ? "<span class=\"count\">" + direction.qty + " " + this.getTicketWord(direction.qty) + "</span>" : '';

                    item.dataset.label = this.airportName(direction) + " (" + airportCode + ")";
                    item.dataset.value = airportCode;
                    item.dataset.type = airportFlyType;
                    item.dataset.flyType = airportFlyType;
                    item.dataset.waypointType = 'airport';
                    item.innerHTML = "\n            <div>\n                <span class=\"item-title\">" + this.airportName(direction) + "</span>\n                <span class=\"item-subtitle\">" + this.availabilitySubtitle(direction.availability, "" + cityName + (countryName ? " (" + countryName + ")" : '')) + "</span>\n            </div>\n            <div class=\"tickets-info\">\n                " + airportTicketCount + "\n                " + this.minPrice(direction) + "\n            </div>\n        ";

                    return item;
                }
            }, {
                key: "searchResults",
                value: function searchResults(result) {
                    if (result && Array.isArray(result.results)) return result.results;
                    if (result && result.data && Array.isArray(result.data.results)) return result.data.results;
                    if (Array.isArray(result)) return result;
                    return [];
                }
            }, {
                key: "cityName",
                value: function cityName(direction) {
                    return direction.cityName || direction.name || '';
                }
            }, {
                key: "cityCode",
                value: function cityCode(direction) {
                    return direction.cityCode || direction.code || '';
                }
            }, {
                key: "airportName",
                value: function airportName(direction) {
                    return direction.airportName || this.cityName(direction);
                }
            }, {
                key: "airports",
                value: function airports(direction) {
                    return Array.isArray(direction.airports) ? direction.airports : [];
                }
            }, {
                key: "countryName",
                value: function countryName(direction) {
                    return direction.country && direction.country.name ? direction.country.name : '';
                }
            }, {
                key: "flyType",
                value: function flyType(availability) {
                    if (Array.isArray(availability)) {
                        if (availability.length === 1) return availability[0];
                        if (availability.length > 1) return 'any';
                        return '';
                    }

                    return availability || '';
                }
            }, {
                key: "waypointType",
                value: function waypointType(type) {
                    return type === 'airport' ? 'airport' : 'city';
                }
            }, {
                key: "availabilitySubtitle",
                value: function availabilitySubtitle(availability, fallback) {
                    var flyType = this.flyType(availability);
                    if (flyType === 'ow') return this.translations.alertOneWay;
                    if (flyType === 'rt') return this.translations.alertRoundTrip;
                    return fallback;
                }
            }, {
                key: "getTicketWord",
                value: function getTicketWord(qty) {
                    var parts = this.translations.countTickets ? this.translations.countTickets.split(',').map(function (s) {
                        return s.trim();
                    }) : ['', '', ''];

                    var _parts = _slicedToArray(parts, 3),
                        ticketOne = _parts[0],
                        ticketFew = _parts[1],
                        ticketMany = _parts[2];

                    return window.brxUtils.getnoun(qty, ticketOne, ticketFew, ticketMany);
                }
            }]);

            return AviaDirectionSearch;
        }();

        window.AviaDirectionSearch = AviaDirectionSearch;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaDepartureSheet = function () {
            function AviaDepartureSheet(props) {
                _classCallCheck(this, AviaDepartureSheet);

                this.translations = props.translations;
                this.modal = window.modal;
                this.sheet = document.querySelector('#aviaDepartCitiesSheet');

                this.bindHandlers();
            }

            _createClass(AviaDepartureSheet, [{
                key: "openModal",
                value: function openModal() {
                    var self = this;
                    this.modal.open({
                        header: {
                            title: this.translations.departCity
                        },
                        content: {
                            htmlDetachSelectorId: 'aviaDepartCitiesSheet'
                        },
                        parentCssClass: 'search-avia-form-modal',
                        footer: false,
                        type: 'bottom',
                        onBeforeClose: function onBeforeClose() {
                            var event = new CustomEvent('_close-direction-modal');
                            document.body.dispatchEvent(event);
                        }
                    });
                }
            }, {
                key: "onChange",
                value: function onChange(label, value, waypointType) {
                    var event = new CustomEvent('_change-avia-departure', {
                        detail: {
                            label: label,
                            value: value,
                            waypointType: waypointType,
                            preserveScroll: true
                        }
                    });
                    document.body.dispatchEvent(event);

                    if (this.modal && typeof this.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }, {
                key: "open",
                value: function open() {
                    this.openModal();
                    this.showLoader();
                }
            }, {
                key: "showLoader",
                value: function showLoader() {
                    if (!this.sheet) return;
                    var groupsContainer = this.sheet.querySelector('.avia-direction-groups');
                    if (groupsContainer) {
                        groupsContainer.innerHTML = '<div class="avia-loader">' + '<div class="spinner"></div>' + '<div class="loader-text">' + this.translations.loadData + '</div>' + '</div>';
                    }
                }
            }, {
                key: "renderContent",
                value: function renderContent(departures) {
                    if (!this.sheet) return;
                    var groupsContainer = this.sheet.querySelector('.avia-direction-groups');
                    if (!groupsContainer) return;
                    groupsContainer.innerHTML = '';

                    var typeTitles = {
                        charter: this.translations.charters,
                        regular: this.translations.regular
                    };

                    for (var type in departures) {
                        var items = departures[type];
                        if (!items || !items.length) continue;
                        groupsContainer.appendChild(this.renderDepartureGroup(items, typeTitles, type));
                    }
                }
            }, {
                key: "renderDepartureGroup",
                value: function renderDepartureGroup(departures, typeTitles, type) {
                    var group = document.createElement('div');
                    group.className = 'avia-form-container avia-direction-group avia-direction-group-default';

                    var title = document.createElement('div');
                    title.className = 'group-title';
                    title.textContent = typeTitles[type] || this.translations.trips;
                    group.appendChild(title);

                    var list = document.createElement('div');
                    list.className = 'group-list';

                    for (var i = 0; i < departures.length; i++) {
                        list.appendChild(this.renderDepartureItem(departures[i]));
                    }

                    group.appendChild(list);
                    return group;
                }
            }, {
                key: "renderDepartureItem",
                value: function renderDepartureItem(departure) {
                    var item = document.createElement('div');
                    item.className = 'list-item';
                    item.dataset.label = departure.name + ' (' + departure.code + ')';
                    item.dataset.value = departure.code;
                    item.dataset.waypointType = 'city';

                    var title = '<span class="item-title">' + departure.name + '</span>';
                    var subtitle = '<span class="item-subtitle">' + departure.country.name + '</span>';
                    var code = '<span class="airport-code">' + departure.code + '</span>';

                    item.innerHTML = '<div>' + title + subtitle + '</div>' + code;
                    return item;
                }
            }, {
                key: "bindHandlers",
                value: function bindHandlers() {
                    var self = this;
                    if (!this.sheet) return;

                    this.sheet.addEventListener('click', function (e) {
                        var item = e.target.closest('.list-item');
                        if (!item || !self.sheet.contains(item)) return;
                        self.onChange(item.dataset.label, item.dataset.value, item.dataset.waypointType);
                    });
                }
            }]);

            return AviaDepartureSheet;
        }();

        window.AviaDepartureSheet = AviaDepartureSheet;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaDepartureSheet = window.AviaDepartureSheet;

        var AviaDepartureControl = function () {
            function AviaDepartureControl(props) {
                _classCallCheck(this, AviaDepartureControl);

                this.translations = props.translations;
                this.elements = {
                    form: props.form,
                    departureInput: document.querySelector('#aviaHiddenDepart'),
                    departureTypeInput: document.querySelector('#aviaHiddenDepartureType')
                };
                this.isPreviewMode = Boolean(window.app && window.app.isPreview);

                this.departSheet = null;
                this.directions = [];
                this.departuresData = [];
                this.departures = [];

                this.bindHandlers();
            }

            _createClass(AviaDepartureControl, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this7 = this;

                    if (!this.elements.form) return;

                    this.elements.form.addEventListener('click', function (event) {
                        var target = event.target.closest('.form-field--depart-city');
                        if (target) {
                            _this7.openDeparts();
                        }
                    });
                }
            }, {
                key: "init",
                value: function init() {
                    this.departSheet = new AviaDepartureSheet({
                        translations: this.translations
                    });
                }
            }, {
                key: "onChange",
                value: function onChange(label, value, waypointType) {
                    this.renderDepartCityLabel(label);
                    this.setValue(value);
                    this.setTypeValue(waypointType);
                }
            }, {
                key: "renderDepartCityLabel",
                value: function renderDepartCityLabel(label) {
                    var labelEl = this.elements.form.querySelector('.form-field--depart-city .form-field__value');
                    if (labelEl) {
                        labelEl.textContent = label;
                    }
                }
            }, {
                key: "setValue",
                value: function setValue(value) {
                    if (this.elements.departureInput) {
                        this.elements.departureInput.value = value;
                    }
                }
            }, {
                key: "setTypeValue",
                value: function setTypeValue(value) {
                    if (this.isPreviewMode && this.elements.departureTypeInput) {
                        this.elements.departureTypeInput.value = value || 'city';
                    }
                }
            }, {
                key: "openDeparts",
                value: function openDeparts() {
                    var _this8 = this;

                    if (!this.departSheet) return;

                    this.departSheet.open();

                    var waitForData = function waitForData() {
                        if (_this8.departuresData.length && _this8.directions.length) {
                            _this8.serialize();
                            _this8.departSheet.renderContent(_this8.departures);
                        } else {
                            setTimeout(waitForData, 100); // ждём данные
                        }
                    };

                    waitForData();
                }
            }, {
                key: "serialize",
                value: function serialize() {
                    var _this9 = this;

                    var groupedData = {};
                    var usedCodes = new Set();

                    var _loop = function _loop(direction) {
                        var type = direction.type || 'unknown';
                        if (!groupedData[type]) groupedData[type] = [];

                        var departure = _this9.departuresData.find(function (dep) {
                            return dep.code === direction.from;
                        });
                        if (!departure || usedCodes.has(departure.code)) return "continue";

                        groupedData[type].push(departure);
                        usedCodes.add(departure.code);
                    };

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = this.directions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var direction = _step.value;

                            var _ret = _loop(direction);

                            if (_ret === "continue") continue;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    for (var type in groupedData) {
                        groupedData[type] = groupedData[type].slice().sort(function (a, b) {
                            var nameA = a.name || '';
                            var nameB = b.name || '';
                            return nameA.localeCompare(nameB, 'ru', { sensitivity: 'base', numeric: true });
                        });
                    }

                    this.departures = groupedData;
                }
            }]);

            return AviaDepartureControl;
        }();

        window.AviaDepartureControl = AviaDepartureControl;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaDestinationSheet = function () {
            function AviaDestinationSheet(props) {
                _classCallCheck(this, AviaDestinationSheet);

                this.translations = props.translations;
                this.modal = window.modal;
                this.sheet = document.querySelector('#aviaDestinationsSheet');
                this.countriesMap = null;

                this.bindHandlers();
            }

            _createClass(AviaDestinationSheet, [{
                key: "openModal",
                value: function openModal() {
                    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.translations.whereFlying;

                    this.modal.open({
                        header: { title: title },
                        content: { htmlDetachSelectorId: 'aviaDestinationsSheet' },
                        parentCssClass: 'search-avia-form-modal',
                        footer: false,
                        type: 'bottom',
                        onBeforeClose: function onBeforeClose() {
                            var event = new CustomEvent('_close-direction-modal');
                            document.body.dispatchEvent(event);

                            var backButton = document.querySelector('.back-button');
                            if (backButton) backButton.remove();
                        }
                    });
                }
            }, {
                key: "showLoader",
                value: function showLoader() {
                    if (!this.sheet) return;
                    var groupsContainer = this.sheet.querySelector('.avia-direction-groups');
                    if (groupsContainer) {
                        groupsContainer.innerHTML = "\n                <div class=\"avia-loader\">\n                    <div class=\"spinner\"></div>\n                    <div class=\"loader-text\">" + this.translations.loadData + "...</div>\n                </div>\n            ";
                    }
                }
            }, {
                key: "onChange",
                value: function onChange(label, value, flyType, waypointType) {
                    var event = new CustomEvent('_change-avia-destination', {
                        detail: { label: label, value: value, flyType: flyType, waypointType: waypointType }
                    });
                    document.body.dispatchEvent(event);
                    if (this.modal && typeof this.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }, {
                key: "open",
                value: function open() {
                    this.openModal();
                    this.showLoader();
                }
            }, {
                key: "renderContent",
                value: function renderContent(destinations) {
                    this.destinationsData = destinations;
                    this.renderCountries(destinations);
                }
            }, {
                key: "renderEmptyHint",
                value: function renderEmptyHint() {
                    if (!this.sheet) return;
                    var groupsContainer = this.sheet.querySelector('.avia-direction-groups');
                    if (!groupsContainer) return;

                    groupsContainer.innerHTML = "\n            <div class=\"avia-form-container search-destinations-hint\">\n                <div class=\"title\">\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435<br> \u0441\u0442\u0440\u0430\u043D\u044B, \u0433\u043E\u0440\u043E\u0434\u0430 \u0438\u043B\u0438 \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430</div>\n            </div>\n        ";
                }
            }, {
                key: "renderCountries",
                value: function renderCountries(destinations) {
                    var _this10 = this;

                    if (!this.sheet) return;
                    var groupsContainer = this.sheet.querySelector('.avia-direction-groups');
                    if (!groupsContainer) return;
                    groupsContainer.innerHTML = '';

                    var countriesMap = {};

                    // формируем карту стран
                    for (var type in destinations) {
                        var items = destinations[type] || [];
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var dest = _step2.value;

                                var country = dest.country.name;
                                if (!countriesMap[country]) {
                                    countriesMap[country] = {
                                        cities: [],
                                        items: [],
                                        code: dest.country.code || null
                                    };
                                }
                                countriesMap[country].cities.push(dest.name);
                                var newItem = Object.assign({}, dest);
                                newItem.type = type;
                                countriesMap[country].items.push(newItem);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }

                    this.countriesMap = countriesMap;

                    if (!Object.keys(countriesMap).length) {
                        this.renderEmptyHint();
                        return;
                    }

                    var countriesWrapper = document.createElement('div');
                    countriesWrapper.className = 'countries avia-direction-group-default';

                    for (var _country in countriesMap) {
                        var data = countriesMap[_country];
                        var citiesPreview = data.cities.slice(0, 5).join(', ') + (data.cities.length > 5 ? '…' : '');

                        var item = document.createElement('div');
                        item.className = 'list-item country-item';
                        item.dataset.country = _country;

                        var flagHtml = data.code ? "<img src=\"https://object.pscloud.io/brx-static/icons/countries/" + data.code + ".png\" alt=\"" + _country + "\" class=\"country-flag\">" : "<div class=\"country-flag placeholder\"></div>";

                        item.innerHTML = "\n                <div class=\"country-info\">\n                    " + flagHtml + "\n                    <div class=\"country-text\">\n                        <span class=\"item-title\">" + _country + "</span>\n                        <span class=\"item-subtitle\">" + citiesPreview + "</span>\n                    </div>\n                </div>\n            ";

                        countriesWrapper.appendChild(item);
                    }

                    groupsContainer.appendChild(countriesWrapper);

                    // заменил jQuery на чистый JS
                    countriesWrapper.addEventListener('click', function (e) {
                        var countryItem = e.target.closest('.country-item');
                        if (!countryItem) return;

                        var country = countryItem.dataset.country;
                        var mapItem = countriesMap[country];
                        if (mapItem) {
                            _this10.renderCities(country, mapItem.code, mapItem.items);
                        }
                    });
                }
            }, {
                key: "renderCities",
                value: function renderCities(country, countryCode, destinations) {
                    var _this11 = this;

                    if (!this.sheet) return;
                    var groupsContainer = this.sheet.querySelector('.avia-direction-groups');
                    if (!groupsContainer) return;
                    groupsContainer.innerHTML = '';

                    // кнопка "Назад"
                    var backBtn = document.createElement('div');
                    backBtn.className = 'back-button';
                    backBtn.addEventListener('click', function () {
                        backBtn.remove();
                        _this11.renderCountries(_this11.destinationsData);
                    });

                    var directionBlock = document.querySelector('#aviaDestinationsSheet .avia-search-direction');
                    if (directionBlock) directionBlock.prepend(backBtn);

                    var flagUrl = countryCode ? "/img/flag2/" + countryCode + ".png" : null;

                    var group = document.createElement('div');
                    group.className = 'avia-form-container avia-direction-group avia-direction-group-default';

                    var title = document.createElement('div');
                    title.className = 'group-title country-header';
                    title.innerHTML = "\n            " + (flagUrl ? "<img src=\"" + flagUrl + "\" alt=\"" + country + "\" class=\"country-flag\">" : '') + "\n            <span class=\"country-name\">" + country + "</span>\n        ";
                    group.appendChild(title);

                    var list = document.createElement('div');
                    list.className = 'group-list';

                    destinations.forEach(function (destination) {
                        list.appendChild(_this11.renderDestinationItem(destination));
                    });

                    group.appendChild(list);
                    groupsContainer.appendChild(group);
                }
            }, {
                key: "renderDestinationItem",
                value: function renderDestinationItem(destination) {
                    var item = document.createElement('div');
                    item.className = 'list-item';
                    item.dataset.label = destination.name + " (" + destination.code + ")";
                    item.dataset.value = destination.code;
                    item.dataset.type = this.flyType(destination.availability);
                    item.dataset.flyType = this.flyType(destination.availability);
                    item.dataset.waypointType = 'city';

                    var title = "<span class=\"item-title\">" + destination.name + " (" + destination.code + ")</span>";
                    var subtitle = this.subtitle(destination);
                    var ticketCount = this.ticketCount(destination.qty);
                    var minPrice = this.minPrice(destination.price);

                    item.innerHTML = "\n            <div>" + title + subtitle + "</div>\n            <div class=\"tickets-info\">" + ticketCount + minPrice + "</div>\n        ";

                    return item;
                }
            }, {
                key: "subtitle",
                value: function subtitle(destination) {
                    var text = destination.country.name;
                    var flyType = this.flyType(destination.availability);
                    if (flyType === 'ow') text = this.translations.alertOneWay;
                    if (flyType === 'rt') text = this.translations.alertRoundTrip;
                    return "<span class=\"item-subtitle\">" + text + "</span>";
                }
            }, {
                key: "flyType",
                value: function flyType(availability) {
                    if (Array.isArray(availability)) {
                        if (availability.length === 1) return availability[0];
                        if (availability.length > 1) return 'any';
                        return '';
                    }

                    return availability || '';
                }
            }, {
                key: "ticketCount",
                value: function ticketCount(count) {
                    if (typeof count === 'number') {
                        var parts = this.translations.countTickets ? this.translations.countTickets.split(',').map(function (s) {
                            return s.trim();
                        }) : ['', '', ''];

                        var _parts2 = _slicedToArray(parts, 3),
                            one = _parts2[0],
                            few = _parts2[1],
                            many = _parts2[2];

                        var str = window.brxUtils.getnoun(count, one, few, many);
                        return "<span class=\"count\">" + count + " " + str + "</span>";
                    }
                    return '';
                }
            }, {
                key: "minPrice",
                value: function minPrice(price) {
                    if (typeof price === 'number') {
                        return "<span class=\"price\">" + this.translations.of + " " + price.toLocaleString('ru-RU') + " \u20B8</span>";
                    }
                    return '';
                }
            }, {
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this12 = this;

                    if (!this.sheet) return;
                    this.sheet.addEventListener('click', function (e) {
                        var item = e.target.closest('.list-item');
                        if (!item || !_this12.sheet.contains(item)) return;

                        if (item.classList.contains('country-item') || item.classList.contains('back-button')) return;

                        var flyType = item.dataset.flyType || item.dataset.type;
                        _this12.onChange(item.dataset.label, item.dataset.value, flyType, item.dataset.waypointType);
                    });
                }
            }]);

            return AviaDestinationSheet;
        }();

        window.AviaDestinationSheet = AviaDestinationSheet;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaDestinationSheet = window.AviaDestinationSheet;

        var AviaDestinationControl = function () {
            function AviaDestinationControl(props) {
                _classCallCheck(this, AviaDestinationControl);

                this.elements = {
                    form: props.form,
                    destinationInput: document.querySelector('#aviaHiddenDestination'),
                    destinationTypeInput: document.querySelector('#aviaHiddenDestinationType'),
                    destinationLabel: props.form.querySelector('.form-field--destination .form-field__value')
                };
                this.isPreviewMode = Boolean(window.app && window.app.isPreview);

                this.translations = props.translations;

                this.values = null;
                this.departure = null;

                this.directions = [];
                this.destinationsData = [];
                this.destinations = [];

                this.bindHandlers();
            }

            _createClass(AviaDestinationControl, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this13 = this;

                    if (!this.elements.form) return;

                    this.elements.form.addEventListener('click', function (event) {
                        var target = event.target.closest('.form-field--destination');
                        if (target) {
                            _this13.openDestinations();
                        }
                    });
                }
            }, {
                key: "init",
                value: function init() {
                    this.destinationSheet = new AviaDestinationSheet({
                        translations: this.translations
                    });
                    if (this.elements.destinationLabel) {
                        this.elements.destinationLabel.classList.add('default');
                    }
                }
            }, {
                key: "onChange",
                value: function onChange(label, value, waypointType) {
                    if (!value) return;

                    if (this.elements.destinationLabel) {
                        this.elements.destinationLabel.classList.remove('default');
                        this.renderDestinationLabel(label);
                    }

                    this.setValue(value);
                    this.setTypeValue(waypointType);
                }
            }, {
                key: "setValue",
                value: function setValue(value) {
                    if (this.elements.destinationInput) {
                        this.elements.destinationInput.value = value;
                    }

                    var formField = this.elements.destinationLabel ? this.elements.destinationLabel.closest('.form-field') : null;

                    if (formField) formField.classList.remove('error');
                }
            }, {
                key: "setTypeValue",
                value: function setTypeValue(value) {
                    if (this.isPreviewMode && this.elements.destinationTypeInput) {
                        this.elements.destinationTypeInput.value = value || '';
                    }
                }
            }, {
                key: "renderDestinationLabel",
                value: function renderDestinationLabel(label) {
                    if (this.elements.destinationLabel) {
                        this.elements.destinationLabel.textContent = label;
                    }
                }
            }, {
                key: "openDestinations",
                value: function openDestinations() {
                    var _this14 = this;

                    if (!this.departure) {
                        console.warn('✈️ Departure не задан — нельзя открыть список направлений');
                        return;
                    }

                    this.destinationSheet.open();

                    var waitForData = function waitForData() {
                        if (_this14.destinationsData.length && _this14.directions.length) {
                            _this14.serialize();
                            _this14.destinationSheet.renderContent(_this14.destinations);
                        } else {
                            setTimeout(waitForData, 100); // ждём подгрузку данных
                        }
                    };

                    waitForData();
                }
            }, {
                key: "reset",
                value: function reset() {
                    var field = this.elements.destinationLabel ? this.elements.destinationLabel.closest('.form-field') : null;

                    if (field) field.classList.remove('error');

                    if (this.elements.destinationLabel) {
                        this.elements.destinationLabel.classList.add('default');
                        this.renderDestinationLabel(this.translations.selectDirection);
                    }

                    if (this.values) {
                        this.values.destination = null;
                        if (this.isPreviewMode) this.values.destinationType = null;
                    }
                    this.setValue('');
                    this.setTypeValue('');
                }
            }, {
                key: "serialize",
                value: function serialize() {
                    var _this15 = this;

                    var groupedData = {};
                    var usedCodes = new Set();
                    var departure = this.departure;

                    if (!departure || typeof departure !== 'string') {
                        console.warn('⚠️ Departure не задан или некорректен');
                        return;
                    }

                    this.directions.forEach(function (direction) {
                        if (direction.from !== departure) return;

                        var type = direction.type || 'unknown';
                        if (!groupedData[type]) groupedData[type] = [];

                        var destination = _this15.destinationsData.find(function (dep) {
                            return dep.code === direction.to;
                        });
                        if (!destination || usedCodes.has(destination.code)) return;

                        destination.availability = direction.availability;
                        destination.price = direction.price;
                        destination.qty = direction.qty;
                        destination.type = direction.type;

                        groupedData[type].push(destination);
                        usedCodes.add(destination.code);
                    });

                    for (var type in groupedData) {
                        groupedData[type] = groupedData[type].slice().sort(function (a, b) {
                            return (a.name || '').localeCompare(b.name || '', 'ru', {
                                sensitivity: 'base',
                                numeric: true
                            });
                        });
                    }

                    this.destinations = groupedData;
                }
            }]);

            return AviaDestinationControl;
        }();

        window.AviaDestinationControl = AviaDestinationControl;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaCalendarPriceRequest = function () {
            function AviaCalendarPriceRequest() {
                _classCallCheck(this, AviaCalendarPriceRequest);
            }

            _createClass(AviaCalendarPriceRequest, [{
                key: "loadCalendarPriceSearchResult",
                value: function loadCalendarPriceSearchResult(params) {
                    var formData = new FormData();

                    for (var key in params) {
                        if (Object.prototype.hasOwnProperty.call(params, key)) {
                            formData.append('AviaCalendarPrice[' + key + ']', params[key]);
                        }
                    }

                    var request = fetch('/new/charter-flight/calendar-price', {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: formData
                    });

                    return request.then(function (response) {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    });
                }
            }]);

            return AviaCalendarPriceRequest;
        }();

        window.AviaCalendarPriceRequest = AviaCalendarPriceRequest;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // ... Оставим тут require без изменений
        var CalendarMonth = require('./CalendarMonth');

        var DATE_IN_RAGE = 'date-in-range';
        var DATE_IN_RAGE_START = 'date-in-range-start';
        var DATE_IN_RAGE_END = 'date-in-range-end';
        var DATE_SELECTED = 'selected';
        var DATE_SELECTED_ONE = 'selected--one';

        var MODE_FULL_RANGE = 'range';
        var MODE_SINGLE_MONTH = 'single';

        var AviaDatepicker = function () {
            function AviaDatepicker(params) {
                var calendarSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                _classCallCheck(this, AviaDatepicker);

                this.containerId = params.containerId;
                this.container = document.querySelector('#' + this.containerId);
                this.container.classList.add('brx-datepicker-container');
                this.viewMode = params.viewMode;

                this.silentMode = false;

                this.calendar = new CalendarMonth(calendarSettings);

                this.allowOnceDispatchChangeOnSelected = params.allowOnceDispatchChangeOnSelected;
                this.selectedDate = params.selectedDate;
                this.currentMonth = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);

                this.range = { start: null, end: null };
                this.selectionMode = params.selectionMode ? params.selectionMode : 'single';

                this.on = {
                    change: 'onChange' in params ? params.onChange : null,
                    changeMonth: 'changeMonth' in params ? params.changeMonth : null,
                    onReadyCalendar: 'onReadyCalendar' in params ? params.onReadyCalendar : null
                };

                this.elements = { calendar: null, controls: null };
            }

            _createClass(AviaDatepicker, [{
                key: "init",
                value: function init() {
                    this.renderContainer();
                    this.elements = {
                        calendar: this.container.querySelector('.brx-datepicker__content'),
                        controls: this.container.querySelector('.brx-datepicker__controls')
                    };
                    this.renderCalendar();
                    this.bindEventListeners();

                    if (this.viewMode === MODE_SINGLE_MONTH) {
                        this.checkChangeMonthControlsState();
                    }
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    this.renderCalendar();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.container.remove();
                }
            }, {
                key: "setSelected",
                value: function setSelected() {
                    var selected = this.elements.calendar.querySelector('.' + DATE_SELECTED_ONE);
                    if (selected) {
                        selected.classList.remove(DATE_SELECTED_ONE);
                    }

                    var cell = this.getCell(this.selectedDate);
                    if (cell) {
                        cell.classList.add(DATE_SELECTED_ONE);
                    }
                }
            }, {
                key: "getCell",
                value: function getCell(date) {
                    var dateStrValue = this.calendar.dateToStringValue(date);
                    return this.elements.calendar.querySelector('.brx-calendar__date-button[data-date="' + dateStrValue + '"]');
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this16 = this;

                    this.elements.calendar.addEventListener('click', function (e) {
                        var cellButton = e.target.closest('.brx-calendar__date-button');
                        if (!cellButton || !_this16.elements.calendar.contains(cellButton)) return;

                        var dateCell = cellButton.parentElement;
                        if (dateCell.classList.contains('brx-calendar__date-disabled') || dateCell.classList.contains('brx-calendar__date-empty')) {
                            return;
                        }

                        var dateValue = cellButton.dataset.date;
                        if (!dateValue) return;

                        var priceEl = cellButton.querySelector('.price');
                        var price = priceEl ? priceEl.dataset.price : 0;
                        var allow = cellButton.dataset.allow;

                        var clickedDate = _this16.calendar.getDateFromValue(dateValue);

                        if (_this16.selectionMode === 'single') {
                            if (_this16.allowOnceDispatchChangeOnSelected || !cellButton.classList.contains(DATE_SELECTED)) {
                                _this16.allowOnceDispatchChangeOnSelected = false;
                                _this16.selectedDate = clickedDate;
                                _this16.dispatchOnChange(price, allow);
                            }
                        }

                        if (_this16.selectionMode === 'range') {
                            _this16.selectRangeDate(clickedDate);
                            _this16.updateSelectedRange();

                            if (!_this16.silentMode && _this16.on.change) {
                                _this16.on.change({
                                    start: _this16.range.start,
                                    end: _this16.range.end,
                                    price: price,
                                    allow: allow
                                });
                            }
                        }
                    });

                    if (this.selectionMode === 'single' && this.viewMode === MODE_SINGLE_MONTH) {
                        this.elements.controls.addEventListener('click', function (e) {
                            var button = e.target.closest('.brx-datepicker__control');
                            if (!button || !_this16.elements.controls.contains(button)) return;

                            if (button.classList.contains('previous')) {
                                _this16.renderPrevMonth();
                            } else {
                                _this16.renderNextMonth();
                            }

                            _this16.checkChangeMonthControlsState();

                            if (_this16.currentMonth.getMonth() === _this16.selectedDate.getMonth() && _this16.currentMonth.getFullYear() === _this16.selectedDate.getFullYear()) {
                                _this16.setSelected();
                            }
                        });
                    }
                }
            }, {
                key: "selectRangeDate",
                value: function selectRangeDate(date) {
                    if (!this.range.start || this.range.start && this.range.end) {
                        this.range.start = date;
                        this.range.end = null;
                    } else if (this.range.start && !this.range.end) {
                        if (date.getTime() > this.range.start.getTime()) {
                            this.range.end = date;
                        } else {
                            this.range.start = date;
                            this.range.end = null;
                        }
                    }
                }
            }, {
                key: "updateSelectedRange",
                value: function updateSelectedRange() {
                    var calendar = this.elements.calendar;

                    // Удаляем все классы диапазона и выделения
                    calendar.querySelectorAll("." + DATE_IN_RAGE).forEach(function (el) {
                        el.classList.remove(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                    });

                    calendar.querySelectorAll("." + DATE_SELECTED).forEach(function (el) {
                        el.classList.remove(DATE_SELECTED);
                    });

                    // Если выбраны обе границы диапазона
                    if (this.range.start && this.range.end) {
                        var current = new Date(this.range.start);
                        while (current <= this.range.end) {
                            var cell = this.getCell(current);
                            if (!cell) {
                                current.setDate(current.getDate() + 1);
                                continue;
                            }

                            if (this.isSameDate(current, this.range.start)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START);
                            } else if (this.isSameDate(current, this.range.end)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_END);
                            } else {
                                cell.classList.add(DATE_IN_RAGE);
                            }

                            current.setDate(current.getDate() + 1);
                        }
                    }
                    // Если выбрана только начальная дата
                    else if (this.range.start) {
                            var startCell = this.getCell(this.range.start);
                            if (startCell) {
                                startCell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                            }
                        }
                }
            }, {
                key: "clearRange",
                value: function clearRange() {
                    this.range = { start: null, end: null };
                    this.updateSelectedRange();
                }
            }, {
                key: "checkChangeMonthControlsState",
                value: function checkChangeMonthControlsState() {
                    var isPrevButtonDisabled = this.settings.minDate && this.isSameMonth(this.currentMonth, this.settings.minDate);

                    var isNextButtonDisabled = this.settings.maxDate && this.isSameMonth(this.currentMonth, this.settings.maxDate);

                    var prevButton = this.elements.controls.querySelector('.previous');
                    var nextButton = this.elements.controls.querySelector('.next');

                    if (prevButton) {
                        if (isPrevButtonDisabled) {
                            prevButton.classList.add('disabled');
                        } else {
                            prevButton.classList.remove('disabled');
                        }
                    }

                    if (nextButton) {
                        if (isNextButtonDisabled) {
                            nextButton.classList.add('disabled');
                        } else {
                            nextButton.classList.remove('disabled');
                        }
                    }
                }
            }, {
                key: "renderContainer",
                value: function renderContainer() {
                    this.container.innerHTML = "\n        <div class=\"brx-datepicker__container\">\n            <div class=\"brx-datepicker__controls\">\n                <div class=\"brx-datepicker__control previous\" role=\"button\">\n                    <span class=\"sr-only\">\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439</span>\n                </div>\n                <div class=\"brx-datepicker__control next\" role=\"button\">\n                    <span class=\"sr-only\">\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439</span>\n                </div>\n            </div>\n            <div class=\"brx-datepicker__content\"></div>\n        </div>\n    ";
                }
            }, {
                key: "renderCalendar",
                value: function renderCalendar() {
                    if (this.viewMode === MODE_SINGLE_MONTH) {
                        this._renderCurrentMonthCalendar();
                    } else if (this.viewMode === MODE_FULL_RANGE) {
                        this._renderCalendarFullRange();
                    }
                }
            }, {
                key: "renderNextMonth",
                value: function renderNextMonth() {
                    if (this.viewMode !== MODE_SINGLE_MONTH) return;
                    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
                    this.renderCalendar();
                    if (this.on.changeMonth) this.on.changeMonth();
                }
            }, {
                key: "renderPrevMonth",
                value: function renderPrevMonth() {
                    if (this.viewMode !== MODE_SINGLE_MONTH) return;
                    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
                    this.renderCalendar();
                    if (this.on.changeMonth) this.on.changeMonth();
                }
            }, {
                key: "_renderCurrentMonthCalendar",
                value: function _renderCurrentMonthCalendar() {
                    this.elements.calendar.innerHTML = this.calendar.renderMonth(this.currentMonth.getMonth(), this.currentMonth.getFullYear());
                }
            }, {
                key: "_renderCalendarFullRange",
                value: function _renderCalendarFullRange() {
                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    if (!minDate || !maxDate) {
                        var renderMonths = 11;
                        minDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
                        maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths, 0);
                    }

                    var renderTillMonth = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 1);
                    var renderFromMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

                    var calendarHtml = '';

                    do {
                        calendarHtml += this.calendar.renderMonth(renderFromMonth.getMonth(), renderFromMonth.getFullYear());
                        renderFromMonth = new Date(renderFromMonth.getFullYear(), renderFromMonth.getMonth() + 1, 1);
                    } while (!this.isSameMonth(renderFromMonth, renderTillMonth));

                    this.elements.calendar.innerHTML = calendarHtml;
                    // this.scrollToActiveMonth();

                    if (this.on.onReadyCalendar) {
                        this.on.onReadyCalendar();
                    }
                }
            }, {
                key: "scrollToActiveMonth",
                value: function scrollToActiveMonth() {
                    var firstDateCell = this.getCell(this.currentMonth);
                    if (!firstDateCell) return;

                    var month = firstDateCell.closest('.brx-calendar__wrapper');
                    if (!month) return;

                    var offsetTop = this.getContainerOffsetTop();

                    window.scrollTo({
                        top: month.getBoundingClientRect().top + window.scrollY - offsetTop,
                        behavior: 'smooth'
                    });
                }
            }, {
                key: "getContainerOffsetTop",
                value: function getContainerOffsetTop() {
                    if (!this.containerOffsetTop) {
                        var datepickerContainer = this.container.querySelector('.brx-datepicker__container');
                        this.containerOffsetTop = datepickerContainer ? datepickerContainer.offsetTop : 50;
                    }
                    return this.containerOffsetTop;
                }
            }, {
                key: "isSameMonth",
                value: function isSameMonth(date1, date2) {
                    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
                }
            }, {
                key: "isSameDate",
                value: function isSameDate(date1, date2) {
                    return this.isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
                }
            }, {
                key: "isDateInRange",
                value: function isDateInRange(date) {
                    var settings = this.calendar.settings;
                    return !(settings.minDate && settings.minDate.getTime() > date.getTime() || settings.maxDate && settings.maxDate.getTime() < date.getTime());
                }
            }, {
                key: "isRangeStartDate",
                value: function isRangeStartDate(date) {
                    var minDate = this.settings.minDate || null;
                    return date.getDate() === 1 || minDate && this.isSameDate(date, minDate);
                }
            }, {
                key: "isRangeEndDate",
                value: function isRangeEndDate(date) {
                    var maxDate = this.settings.maxDate || null;
                    if (maxDate && this.isSameDate(date, maxDate)) return true;
                    var lastDateOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    return lastDateOfMonth.getDate() === date.getDate();
                }
            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(price, allow) {
                    if (!this.silentMode && this.on.change) {
                        this.on.change({
                            start: this.selectedDate,
                            price: price,
                            allow: allow
                        });
                    }
                    this.setSelected();
                }
            }, {
                key: "setSelectedDates",
                value: function setSelectedDates(date) {
                    this.range = {
                        start: date.start ? new Date(date.start) : null,
                        end: date.end ? new Date(date.end) : null
                    };
                    this.updateSelectedRange();
                }
            }, {
                key: "settings",
                get: function get() {
                    return this.calendar.settings;
                }
            }]);

            return AviaDatepicker;
        }();

        module.exports = {
            AviaDatepicker: AviaDatepicker
        };
    }, { "./CalendarMonth": 2 }], 2: [function (require, module, exports) {
        var _require = require('./calendar-labels-ru'),
            monthNames = _require.monthNames,
            weekDayNamesShort = _require.weekDayNamesShort;

        var CalendarSettings = require('./CalendarSettings');

        var CalendarMonth = function () {
            /**
             * @param {CalendarSettings|null} settings
             */
            function CalendarMonth() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _classCallCheck(this, CalendarMonth);

                /** @type {CalendarSettings} */
                this.settings = settings !== null ? settings : new CalendarSettings();
                var messages = this.settings.messages;
                this.monthNames = messages ? messages.monthNames : monthNames;
                this.weekDayNamesShort = messages ? messages.weekDayNamesShort : weekDayNamesShort;
            }

            /**
             * @param {number} month - 0-11
             * @param {number} fullYear
             * @return {string}
             */


            _createClass(CalendarMonth, [{
                key: "renderMonth",
                value: function renderMonth(month, fullYear) {
                    var baseDate = new Date(fullYear, month, 1);
                    // Первый день месяца
                    var firstDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
                    // последний день месяца
                    var lastDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
                    // Последний день предыдущего месяца
                    var lastDateOfPrevMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

                    var firstDay = this.settings.firstDay;

                    var i = void 0;
                    var weekDay = void 0;
                    var weekDaysCellsHtml = '';
                    var startWeekDay = null;
                    var endWeekDay = null;
                    for (i = 0; i < 7; i++) {
                        weekDay = i + firstDay;
                        weekDay = weekDay > 6 ? weekDay - 7 : weekDay;
                        if (startWeekDay === null) {
                            startWeekDay = weekDay;
                        }
                        endWeekDay = weekDay;
                        weekDaysCellsHtml += '<td class="brx-calendar__day-name">' + this.weekDayNamesShort[i] + '</td>';
                    }

                    // Пустые клетки предыдущего месяца
                    var prevMonthEmptyCellCount = firstDateOfMonth.getDay() - firstDay;
                    if (prevMonthEmptyCellCount < 0) {
                        prevMonthEmptyCellCount = prevMonthEmptyCellCount + 7;
                    }
                    // Пустые клетки следующего месяца
                    // Если месяц заканчивается последним дней недели - 0
                    var nextMonthEmptyCellCount = lastDateOfMonth.getDay() === endWeekDay ? 0 : 7 + 1 - lastDateOfMonth.getDay() - firstDay;
                    // Кол-во дней в календаре
                    var datesCount = prevMonthEmptyCellCount + nextMonthEmptyCellCount + lastDateOfMonth.getDate();

                    // День предыдущего месяца, с которого начинается календарь
                    var prevMonthStartDate = lastDateOfPrevMonth.getDate() - prevMonthEmptyCellCount + 1;
                    // Начинаем рисовать с этой даты
                    var dateInstance = new Date(lastDateOfPrevMonth.getFullYear(), lastDateOfPrevMonth.getMonth(), prevMonthStartDate);
                    // dataInstance.getDay() === startWeekDay // Должно быть true

                    var calendarDatesHtml = '';
                    var rowHtml = '';
                    for (i = 0; i < datesCount; i++) {
                        rowHtml += this.getDateCell(dateInstance, dateInstance.getMonth() !== baseDate.getMonth());
                        if (endWeekDay === dateInstance.getDay()) {
                            // Конец недели
                            calendarDatesHtml += '<tr class="brx-calendar__row">' + rowHtml + '</tr>';
                            rowHtml = '';
                        }
                        // сдвигаем дату на след. день
                        dateInstance = new Date(dateInstance.getFullYear(), dateInstance.getMonth(), dateInstance.getDate() + 1);
                    }

                    var monthLabel = this.monthNames[baseDate.getMonth()] + (this.settings.showYear ? ' ' + baseDate.getFullYear() : '');
                    return '<div class="brx-calendar__wrapper">' + '<div class="brx-calendar__month">' + monthLabel + '</div>' + '<table class="brx-calendar__dates">' + '<thead><tr class="brx-calendar__row">' + weekDaysCellsHtml + '</tr></thead>' + '<tbody>' + calendarDatesHtml + '</tbody>' + '</table>' + '</div>';
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {string} - table cell html
                 */

            }, {
                key: "getDateCell",
                value: function getDateCell(date, empty) {
                    var today = new Date();
                    var settings = this.getDateSettings(date, empty);

                    var classList = 'brx-calendar__date' + (empty ? ' brx-calendar__date-empty' : '');

                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    var disabled = empty;
                    if (minDate && minDate.getTime() > date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }
                    if (maxDate && maxDate.getTime() < date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }

                    if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
                        classList += ' today';
                    }
                    classList += settings.cssClass !== '' ? ' ' + settings.cssClass : '';

                    return '<td class="' + classList + '">' + (empty && !this.settings.showEmptyDate ? '&nbsp;' : this.renderDateCellButton(date)) + '</td>';
                }

                /**
                 * @private
                 * @param {Date} date
                 */

            }, {
                key: "renderDateCellButton",
                value: function renderDateCellButton(date) {
                    var dateStringValue = this.dateToStringValue(date);
                    return "<button type=\"button\"\n                        class=\"brx-calendar__date-button\"\n                        data-date=\"" + dateStringValue + "\"\n                        data-date-day=\"" + date.getDate() + "\">" + date.getDate() + "</button>";
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {{cssClass: string}}
                 * @private
                 */

            }, {
                key: "getDateSettings",
                value: function getDateSettings(date, empty) {
                    var cssClass = this.settings.getDateCellCustomCssClass ? this.settings.getDateCellCustomCssClass(date, empty) : '';
                    return { cssClass: cssClass };
                }

                /**
                 * Формат значения в data-date
                 * @param {Date} date
                 * @return {string}
                 */

            }, {
                key: "dateToStringValue",
                value: function dateToStringValue(date) {
                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);

                    return day + '.' + month + '.' + date.getFullYear();
                }

                /**
                 * relates to this.dateToStringValue()
                 * @param {string} dateStringValue - Формат как и в dateToStringValue
                 * @return {Date}
                 */

            }, {
                key: "getDateFromValue",
                value: function getDateFromValue(dateStringValue) {
                    var values = dateStringValue.split('.');
                    return new Date(values[2], values[1] - 1, values[0]);
                }
            }]);

            return CalendarMonth;
        }();

        module.exports = CalendarMonth;
    }, { "./CalendarSettings": 3, "./calendar-labels-ru": 4 }], 3: [function (require, module, exports) {
        var CalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function CalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, CalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(CalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages = settings.messages,
                            monthNames = _settings$messages.monthNames,
                            weekDayNamesShort = _settings$messages.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return CalendarSettings;
        }();

        module.exports = CalendarSettings;
    }, {}], 4: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var _window = window,
            AviaCalendarPriceRequest = _window.AviaCalendarPriceRequest;

        var AviaCalendarPrices = function AviaCalendarPrices(params) {
            _classCallCheck(this, AviaCalendarPrices);

            this.values = [];
        };

        window.AviaCalendarPrices = AviaCalendarPrices;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaCalendarDates = function () {
            function AviaCalendarDates(props) {
                _classCallCheck(this, AviaCalendarDates);

                this.translations = props.translations;
                this.utils = window.brxUtils;
                this.modal = window.modal;

                var departDate = document.querySelector('.avia-calendar-depart-date');
                var arrivalDate = document.querySelector('.avia-calendar-arrival-date');

                this.elements = {
                    departDate: departDate,
                    departDateValue: departDate ? departDate.querySelector('.value') : null,
                    resetDepartDateBtn: departDate ? departDate.querySelector('.reset-depart-date') : null,

                    arrivalDate: arrivalDate,
                    arrivalDateValue: arrivalDate ? arrivalDate.querySelector('.value') : null,
                    resetArrivalDateBtn: arrivalDate ? arrivalDate.querySelector('.reset-arrival-date') : null
                };

                this.ruDayMonthFormatter = new Intl.DateTimeFormat('ru-RU', {
                    day: 'numeric',
                    month: 'long'
                });

                this.departDate = null;
                this.arrivalDate = null;
                this.price = null;

                this.bindEventListeners();
            }

            _createClass(AviaCalendarDates, [{
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this17 = this;

                    // слушаем пользовательское событие "_change-calendar"
                    document.body.addEventListener('_change-calendar', function (event) {
                        var params = event.detail;
                        _this17.price = params.price;

                        if (params && params.start) {
                            _this17.setDepartDate(_this17.parseIsoDateToYMD(params.start));
                            _this17.departDate = params.start;
                        }

                        if (params && params.end) {
                            _this17.setArrivalDate(_this17.parseIsoDateToYMD(params.end));
                        } else {
                            _this17.resetArrivalDate();
                        }
                    });

                    // делегирование кликов по кнопкам сброса
                    document.body.addEventListener('click', function (e) {
                        var target = e.target;

                        // Сброс даты вылета
                        if (target.closest('.reset-depart-date')) {
                            _this17.resetDepartDate();
                            document.body.dispatchEvent(new CustomEvent('_reset-depart-date'));
                            return;
                        }

                        // Сброс даты возвращения
                        if (target.closest('.reset-arrival-date')) {
                            _this17.resetArrivalDate();
                            document.body.dispatchEvent(new CustomEvent('_reset-arrival-date', {
                                detail: _this17.departDate
                            }));
                        }
                    });
                }
            }, {
                key: "setDepartDate",
                value: function setDepartDate(date) {
                    var formatted = this.formatDayMonth(date);

                    if (this.elements.departDate) {
                        this.elements.departDate.classList.toggle('selected', !!date);
                    }

                    if (this.elements.resetDepartDateBtn) {
                        this.elements.resetDepartDateBtn.classList.toggle('hidden', !date);
                    }

                    if (this.elements.departDateValue) {
                        this.elements.departDateValue.textContent = formatted;
                    }
                }
            }, {
                key: "setArrivalDate",
                value: function setArrivalDate(date) {
                    var formatted = this.formatDayMonth(date);

                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.toggle('selected', !!date);
                    }

                    if (this.elements.resetArrivalDateBtn) {
                        this.elements.resetArrivalDateBtn.classList.toggle('hidden', !date);
                    }

                    if (this.elements.arrivalDateValue) {
                        this.elements.arrivalDateValue.textContent = formatted;
                    }
                }
            }, {
                key: "resetDepartDate",
                value: function resetDepartDate() {
                    if (this.elements.departDate) {
                        this.elements.departDate.classList.remove('selected');
                    }

                    if (this.elements.resetDepartDateBtn) {
                        this.elements.resetDepartDateBtn.classList.add('hidden');
                    }

                    if (this.elements.departDateValue) {
                        this.elements.departDateValue.textContent = '';
                    }

                    this.resetArrivalDate();
                }
            }, {
                key: "showArrivalDate",
                value: function showArrivalDate() {
                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.remove('hidden');
                    }

                    if (this.elements.departDate) {
                        this.elements.departDate.classList.remove('full');
                    }
                }
            }, {
                key: "hideArrivalDate",
                value: function hideArrivalDate() {
                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.add('hidden');
                    }

                    if (this.elements.departDate) {
                        this.elements.departDate.classList.add('full');
                    }
                }
            }, {
                key: "resetArrivalDate",
                value: function resetArrivalDate() {
                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.remove('selected');
                    }

                    if (this.elements.resetArrivalDateBtn) {
                        this.elements.resetArrivalDateBtn.classList.add('hidden');
                    }

                    if (this.elements.arrivalDateValue) {
                        this.elements.arrivalDateValue.textContent = '';
                    }
                }
            }, {
                key: "formatDayMonth",
                value: function formatDayMonth(dateStr) {
                    if (!dateStr) return '';
                    var d = new Date(dateStr);
                    if (isNaN(d)) return ''; // защита от битых дат
                    return this.ruDayMonthFormatter.format(d);
                }
            }, {
                key: "parseIsoDateToYMD",
                value: function parseIsoDateToYMD(input) {
                    var d = new Date(input);
                    var yyyy = d.getFullYear();
                    var mm = String(d.getMonth() + 1).padStart(2, '0');
                    var dd = String(d.getDate()).padStart(2, '0');
                    return yyyy + "-" + mm + "-" + dd;
                }
            }]);

            return AviaCalendarDates;
        }();

        window.AviaCalendarDates = AviaCalendarDates;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaCalendarApplyButton = function () {
            function AviaCalendarApplyButton(props) {
                _classCallCheck(this, AviaCalendarApplyButton);

                this.translations = props.translations;

                this.params = {
                    start: null, end: null, price: null, flyType: null, localType: null
                };
                this.button = null;

                this.bindHandlers();
            }

            _createClass(AviaCalendarApplyButton, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this18 = this;

                    // Слушаем пользовательские события на body
                    document.body.addEventListener('_change-calendar', function (event) {
                        _this18.params = event.detail;
                        if (_this18.params.localType && _this18.params.localType === 'any') {
                            _this18.renderAnyFlyButton();
                        } else {
                            _this18.renderButton();
                        }
                    });

                    document.body.addEventListener('_reset-depart-date', function (event) {
                        var departDate = event.detail;
                        _this18.params.end = null;
                        _this18.params.start = departDate;
                        _this18.params.price = 0;
                        _this18.renderButton();
                    });

                    document.body.addEventListener('_reset-arrival-date', function (event) {
                        var departDate = event.detail;
                        _this18.params.end = null;
                        _this18.params.start = departDate;
                        _this18.params.price = 0;
                        _this18.renderButton();
                    });

                    // Делегирование клика по кнопке .apply-dates
                    document.body.addEventListener('click', function (e) {

                        var target = e.target.closest('.apply-dates');
                        var currentTarget = e.currentTarget.closest('.apply-dates');
                        if (target || currentTarget) {
                            _this18.apply();
                        }
                    });
                }
            }, {
                key: "renderButton",
                value: function renderButton() {
                    this.button = document.querySelector('.modal2-footer .apply-dates');
                    if (!this.button) return;

                    var options = { day: 'numeric', month: 'long' };
                    var departDate = this.params.start ? new Date(this.params.start).toLocaleDateString('ru-RU', options) : null;
                    var arrivalDate = this.params.end ? new Date(this.params.end).toLocaleDateString('ru-RU', options) : null;

                    // если нет обеих дат — прячем кнопку
                    if (!this.params.start && !this.params.end) {
                        this.button.classList.add('hidden');
                        return;
                    }

                    if (this.params.flyType === 'rt') {
                        this.renderRoundTripButton(departDate, arrivalDate);
                    } else if (this.params.flyType === 'ow') {
                        this.renderOneWayButton(departDate);
                    } else if (this.params.flyType === 'any') {
                        this.renderAnyFlyButton(this.params.localType);
                    } else if (arrivalDate) {
                        this.renderRoundTripButton(departDate, arrivalDate);
                    } else if (departDate) {
                        this.renderOneWayButton(departDate);
                    }
                }
            }, {
                key: "renderRoundTripButton",
                value: function renderRoundTripButton(departDate, arrivalDate) {
                    var textButton = '';
                    var textPrice = '';

                    if (!arrivalDate) {
                        textButton = this.translations.returnDate;

                        this.button.classList.remove('hidden');
                        this.button.disabled = true;
                    } else {
                        textButton = this.translations.select + ": " + departDate + " - " + arrivalDate;
                        if (Number(this.params.price) > 0) {
                            textPrice = this.translations.of + " " + (+this.params.price).toLocaleString('ru-RU') + " \u20B8";
                        }

                        this.button.classList.remove('hidden');
                        this.button.disabled = false;
                    }

                    this.button.innerHTML = "\n        <span>" + textButton + "</span>\n        <span class=\"price\">" + textPrice + "</span>\n    ";
                }
            }, {
                key: "renderOneWayButton",
                value: function renderOneWayButton(departDate) {
                    var textButton = '';
                    var textPrice = '';

                    if (departDate) {
                        textButton = this.translations.select + ": " + departDate;
                        if (Number(this.params.price) > 0) {
                            textPrice = this.translations.of + " " + (+this.params.price).toLocaleString('ru-RU') + " \u20B8";
                        }
                        this.button.classList.remove('hidden');
                    }

                    this.button.innerHTML = "\n        <span>" + textButton + "</span>\n        <span class=\"price\">" + textPrice + "</span>\n    ";
                }
            }, {
                key: "renderAnyFlyButton",
                value: function renderAnyFlyButton() {
                    var options = { day: 'numeric', month: 'long' };
                    var departDate = new Date(this.params.start).toLocaleDateString('ru-RU', options);
                    var arrivalDate = this.params.end ? new Date(this.params.end).toLocaleDateString('ru-RU', options) : null;

                    if (this.params.flyType === 'any') {
                        if (this.params.localType === 'ow') {
                            this.renderOneWayButton(departDate);
                        } else if (this.params.localType === 'rt') {
                            this.renderRoundTripButton(departDate, arrivalDate);
                        } else {
                            if (arrivalDate) {
                                this.renderRoundTripButton(departDate, arrivalDate);
                            } else {
                                var textButton = this.translations.noNeedGoBack;
                                this.button.classList.remove('hidden');
                                this.button.disabled = false;
                                this.button.innerHTML = "<span>" + textButton + "</span>";
                            }
                        }
                    }
                }
            }, {
                key: "resetParams",
                value: function resetParams() {
                    this.params = {
                        start: null, end: null, price: null, flyType: null
                    };
                }
            }, {
                key: "apply",
                value: function apply() {
                    var event = new CustomEvent('_change-avia-dates', {
                        detail: {
                            dateFrom: this.params.start,
                            dateTo: this.params.end,
                            flyType: this.params.flyType,
                            minPrice: this.params.price
                        }
                    });

                    document.body.dispatchEvent(event);
                }
            }]);

            return AviaCalendarApplyButton;
        }();

        window.AviaCalendarApplyButton = AviaCalendarApplyButton;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var CalendarSettings = require("./CalendarSettings");

        var _require2 = require("./AviaDatepicker"),
            AviaDatepicker = _require2.AviaDatepicker;

        var AviaCalendar = function () {
            function AviaCalendar(props) {
                _classCallCheck(this, AviaCalendar);

                this.startDateWithPrice = new Date();
                this.prices = null;
                this.flyType = null;
                this.translations = props.translations;
                this.aviaCalendarApplyButton = props.aviaCalendarApplyButton;

                this.datesContainer = document.querySelector('.avia-calendar-dates');
                this.localType = null;

                this.bindHandlers();
            }

            _createClass(AviaCalendar, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this19 = this;

                    document.body.addEventListener('_reset-depart-date', function (event) {
                        _this19.setSelectedDates(null, null);
                        _this19.renderPrices();
                    });

                    document.body.addEventListener('_reset-arrival-date', function (event) {
                        var date = event.detail;
                        _this19.setSelectedDates(date, null);

                        var departDate = _this19.parseIsoDateToYMD(date);
                        var minPrice = null;

                        if (_this19.localType === 'any') {
                            var any = _this19.prices && _this19.prices.anyPrices ? _this19.prices.anyPrices : {};
                            var oneWay = any.oneWay || any.oneway || {};
                            var roundTrip = any.roundTrip || {};

                            var oneWayRaw = Object.prototype.hasOwnProperty.call(oneWay, departDate) ? oneWay[departDate] : undefined;
                            var oneWayMinPrice = oneWayRaw === undefined ? NaN : Number(oneWayRaw);

                            var endRoundTripPrices = Object.prototype.hasOwnProperty.call(roundTrip, departDate) ? roundTrip[departDate] : {};

                            var pricesList = [];
                            for (var endDate in endRoundTripPrices) {
                                if (!Object.prototype.hasOwnProperty.call(endRoundTripPrices, endDate)) continue;
                                if (endDate === departDate) continue;
                                var p = Number(endRoundTripPrices[endDate]);
                                if (isFinite(p)) pricesList.push(p);
                            }

                            var candidates = [];
                            if (isFinite(oneWayMinPrice)) candidates.push(oneWayMinPrice);
                            if (pricesList.length) candidates.push(Math.min.apply(Math, pricesList));

                            minPrice = candidates.length ? Math.min.apply(Math, candidates) : null;

                            _this19.renderRoundTripEndPrices(departDate, minPrice);
                        } else if (_this19.localType === 'rt') {
                            var footer = document.querySelector('.modal2-footer');
                            if (footer) {
                                footer.insertAdjacentHTML('beforeend', _this19.renderFlyTypeAlert('footer'));
                            }
                            _this19.renderRoundTripEndPrices(departDate);
                        } else {
                            _this19.renderRoundTripEndPrices(departDate);
                        }
                    });
                }
            }, {
                key: "init",
                value: function init(prices, flyType) {
                    var _this20 = this;

                    this.prices = prices;
                    this.flyType = flyType;

                    this.startDateWithPrice = null;
                    this.endDateWithPrice = null;

                    this.getStartDateWithPrice();

                    this.datepicker = new AviaDatepicker({
                        containerId: 'aviaCalendarContent',
                        selectedDate: this.startDateWithPrice,
                        viewMode: 'range',
                        selectionMode: 'range',
                        onChange: function onChange(data) {
                            if (_this20.flyType === 'rt') {
                                if (data.start && !data.end) {
                                    _this20.renderRoundTripEndPrices(data.start);
                                }
                            }

                            _this20.localType = '';

                            if (_this20.flyType === 'any') {
                                var selectedDate = _this20.parseIsoDateToYMD(data.start);
                                var oneWay = _this20.prices.anyPrices.oneWay;
                                var roundTrip = _this20.prices.anyPrices.roundTrip;

                                _this20.datepicker.selectionMode = 'range';
                                _this20.removeFlyTypeAlert();

                                if (oneWay[selectedDate] && roundTrip[selectedDate]) {
                                    // ✅ оба направления доступны
                                    _this20.localType = 'any';
                                    _this20.datepicker.setSelectedDates({ start: data.start, end: data.end });

                                    if (!data.end) {
                                        _this20.renderRoundTripEndPrices(data.start, data.price);
                                    } else {
                                        _this20.renderOnlyRangePrices(data.start, data.end);
                                    }
                                } else if (oneWay[selectedDate]) {
                                    // ✅ только one-way
                                    _this20.localType = 'ow';
                                    _this20.datepicker.selectionMode = 'single';
                                    _this20.datepicker.setSelectedDates({ start: data.start, end: data.end });

                                    var footer = document.querySelector('.modal2-footer');
                                    if (footer) {
                                        footer.insertAdjacentHTML('beforeend', _this20.renderFlyTypeAlert('footer'));
                                    }
                                } else {
                                    // ✅ round-trip или fallback
                                    if (data.end && data.start.getTime() === data.end.getTime()) {
                                        data.end = null;
                                    }

                                    _this20.datepicker.setSelectedDates({ start: data.start, end: data.end });
                                    _this20.localType = 'rt';

                                    if (data.end) {
                                        _this20.renderOnlyRangePrices(data.start, data.end);
                                    } else {
                                        _this20.renderRoundTripEndPrices(data.start);
                                    }

                                    var _footer = document.querySelector('.modal2-footer');
                                    if (_footer) {
                                        _footer.insertAdjacentHTML('beforeend', _this20.renderFlyTypeAlert('footer'));
                                    }
                                }
                            }

                            if (_this20.flyType === 'rt' && data.start && data.end) {
                                _this20.renderOnlyRangePrices(data.start, data.end);
                            }

                            data.flyType = _this20.flyType;
                            data.localType = _this20.localType;

                            document.body.dispatchEvent(new CustomEvent('_change-calendar', { detail: data }));
                        },
                        onReadyCalendar: function onReadyCalendar() {
                            _this20.renderPrices();
                        }
                    }, this.calendarSettings());

                    this.datepicker.init();
                }
            }, {
                key: "getStartDateWithPrice",
                value: function getStartDateWithPrice() {
                    var allDates = [].concat(_toConsumableArray(Object.keys(this.prices.oneWayPrices || {})), _toConsumableArray(Object.keys(this.prices.roundTripPrices || {})));
                    if (!allDates.length) {
                        this.startDateWithPrice = new Date();
                        this.endDateWithPrice = new Date();
                        return;
                    }

                    var minDateStr = allDates.reduce(function (min, current) {
                        return current < min ? current : min;
                    });
                    var maxDateStr = allDates.reduce(function (max, current) {
                        return current > max ? current : max;
                    });

                    var allReturnDates = Object.values(this.prices.roundTripPrices || {}).flatMap(function (obj) {
                        return Object.keys(obj || {}).map(function (s) {
                            return s.trim();
                        });
                    });

                    if (allReturnDates.length) {
                        maxDateStr = allReturnDates.reduce(function (max, current) {
                            return current > max ? current : max;
                        });
                    }

                    this.startDateWithPrice = new Date(minDateStr);
                    this.endDateWithPrice = new Date(maxDateStr);
                }
            }, {
                key: "calendarSettings",
                value: function calendarSettings() {
                    var _createCalendarDateBo = this.createCalendarDateBounds(),
                        minDate = _createCalendarDateBo.minDate,
                        maxDate = _createCalendarDateBo.maxDate;

                    return new CalendarSettings({
                        minDate: minDate,
                        maxDate: maxDate,
                        showYear: true,
                        showEmptyDate: false
                    });
                }
            }, {
                key: "createCalendarDateBounds",
                value: function createCalendarDateBounds() {
                    var renderMonths = 11;
                    var minDate = new Date();
                    var fallbackMaxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths + 1, 0);
                    var priceMaxDate = new Date(this.endDateWithPrice);
                    var priceMaxMonthEnd = !isNaN(priceMaxDate) ? new Date(priceMaxDate.getFullYear(), priceMaxDate.getMonth() + 1, 0) : null;
                    var maxDate = priceMaxMonthEnd && priceMaxMonthEnd.getTime() > fallbackMaxDate.getTime() ? priceMaxMonthEnd : fallbackMaxDate;

                    minDate.setHours(0, 0, 0, 0);
                    maxDate.setHours(23, 59, 59);

                    return { minDate: minDate, maxDate: maxDate };
                }
            }, {
                key: "renderPrices",
                value: function renderPrices() {
                    this.removeFlyTypeAlert();

                    if (this.flyType === 'rt') {
                        this.datesContainer.insertAdjacentHTML('beforeend', this.renderFlyTypeAlert());
                        this.renderRoundTripPrices();
                    }

                    if (this.flyType === 'ow') {
                        this.datesContainer.insertAdjacentHTML('beforeend', this.renderFlyTypeAlert());
                        this.renderOneWayPrices();
                    }

                    if (this.flyType === 'any') {
                        this.renderAnyPrices();
                    }
                }
            }, {
                key: "renderRoundTripPrices",
                value: function renderRoundTripPrices() {
                    var pricesMap = {};
                    var roundTrip = this.prices.roundTripPrices || {};

                    for (var date in roundTrip) {
                        if (!roundTrip.hasOwnProperty(date)) continue;

                        var endDates = roundTrip[date];

                        var pricesList = [];
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = Object.entries(endDates)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _ref8 = _step3.value;

                                var _ref9 = _slicedToArray(_ref8, 2);

                                var endDate = _ref9[0];
                                var price = _ref9[1];

                                if (endDate !== date) pricesList.push(price);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        if (pricesList.length) {
                            pricesMap[date] = Math.min.apply(Math, pricesList);
                        }
                    }

                    this.renderPricesHtml(pricesMap);
                }
            }, {
                key: "renderRoundTripEndPrices",
                value: function renderRoundTripEndPrices(startDate) {
                    var price = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    // безопасно достаём структуру
                    var roundTripAll = this.prices && this.prices.roundTripPrices ? this.prices.roundTripPrices : {};
                    var normalizedDate = this.parseIsoDateToYMD(startDate);

                    // копируем исходную мапу (чтобы не трогать this.prices)
                    var originalMap = roundTripAll[normalizedDate] || {};
                    var pricesMap = {};
                    for (var k in originalMap) {
                        if (!Object.prototype.hasOwnProperty.call(originalMap, k)) continue;
                        var v = Number(originalMap[k]);
                        if (isFinite(v)) pricesMap[k] = v;
                    }

                    // Если price передан и это валидное число — просто вставляем (без сравнений)
                    if (price !== undefined && price !== null) {
                        var num = Number(price);
                        if (isFinite(num)) {
                            pricesMap[normalizedDate] = num; // просто ставим/перезаписываем
                        }
                    }

                    // рендерим результат
                    this.renderPricesHtml(pricesMap);
                }
            }, {
                key: "renderOnlyRangePrices",
                value: function renderOnlyRangePrices(start, end) {
                    var pricesMap = {};
                    var roundTrip = this.prices.roundTripPrices || {};
                    var dateStart = this.parseIsoDateToYMD(start);
                    var dateEnd = this.parseIsoDateToYMD(end);

                    var endDates = roundTrip[dateStart];
                    pricesMap[dateEnd] = endDates[dateEnd];

                    this.renderPricesHtml(pricesMap);
                }
            }, {
                key: "renderOneWayPrices",
                value: function renderOneWayPrices() {
                    this.renderPricesHtml(this.prices.oneWayPrices);
                }
            }, {
                key: "renderAnyPrices",
                value: function renderAnyPrices() {
                    var anyPrices = this.prices && this.prices.anyPrices ? this.prices.anyPrices : {};
                    var oneWayPrices = anyPrices.oneWay;
                    var roundTripPrices = anyPrices.roundTrip;

                    var priceMap = {};
                    for (var date in oneWayPrices) {
                        if (!Object.prototype.hasOwnProperty.call(oneWayPrices, date)) continue;
                        var price = Number(oneWayPrices[date]);
                        if (isFinite(price)) priceMap[date] = price;
                    }

                    for (var _date in roundTripPrices) {
                        if (!Object.prototype.hasOwnProperty.call(roundTripPrices, _date)) continue;

                        var endPrices = roundTripPrices[_date] || {};
                        var rtMin = Infinity;

                        for (var end in endPrices) {
                            if (!Object.prototype.hasOwnProperty.call(endPrices, end)) continue;
                            if (end === _date) continue; // исключаем «тот же день»
                            var _price = Number(endPrices[end]);
                            if (isFinite(_price) && _price < rtMin) rtMin = _price;
                        }

                        if (rtMin === Infinity) continue; // нечего сравнивать

                        var owPrice = Object.prototype.hasOwnProperty.call(priceMap, _date) ? Number(priceMap[_date]) : Infinity;

                        priceMap[_date] = Math.min(owPrice, rtMin);
                    }

                    this.renderPricesHtml(priceMap);
                }
            }, {
                key: "renderPricesHtml",
                value: function renderPricesHtml(pricesMap) {
                    var _this21 = this;

                    var dateButtons = document.querySelectorAll('.brx-calendar__date-button');
                    var normalizedPrices = pricesMap || {};

                    dateButtons.forEach(function (btn) {
                        var parent = btn.closest('.brx-calendar__date');
                        var date = btn.dataset.date;
                        var normalizedDate = _this21.parseUIDateToYMD(date);
                        var fullPrice = Number(normalizedPrices[normalizedDate]);
                        var hasPrice = Object.prototype.hasOwnProperty.call(normalizedPrices, normalizedDate) && isFinite(fullPrice);

                        // удалить старую цену
                        btn.querySelectorAll('.price').forEach(function (priceEl) {
                            return priceEl.remove();
                        });

                        if (!_this21.isDateBeforeToday(normalizedDate)) {
                            parent.classList.remove('brx-calendar__date-disabled');
                            btn.classList.remove('disabled-date');
                        }

                        if (hasPrice) {
                            var shortPrice = Math.round(fullPrice / 1000);

                            btn.insertAdjacentHTML('beforeend', "<span class=\"price\" data-price=\"" + fullPrice + "\">" + shortPrice + "</span>");
                        }
                    });
                }
            }, {
                key: "setSelectedDates",
                value: function setSelectedDates(dateFrom, dateTo) {
                    if (!this.datepicker) return;

                    if (this.datepicker.selectionMode === 'range') {
                        this.datepicker.setSelectedDates({ start: dateFrom, end: dateTo });

                        if (dateFrom && dateTo) {
                            this.renderOnlyRangePrices(dateFrom, dateTo);
                            return;
                        }

                        if (dateFrom) {
                            var date = this.parseIsoDateToYMD(dateFrom);
                            var price = this.prices.oneWayPrices[date];
                            this.renderRoundTripEndPrices(dateFrom, price ? price : null);
                            return;
                        }
                    } else if (this.datepicker.selectionMode === 'single') {
                        this.datepicker.setSelectedDates({ start: dateFrom, end: dateTo });
                    }

                    if (this.flyType === 'rt') {
                        if (dateFrom && dateTo) {
                            this.renderRoundTripEndPrices(dateFrom);
                        } else {
                            this.renderPrices();
                        }
                    } else {
                        this.renderPrices();
                    }
                }
            }, {
                key: "renderFlyTypeAlert",
                value: function renderFlyTypeAlert() {
                    var cssClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                    var text = '';
                    if (this.flyType === 'rt' || this.localType === 'rt') {
                        text = this.translations.alertRoundTrip;
                    }
                    if (this.flyType === 'ow' || this.localType === 'ow') {
                        text = this.translations.alertOneWay;
                    }

                    return "<div class=\"avia-calendar-alert " + cssClass + "\">" + text + "</div>";
                }
            }, {
                key: "removeFlyTypeAlert",
                value: function removeFlyTypeAlert() {
                    document.querySelectorAll('.avia-calendar-alert').forEach(function (el) {
                        return el.remove();
                    });
                }
            }, {
                key: "parseUIDateToYMD",
                value: function parseUIDateToYMD(dateStr) {
                    // из "10.07.2025" сделаем "2025-07-10"
                    var _dateStr$split = dateStr.split('.'),
                        _dateStr$split2 = _slicedToArray(_dateStr$split, 3),
                        day = _dateStr$split2[0],
                        month = _dateStr$split2[1],
                        year = _dateStr$split2[2];

                    return year + "-" + month + "-" + day;
                }
            }, {
                key: "parseIsoDateToYMD",
                value: function parseIsoDateToYMD(input) {
                    var d = new Date(input);
                    var yyyy = d.getFullYear();
                    var mm = String(d.getMonth() + 1).padStart(2, '0');
                    var dd = String(d.getDate()).padStart(2, '0');
                    return yyyy + "-" + mm + "-" + dd;
                }
            }, {
                key: "isDateBeforeToday",
                value: function isDateBeforeToday(dateString) {
                    var date = new Date(dateString);
                    var today = new Date();

                    if (isNaN(date)) return true;

                    date.setHours(0, 0, 0, 0);
                    today.setHours(0, 0, 0, 0);

                    return date.getTime() < today.getTime();
                }
            }]);

            return AviaCalendar;
        }();

        window.AviaCalendar = AviaCalendar;
    }, { "./AviaDatepicker": 2, "./CalendarSettings": 4 }], 2: [function (require, module, exports) {
        // ... Оставим тут require без изменений
        var CalendarMonth = require('./CalendarMonth');

        var DATE_IN_RAGE = 'date-in-range';
        var DATE_IN_RAGE_START = 'date-in-range-start';
        var DATE_IN_RAGE_END = 'date-in-range-end';
        var DATE_SELECTED = 'selected';
        var DATE_SELECTED_ONE = 'selected--one';

        var MODE_FULL_RANGE = 'range';
        var MODE_SINGLE_MONTH = 'single';

        var AviaDatepicker = function () {
            function AviaDatepicker(params) {
                var calendarSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                _classCallCheck(this, AviaDatepicker);

                this.containerId = params.containerId;
                this.container = document.querySelector('#' + this.containerId);
                this.container.classList.add('brx-datepicker-container');
                this.viewMode = params.viewMode;

                this.silentMode = false;

                this.calendar = new CalendarMonth(calendarSettings);

                this.allowOnceDispatchChangeOnSelected = params.allowOnceDispatchChangeOnSelected;
                this.selectedDate = params.selectedDate;
                this.currentMonth = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);

                this.range = { start: null, end: null };
                this.selectionMode = params.selectionMode ? params.selectionMode : 'single';

                this.on = {
                    change: 'onChange' in params ? params.onChange : null,
                    changeMonth: 'changeMonth' in params ? params.changeMonth : null,
                    onReadyCalendar: 'onReadyCalendar' in params ? params.onReadyCalendar : null
                };

                this.elements = { calendar: null, controls: null };
            }

            _createClass(AviaDatepicker, [{
                key: "init",
                value: function init() {
                    this.renderContainer();
                    this.elements = {
                        calendar: this.container.querySelector('.brx-datepicker__content'),
                        controls: this.container.querySelector('.brx-datepicker__controls')
                    };
                    this.renderCalendar();
                    this.bindEventListeners();

                    if (this.viewMode === MODE_SINGLE_MONTH) {
                        this.checkChangeMonthControlsState();
                    }
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    this.renderCalendar();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.container.remove();
                }
            }, {
                key: "setSelected",
                value: function setSelected() {
                    var selected = this.elements.calendar.querySelector('.' + DATE_SELECTED_ONE);
                    if (selected) {
                        selected.classList.remove(DATE_SELECTED_ONE);
                    }

                    var cell = this.getCell(this.selectedDate);
                    if (cell) {
                        cell.classList.add(DATE_SELECTED_ONE);
                    }
                }
            }, {
                key: "getCell",
                value: function getCell(date) {
                    var dateStrValue = this.calendar.dateToStringValue(date);
                    return this.elements.calendar.querySelector('.brx-calendar__date-button[data-date="' + dateStrValue + '"]');
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this22 = this;

                    this.elements.calendar.addEventListener('click', function (e) {
                        var cellButton = e.target.closest('.brx-calendar__date-button');
                        if (!cellButton || !_this22.elements.calendar.contains(cellButton)) return;

                        var dateCell = cellButton.parentElement;
                        if (dateCell.classList.contains('brx-calendar__date-disabled') || dateCell.classList.contains('brx-calendar__date-empty')) {
                            return;
                        }

                        var dateValue = cellButton.dataset.date;
                        if (!dateValue) return;

                        var priceEl = cellButton.querySelector('.price');
                        var price = priceEl ? priceEl.dataset.price : 0;
                        var allow = cellButton.dataset.allow;

                        var clickedDate = _this22.calendar.getDateFromValue(dateValue);

                        if (_this22.selectionMode === 'single') {
                            if (_this22.allowOnceDispatchChangeOnSelected || !cellButton.classList.contains(DATE_SELECTED)) {
                                _this22.allowOnceDispatchChangeOnSelected = false;
                                _this22.selectedDate = clickedDate;
                                _this22.dispatchOnChange(price, allow);
                            }
                        }

                        if (_this22.selectionMode === 'range') {
                            _this22.selectRangeDate(clickedDate);
                            _this22.updateSelectedRange();

                            if (!_this22.silentMode && _this22.on.change) {
                                _this22.on.change({
                                    start: _this22.range.start,
                                    end: _this22.range.end,
                                    price: price,
                                    allow: allow
                                });
                            }
                        }
                    });

                    if (this.selectionMode === 'single' && this.viewMode === MODE_SINGLE_MONTH) {
                        this.elements.controls.addEventListener('click', function (e) {
                            var button = e.target.closest('.brx-datepicker__control');
                            if (!button || !_this22.elements.controls.contains(button)) return;

                            if (button.classList.contains('previous')) {
                                _this22.renderPrevMonth();
                            } else {
                                _this22.renderNextMonth();
                            }

                            _this22.checkChangeMonthControlsState();

                            if (_this22.currentMonth.getMonth() === _this22.selectedDate.getMonth() && _this22.currentMonth.getFullYear() === _this22.selectedDate.getFullYear()) {
                                _this22.setSelected();
                            }
                        });
                    }
                }
            }, {
                key: "selectRangeDate",
                value: function selectRangeDate(date) {
                    if (!this.range.start || this.range.start && this.range.end) {
                        this.range.start = date;
                        this.range.end = null;
                    } else if (this.range.start && !this.range.end) {
                        if (date.getTime() > this.range.start.getTime()) {
                            this.range.end = date;
                        } else {
                            this.range.start = date;
                            this.range.end = null;
                        }
                    }
                }
            }, {
                key: "updateSelectedRange",
                value: function updateSelectedRange() {
                    var calendar = this.elements.calendar;

                    // Удаляем все классы диапазона и выделения
                    calendar.querySelectorAll("." + DATE_IN_RAGE).forEach(function (el) {
                        el.classList.remove(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                    });

                    calendar.querySelectorAll("." + DATE_SELECTED).forEach(function (el) {
                        el.classList.remove(DATE_SELECTED);
                    });

                    // Если выбраны обе границы диапазона
                    if (this.range.start && this.range.end) {
                        var current = new Date(this.range.start);
                        while (current <= this.range.end) {
                            var cell = this.getCell(current);
                            if (!cell) {
                                current.setDate(current.getDate() + 1);
                                continue;
                            }

                            if (this.isSameDate(current, this.range.start)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START);
                            } else if (this.isSameDate(current, this.range.end)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_END);
                            } else {
                                cell.classList.add(DATE_IN_RAGE);
                            }

                            current.setDate(current.getDate() + 1);
                        }
                    }
                    // Если выбрана только начальная дата
                    else if (this.range.start) {
                            var startCell = this.getCell(this.range.start);
                            if (startCell) {
                                startCell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                            }
                        }
                }
            }, {
                key: "clearRange",
                value: function clearRange() {
                    this.range = { start: null, end: null };
                    this.updateSelectedRange();
                }
            }, {
                key: "checkChangeMonthControlsState",
                value: function checkChangeMonthControlsState() {
                    var isPrevButtonDisabled = this.settings.minDate && this.isSameMonth(this.currentMonth, this.settings.minDate);

                    var isNextButtonDisabled = this.settings.maxDate && this.isSameMonth(this.currentMonth, this.settings.maxDate);

                    var prevButton = this.elements.controls.querySelector('.previous');
                    var nextButton = this.elements.controls.querySelector('.next');

                    if (prevButton) {
                        if (isPrevButtonDisabled) {
                            prevButton.classList.add('disabled');
                        } else {
                            prevButton.classList.remove('disabled');
                        }
                    }

                    if (nextButton) {
                        if (isNextButtonDisabled) {
                            nextButton.classList.add('disabled');
                        } else {
                            nextButton.classList.remove('disabled');
                        }
                    }
                }
            }, {
                key: "renderContainer",
                value: function renderContainer() {
                    this.container.innerHTML = "\n        <div class=\"brx-datepicker__container\">\n            <div class=\"brx-datepicker__controls\">\n                <div class=\"brx-datepicker__control previous\" role=\"button\">\n                    <span class=\"sr-only\">\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439</span>\n                </div>\n                <div class=\"brx-datepicker__control next\" role=\"button\">\n                    <span class=\"sr-only\">\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439</span>\n                </div>\n            </div>\n            <div class=\"brx-datepicker__content\"></div>\n        </div>\n    ";
                }
            }, {
                key: "renderCalendar",
                value: function renderCalendar() {
                    if (this.viewMode === MODE_SINGLE_MONTH) {
                        this._renderCurrentMonthCalendar();
                    } else if (this.viewMode === MODE_FULL_RANGE) {
                        this._renderCalendarFullRange();
                    }
                }
            }, {
                key: "renderNextMonth",
                value: function renderNextMonth() {
                    if (this.viewMode !== MODE_SINGLE_MONTH) return;
                    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
                    this.renderCalendar();
                    if (this.on.changeMonth) this.on.changeMonth();
                }
            }, {
                key: "renderPrevMonth",
                value: function renderPrevMonth() {
                    if (this.viewMode !== MODE_SINGLE_MONTH) return;
                    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
                    this.renderCalendar();
                    if (this.on.changeMonth) this.on.changeMonth();
                }
            }, {
                key: "_renderCurrentMonthCalendar",
                value: function _renderCurrentMonthCalendar() {
                    this.elements.calendar.innerHTML = this.calendar.renderMonth(this.currentMonth.getMonth(), this.currentMonth.getFullYear());
                }
            }, {
                key: "_renderCalendarFullRange",
                value: function _renderCalendarFullRange() {
                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    if (!minDate || !maxDate) {
                        var renderMonths = 11;
                        minDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
                        maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths, 0);
                    }

                    var renderTillMonth = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 1);
                    var renderFromMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

                    var calendarHtml = '';

                    do {
                        calendarHtml += this.calendar.renderMonth(renderFromMonth.getMonth(), renderFromMonth.getFullYear());
                        renderFromMonth = new Date(renderFromMonth.getFullYear(), renderFromMonth.getMonth() + 1, 1);
                    } while (!this.isSameMonth(renderFromMonth, renderTillMonth));

                    this.elements.calendar.innerHTML = calendarHtml;
                    // this.scrollToActiveMonth();

                    if (this.on.onReadyCalendar) {
                        this.on.onReadyCalendar();
                    }
                }
            }, {
                key: "scrollToActiveMonth",
                value: function scrollToActiveMonth() {
                    var firstDateCell = this.getCell(this.currentMonth);
                    if (!firstDateCell) return;

                    var month = firstDateCell.closest('.brx-calendar__wrapper');
                    if (!month) return;

                    var offsetTop = this.getContainerOffsetTop();

                    window.scrollTo({
                        top: month.getBoundingClientRect().top + window.scrollY - offsetTop,
                        behavior: 'smooth'
                    });
                }
            }, {
                key: "getContainerOffsetTop",
                value: function getContainerOffsetTop() {
                    if (!this.containerOffsetTop) {
                        var datepickerContainer = this.container.querySelector('.brx-datepicker__container');
                        this.containerOffsetTop = datepickerContainer ? datepickerContainer.offsetTop : 50;
                    }
                    return this.containerOffsetTop;
                }
            }, {
                key: "isSameMonth",
                value: function isSameMonth(date1, date2) {
                    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
                }
            }, {
                key: "isSameDate",
                value: function isSameDate(date1, date2) {
                    return this.isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
                }
            }, {
                key: "isDateInRange",
                value: function isDateInRange(date) {
                    var settings = this.calendar.settings;
                    return !(settings.minDate && settings.minDate.getTime() > date.getTime() || settings.maxDate && settings.maxDate.getTime() < date.getTime());
                }
            }, {
                key: "isRangeStartDate",
                value: function isRangeStartDate(date) {
                    var minDate = this.settings.minDate || null;
                    return date.getDate() === 1 || minDate && this.isSameDate(date, minDate);
                }
            }, {
                key: "isRangeEndDate",
                value: function isRangeEndDate(date) {
                    var maxDate = this.settings.maxDate || null;
                    if (maxDate && this.isSameDate(date, maxDate)) return true;
                    var lastDateOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    return lastDateOfMonth.getDate() === date.getDate();
                }
            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(price, allow) {
                    if (!this.silentMode && this.on.change) {
                        this.on.change({
                            start: this.selectedDate,
                            price: price,
                            allow: allow
                        });
                    }
                    this.setSelected();
                }
            }, {
                key: "setSelectedDates",
                value: function setSelectedDates(date) {
                    this.range = {
                        start: date.start ? new Date(date.start) : null,
                        end: date.end ? new Date(date.end) : null
                    };
                    this.updateSelectedRange();
                }
            }, {
                key: "settings",
                get: function get() {
                    return this.calendar.settings;
                }
            }]);

            return AviaDatepicker;
        }();

        module.exports = {
            AviaDatepicker: AviaDatepicker
        };
    }, { "./CalendarMonth": 3 }], 3: [function (require, module, exports) {
        var _require3 = require('./calendar-labels-ru'),
            monthNames = _require3.monthNames,
            weekDayNamesShort = _require3.weekDayNamesShort;

        var CalendarSettings = require('./CalendarSettings');

        var CalendarMonth = function () {
            /**
             * @param {CalendarSettings|null} settings
             */
            function CalendarMonth() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _classCallCheck(this, CalendarMonth);

                /** @type {CalendarSettings} */
                this.settings = settings !== null ? settings : new CalendarSettings();
                var messages = this.settings.messages;
                this.monthNames = messages ? messages.monthNames : monthNames;
                this.weekDayNamesShort = messages ? messages.weekDayNamesShort : weekDayNamesShort;
            }

            /**
             * @param {number} month - 0-11
             * @param {number} fullYear
             * @return {string}
             */


            _createClass(CalendarMonth, [{
                key: "renderMonth",
                value: function renderMonth(month, fullYear) {
                    var baseDate = new Date(fullYear, month, 1);
                    // Первый день месяца
                    var firstDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
                    // последний день месяца
                    var lastDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
                    // Последний день предыдущего месяца
                    var lastDateOfPrevMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

                    var firstDay = this.settings.firstDay;

                    var i = void 0;
                    var weekDay = void 0;
                    var weekDaysCellsHtml = '';
                    var startWeekDay = null;
                    var endWeekDay = null;
                    for (i = 0; i < 7; i++) {
                        weekDay = i + firstDay;
                        weekDay = weekDay > 6 ? weekDay - 7 : weekDay;
                        if (startWeekDay === null) {
                            startWeekDay = weekDay;
                        }
                        endWeekDay = weekDay;
                        weekDaysCellsHtml += '<td class="brx-calendar__day-name">' + this.weekDayNamesShort[i] + '</td>';
                    }

                    // Пустые клетки предыдущего месяца
                    var prevMonthEmptyCellCount = firstDateOfMonth.getDay() - firstDay;
                    if (prevMonthEmptyCellCount < 0) {
                        prevMonthEmptyCellCount = prevMonthEmptyCellCount + 7;
                    }
                    // Пустые клетки следующего месяца
                    // Если месяц заканчивается последним дней недели - 0
                    var nextMonthEmptyCellCount = lastDateOfMonth.getDay() === endWeekDay ? 0 : 7 + 1 - lastDateOfMonth.getDay() - firstDay;
                    // Кол-во дней в календаре
                    var datesCount = prevMonthEmptyCellCount + nextMonthEmptyCellCount + lastDateOfMonth.getDate();

                    // День предыдущего месяца, с которого начинается календарь
                    var prevMonthStartDate = lastDateOfPrevMonth.getDate() - prevMonthEmptyCellCount + 1;
                    // Начинаем рисовать с этой даты
                    var dateInstance = new Date(lastDateOfPrevMonth.getFullYear(), lastDateOfPrevMonth.getMonth(), prevMonthStartDate);
                    // dataInstance.getDay() === startWeekDay // Должно быть true

                    var calendarDatesHtml = '';
                    var rowHtml = '';
                    for (i = 0; i < datesCount; i++) {
                        rowHtml += this.getDateCell(dateInstance, dateInstance.getMonth() !== baseDate.getMonth());
                        if (endWeekDay === dateInstance.getDay()) {
                            // Конец недели
                            calendarDatesHtml += '<tr class="brx-calendar__row">' + rowHtml + '</tr>';
                            rowHtml = '';
                        }
                        // сдвигаем дату на след. день
                        dateInstance = new Date(dateInstance.getFullYear(), dateInstance.getMonth(), dateInstance.getDate() + 1);
                    }

                    var monthLabel = this.monthNames[baseDate.getMonth()] + (this.settings.showYear ? ' ' + baseDate.getFullYear() : '');
                    return '<div class="brx-calendar__wrapper">' + '<div class="brx-calendar__month">' + monthLabel + '</div>' + '<table class="brx-calendar__dates">' + '<thead><tr class="brx-calendar__row">' + weekDaysCellsHtml + '</tr></thead>' + '<tbody>' + calendarDatesHtml + '</tbody>' + '</table>' + '</div>';
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {string} - table cell html
                 */

            }, {
                key: "getDateCell",
                value: function getDateCell(date, empty) {
                    var today = new Date();
                    var settings = this.getDateSettings(date, empty);

                    var classList = 'brx-calendar__date' + (empty ? ' brx-calendar__date-empty' : '');

                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    var disabled = empty;
                    if (minDate && minDate.getTime() > date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }
                    if (maxDate && maxDate.getTime() < date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }

                    if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
                        classList += ' today';
                    }
                    classList += settings.cssClass !== '' ? ' ' + settings.cssClass : '';

                    return '<td class="' + classList + '">' + (empty && !this.settings.showEmptyDate ? '&nbsp;' : this.renderDateCellButton(date)) + '</td>';
                }

                /**
                 * @private
                 * @param {Date} date
                 */

            }, {
                key: "renderDateCellButton",
                value: function renderDateCellButton(date) {
                    var dateStringValue = this.dateToStringValue(date);
                    return "<button type=\"button\"\n                        class=\"brx-calendar__date-button\"\n                        data-date=\"" + dateStringValue + "\"\n                        data-date-day=\"" + date.getDate() + "\">" + date.getDate() + "</button>";
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {{cssClass: string}}
                 * @private
                 */

            }, {
                key: "getDateSettings",
                value: function getDateSettings(date, empty) {
                    var cssClass = this.settings.getDateCellCustomCssClass ? this.settings.getDateCellCustomCssClass(date, empty) : '';
                    return { cssClass: cssClass };
                }

                /**
                 * Формат значения в data-date
                 * @param {Date} date
                 * @return {string}
                 */

            }, {
                key: "dateToStringValue",
                value: function dateToStringValue(date) {
                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);

                    return day + '.' + month + '.' + date.getFullYear();
                }

                /**
                 * relates to this.dateToStringValue()
                 * @param {string} dateStringValue - Формат как и в dateToStringValue
                 * @return {Date}
                 */

            }, {
                key: "getDateFromValue",
                value: function getDateFromValue(dateStringValue) {
                    var values = dateStringValue.split('.');
                    return new Date(values[2], values[1] - 1, values[0]);
                }
            }]);

            return CalendarMonth;
        }();

        module.exports = CalendarMonth;
    }, { "./CalendarSettings": 4, "./calendar-labels-ru": 5 }], 4: [function (require, module, exports) {
        var CalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function CalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, CalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(CalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages2 = settings.messages,
                            monthNames = _settings$messages2.monthNames,
                            weekDayNamesShort = _settings$messages2.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return CalendarSettings;
        }();

        module.exports = CalendarSettings;
    }, {}], 5: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaDateCalendarSheet = function () {
            function AviaDateCalendarSheet(props) {
                _classCallCheck(this, AviaDateCalendarSheet);

                this.translations = props.translations;
                this.utils = window.brxUtils;
                this.modal = window.modal;

                this.localValues = {
                    departure: null,
                    destination: null
                };

                this.dateFrom = null;
                this.dateTo = null;
                this.departure = null;
                this.destination = null;
                this.flyType = null;
                this.minPrice = 0;

                this.prices = {
                    anyPrices: {},
                    oneWayPrices: {},
                    roundTripPrices: {}
                };

                this.elements = {
                    calendarContent: document.querySelector('#aviaCalendarContent')
                };

                this.aviaRequestService = null;

                this.init();
                this.bindEventListeners();
            }

            _createClass(AviaDateCalendarSheet, [{
                key: "init",
                value: function init() {
                    this.aviaRequestService = new window.AviaCalendarPriceRequest();
                    this.aviaCalendarApplyButton = new window.AviaCalendarApplyButton({
                        translations: this.translations
                    });

                    this.calendar = new window.AviaCalendar({
                        translations: this.translations,
                        aviaCalendarApplyButton: this.aviaCalendarApplyButton
                    });

                    this.aviaCalendarDates = new window.AviaCalendarDates({
                        translations: this.translations
                    });
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    // можно будет расширить при необходимости
                }
            }, {
                key: "openModal",
                value: function openModal(dateFrom, dateTo, departure, destination, flyType, minPrice) {
                    var self = this;
                    this.dateFrom = dateFrom;
                    this.dateTo = dateTo;
                    this.departure = departure;
                    this.destination = destination;
                    this.flyType = flyType;
                    this.minPrice = minPrice;

                    this.modal.open({
                        content: { htmlDetachSelectorId: 'aviaCalendarSheet' },
                        parentCssClass: 'search-avia-form-modal',
                        footer: {
                            buttonLabel: this.translations.select,
                            buttonCssClass: 'apply-dates hidden'
                        },
                        type: 'bottom',
                        onBeforeClose: function onBeforeClose() {
                            self.resetData();
                        },
                        onAfterShow: function onAfterShow() {
                            if (self.isAvailablePriceRequest()) {
                                self.renderSkeletons();
                                self.loadPrices();
                            } else if (self.hasPrices()) {
                                self.renderData();
                            }
                        }
                    });
                }
            }, {
                key: "isAvailablePriceRequest",
                value: function isAvailablePriceRequest() {
                    return this.departure !== this.localValues.departure || this.destination !== this.localValues.destination;
                }
            }, {
                key: "loadPrices",
                value: function loadPrices() {
                    var self = this;
                    this.localValues.departure = this.departure;
                    this.localValues.destination = this.destination;

                    this.aviaRequestService.loadCalendarPriceSearchResult({
                        from: this.departure,
                        to: this.destination
                    }).then(function (result) {
                        self.prices.roundTripPrices = result.roundTrip || {};
                        self.prices.oneWayPrices = result.oneway || {};
                        self.prices.anyPrices = {};

                        if (Object.keys(self.prices.roundTripPrices).length && Object.keys(self.prices.oneWayPrices).length) {
                            self.prices.anyPrices = {
                                oneWay: self.prices.oneWayPrices,
                                roundTrip: self.prices.roundTripPrices
                            };
                        }

                        self.removeSkeletons();
                        if (self.hasPrices()) {
                            self.renderData();
                        } else {
                            self.renderEmptyResult();
                        }
                    }).catch(function (err) {
                        console.error('Ошибка при поиске направлений', err);
                        self.removeSkeletons();
                        self.renderEmptyResult();
                    });
                }
            }, {
                key: "hasPrices",
                value: function hasPrices() {
                    return Object.keys(this.prices.roundTripPrices).length > 0 || Object.keys(this.prices.oneWayPrices).length > 0;
                }
            }, {
                key: "resetData",
                value: function resetData() {
                    this.aviaCalendarDates.resetDepartDate();
                    this.aviaCalendarDates.resetArrivalDate();
                    this.calendar.setSelectedDates(null, null);
                    this.aviaCalendarApplyButton.resetParams();
                    this.calendar.removeFlyTypeAlert();
                }
            }, {
                key: "resolveFlyType",
                value: function resolveFlyType() {
                    if (this.flyType === 'rt' || this.flyType === 'ow' || this.flyType === 'any') {
                        return this.flyType;
                    }

                    var hasRoundTrip = Object.keys(this.prices.roundTripPrices || {}).length > 0;
                    var hasOneWay = Object.keys(this.prices.oneWayPrices || {}).length > 0;

                    if (hasRoundTrip && hasOneWay) {
                        return 'any';
                    }
                    if (hasRoundTrip) {
                        return 'rt';
                    }
                    if (hasOneWay) {
                        return 'ow';
                    }

                    return null;
                }
            }, {
                key: "renderData",
                value: function renderData() {
                    var flyType = this.resolveFlyType();
                    this.flyType = flyType;
                    this.calendar.init(this.prices, flyType);

                    this.aviaCalendarDates.setDepartDate(this.dateFrom);

                    if (flyType === 'rt') {
                        this.calendar.localType = 'rt';
                        this.calendar.setSelectedDates(this.dateFrom, this.dateTo);
                        this.aviaCalendarDates.setArrivalDate(this.dateTo);
                        this.aviaCalendarDates.showArrivalDate();
                    } else if (flyType === 'ow') {
                        this.calendar.localType = 'ow';
                        this.calendar.datepicker.selectionMode = 'single';
                        this.calendar.setSelectedDates(this.dateFrom);
                        this.aviaCalendarDates.hideArrivalDate();
                    } else if (flyType === 'any') {
                        this.calendar.localType = 'any';
                        this.calendar.datepicker.selectionMode = 'range';
                        this.calendar.setSelectedDates(this.dateFrom, this.dateTo);
                        this.aviaCalendarDates.setDepartDate(this.dateFrom);
                        if (this.dateTo) {
                            this.aviaCalendarDates.setArrivalDate(this.dateTo);
                        }
                    } else {
                        this.calendar.datepicker.selectionMode = 'range';
                        this.calendar.setSelectedDates(this.dateFrom, this.dateTo);
                        this.aviaCalendarDates.showArrivalDate();
                        if (this.dateTo) {
                            this.aviaCalendarDates.setArrivalDate(this.dateTo);
                        } else {
                            this.aviaCalendarDates.resetArrivalDate();
                        }
                    }

                    this.aviaCalendarApplyButton.params = {
                        start: this.dateFrom,
                        end: this.dateTo,
                        flyType: flyType,
                        price: this.minPrice
                    };

                    this.aviaCalendarApplyButton.renderButton();
                }
            }, {
                key: "renderEmptyResult",
                value: function renderEmptyResult() {
                    var parent = this.elements.calendarContent;
                    if (!parent) return;

                    // удалить старые блоки
                    var old = parent.querySelector('.avia-direction-empty-search');
                    if (old) old.remove();

                    var container = document.createElement('div');
                    container.className = 'avia-form-container avia-direction-empty-search';

                    var html = '' + '<div class="empty-title">' + this.translations.notFoundPrices + '</div>' + '<div class="empty-subtitle">' + this.translations.reloadPage + '</div>' + '<button type="button" class="clear-search-input reload-page-btn">' + this.translations.reloadBtn + '</button>';

                    container.innerHTML = html;
                    parent.innerHTML = '';
                    parent.appendChild(container);
                }
            }, {
                key: "renderSkeletons",
                value: function renderSkeletons() {
                    var parent = this.elements.calendarContent;
                    if (!parent) return;
                    parent.innerHTML = '';

                    for (var i = 0; i < 2; i++) {
                        var wrapper = document.createElement('div');
                        wrapper.className = 'brx-calendar__wrapper';

                        var month = document.createElement('div');
                        month.className = 'brx-calendar__month skeleton';

                        var table = document.createElement('table');
                        table.className = 'brx-calendar__dates';

                        var tbody = document.createElement('tbody');

                        for (var r = 0; r < 5; r++) {
                            var tr = document.createElement('tr');
                            tr.className = 'brx-calendar__row';

                            for (var c = 0; c < 7; c++) {
                                var td = document.createElement('td');
                                td.className = 'brx-calendar__date skeleton';
                                var span = document.createElement('span');
                                td.appendChild(span);
                                tr.appendChild(td);
                            }
                            tbody.appendChild(tr);
                        }

                        table.appendChild(tbody);
                        wrapper.appendChild(month);
                        wrapper.appendChild(table);
                        parent.appendChild(wrapper);
                    }
                }
            }, {
                key: "removeSkeletons",
                value: function removeSkeletons() {
                    var parent = this.elements.calendarContent;
                    if (parent) {
                        parent.innerHTML = '';
                    }

                    var skeletons = document.querySelectorAll('.avia-calendar-dates .skeleton');
                    for (var i = 0; i < skeletons.length; i++) {
                        skeletons[i].classList.remove('skeleton');
                    }
                }
            }]);

            return AviaDateCalendarSheet;
        }();

        window.AviaDateCalendarSheet = AviaDateCalendarSheet;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaDateCalendarSheet = window.AviaDateCalendarSheet;

        var AviaDateCalendarControl = function () {
            function AviaDateCalendarControl(props) {
                _classCallCheck(this, AviaDateCalendarControl);

                this.utils = window.brxUtils;
                this.values = null;
                this.destination = null;
                this.translations = props.translations;

                this.elements = {
                    form: props.form,
                    dateFrom: document.querySelector('#aviaHiddenDateFrom'),
                    dateTo: document.querySelector('#aviaHiddenDateTo'),
                    datesLabel: props.form.querySelector('.form-field--fly-date .form-field__value')
                };

                this.calendarSheet = null;

                this.bindHandlers();
            }

            _createClass(AviaDateCalendarControl, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var self = this;
                    if (!this.elements.form) return;

                    this.elements.form.addEventListener('click', function (event) {
                        if (event.target.closest('.form-field--fly-date')) {
                            self.openCalendar();
                        }
                    });
                }
            }, {
                key: "init",
                value: function init() {
                    this.calendarSheet = new AviaDateCalendarSheet({
                        translations: this.translations
                    });
                }
            }, {
                key: "onChange",
                value: function onChange(params) {
                    if (!params || !params.dateFrom) return;

                    var field = this.elements.datesLabel.closest('.form-field');
                    if (field) field.classList.remove('error');

                    if (this.elements.datesLabel) {
                        this.elements.datesLabel.classList.remove('default');
                    }

                    this.renderDatesLabel(params);
                    this.setValue(params);
                }
            }, {
                key: "setValue",
                value: function setValue(params) {
                    if (!params || !params.dateFrom) {
                        if (this.values) {
                            this.values.dateFrom = null;
                            this.values.dateTo = null;
                        }
                        return;
                    }

                    var formatDate = function formatDate(d) {
                        var date = new Date(d);
                        if (isNaN(date)) return '';
                        var y = date.getFullYear();
                        var m = String(date.getMonth() + 1).padStart(2, '0');
                        var day = String(date.getDate()).padStart(2, '0');
                        return y + '-' + m + '-' + day;
                    };

                    var dateFromStr = formatDate(params.dateFrom);
                    if (this.elements.dateFrom) this.elements.dateFrom.value = dateFromStr;

                    if (params.dateTo && this.elements.dateTo) {
                        var dateToStr = formatDate(params.dateTo);
                        this.elements.dateTo.value = dateToStr;
                    }

                    if (!this.values) this.values = {};
                    this.values.flyType = params.flyType;
                    this.values.minPrice = params.minPrice;
                }
            }, {
                key: "renderDatesLabel",
                value: function renderDatesLabel(params) {
                    if (!params || !params.dateFrom) return;

                    var options = { day: 'numeric', month: 'long' };
                    var dateFrom = new Date(params.dateFrom).toLocaleDateString('ru-RU', options);
                    var dateTo = '';

                    if (params.dateTo) {
                        dateTo = new Date(params.dateTo).toLocaleDateString('ru-RU', options);
                        dateTo = ' - ' + dateTo;
                    }

                    var label = this.elements.form.querySelector('.form-field--fly-date .form-field__value');
                    if (label) {
                        label.textContent = dateFrom + dateTo;
                    }
                }
            }, {
                key: "openCalendar",
                value: function openCalendar() {
                    if (this.values && this.values.departure && this.values.destination) {
                        this.calendarSheet.openModal(this.values.dateFrom, this.values.dateTo, this.values.departure, this.values.destination, this.values.flyType, this.values.minPrice || 0);
                    } else if (this.destination && this.destination.elements && this.destination.elements.destinationLabel) {
                        var field = this.destination.elements.destinationLabel.closest('.form-field');
                        if (field) field.classList.add('error');
                    }
                }
            }, {
                key: "reset",
                value: function reset() {
                    var field = this.elements.datesLabel.closest('.form-field');
                    if (field) field.classList.remove('error');

                    if (this.elements.datesLabel) {
                        this.elements.datesLabel.classList.add('default');
                        this.elements.datesLabel.textContent = this.translations.selectDates;
                    }

                    this.setValue({});
                }
            }]);

            return AviaDateCalendarControl;
        }();

        window.AviaDateCalendarControl = AviaDateCalendarControl;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewAviaCalendarPriceRequest = function () {
            function NewAviaCalendarPriceRequest() {
                _classCallCheck(this, NewAviaCalendarPriceRequest);
            }

            _createClass(NewAviaCalendarPriceRequest, [{
                key: "loadCalendarPriceSearchResult",
                value: function loadCalendarPriceSearchResult(params) {
                    var searchParams = new URLSearchParams();

                    for (var key in params) {
                        if (Object.prototype.hasOwnProperty.call(params, key)) {
                            if (key === 'from' || key === 'to') continue;
                            var value = params[key];
                            if (value !== undefined && value !== null && value !== '') {
                                searchParams.append(key, value);
                            }
                        }
                    }

                    var headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Accept-Language': this.getAcceptLanguage()
                    };

                    var deviceKey = this.getDeviceKey();
                    if (deviceKey) {
                        headers['X-Device-Key'] = deviceKey;
                    }

                    var request = fetch('https://dev-api.ht.kz/flights-search/web/search/calendar/' + encodeURIComponent(params.from) + '/' + encodeURIComponent(params.to) + (searchParams.toString() ? '?' + searchParams.toString() : ''), {
                        method: 'GET',
                        headers: headers
                    });

                    return request.then(function (response) {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    });
                }
            }, {
                key: "getAcceptLanguage",
                value: function getAcceptLanguage() {
                    if (window.app && window.app.locale) {
                        return window.app.locale;
                    }

                    if (document.documentElement && document.documentElement.lang) {
                        return document.documentElement.lang;
                    }

                    return 'ru-RU';
                }
            }, {
                key: "getDeviceKey",
                value: function getDeviceKey() {
                    if (window.app && window.app.deviceKey) {
                        return window.app.deviceKey;
                    }

                    if (window.app && window.app.device_key) {
                        return window.app.device_key;
                    }

                    if (window.localStorage) {
                        return localStorage.getItem('deviceKey') || localStorage.getItem('device_key') || '';
                    }

                    return '';
                }
            }]);

            return NewAviaCalendarPriceRequest;
        }();

        window.NewAviaCalendarPriceRequest = NewAviaCalendarPriceRequest;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // ... Оставим тут require без изменений
        var NewCalendarMonth = require('./NewCalendarMonth');

        var DATE_IN_RAGE = 'date-in-range';
        var DATE_IN_RAGE_START = 'date-in-range-start';
        var DATE_IN_RAGE_END = 'date-in-range-end';
        var DATE_SELECTED = 'selected';
        var DATE_SELECTED_ONE = 'selected--one';

        var MODE_FULL_RANGE = 'range';

        var NewAviaDatepicker = function () {
            function NewAviaDatepicker(params) {
                var calendarSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                _classCallCheck(this, NewAviaDatepicker);

                this.containerId = params.containerId;
                this.container = document.querySelector('#' + this.containerId);
                this.container.classList.add('brx-datepicker-container');
                this.viewMode = params.viewMode;

                this.silentMode = false;

                this.calendar = new NewCalendarMonth(calendarSettings);

                this.selectedDate = params.selectedDate;
                this.currentMonth = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);

                this.range = { start: null, end: null };
                this.selectionMode = params.selectionMode ? params.selectionMode : 'single';

                this.on = {
                    change: 'onChange' in params ? params.onChange : null,
                    changeMonth: 'changeMonth' in params ? params.changeMonth : null,
                    onReadyCalendar: 'onReadyCalendar' in params ? params.onReadyCalendar : null
                };

                this.elements = { calendar: null, controls: null };
                this.renderedMaxMonthStart = null;
            }

            _createClass(NewAviaDatepicker, [{
                key: "init",
                value: function init() {
                    this.renderContainer();
                    this.elements = {
                        calendar: this.container.querySelector('.brx-datepicker__content'),
                        controls: this.container.querySelector('.brx-datepicker__controls')
                    };
                    this.renderCalendar();
                    this.bindEventListeners();
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    this.renderCalendar();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.container.remove();
                }
            }, {
                key: "getCell",
                value: function getCell(date) {
                    var dateStrValue = this.calendar.dateToStringValue(date);
                    return this.elements.calendar.querySelector('.brx-calendar__date-button[data-date="' + dateStrValue + '"]');
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this23 = this;

                    this.elements.calendar.addEventListener('click', function (e) {
                        var cellButton = e.target.closest('.brx-calendar__date-button');
                        if (!cellButton || !_this23.elements.calendar.contains(cellButton)) return;

                        var dateCell = cellButton.parentElement;
                        if (dateCell.classList.contains('brx-calendar__date-disabled') || dateCell.classList.contains('brx-calendar__date-empty')) {
                            return;
                        }

                        var dateValue = cellButton.dataset.date;
                        if (!dateValue) return;

                        var priceEl = cellButton.querySelector('.price');
                        var price = priceEl ? priceEl.dataset.price : 0;
                        var allow = cellButton.dataset.allow;

                        var clickedDate = _this23.calendar.getDateFromValue(dateValue);

                        if (_this23.selectionMode === 'range') {
                            _this23.selectRangeDate(clickedDate);
                            _this23.updateSelectedRange();

                            if (!_this23.silentMode && _this23.on.change) {
                                _this23.on.change({
                                    start: _this23.range.start,
                                    end: _this23.range.end,
                                    price: price,
                                    allow: allow
                                });
                            }
                        }
                    });
                }
            }, {
                key: "selectRangeDate",
                value: function selectRangeDate(date) {
                    if (!this.range.start || this.range.start && this.range.end) {
                        this.range.start = date;
                        this.range.end = null;
                    } else if (this.range.start && !this.range.end) {
                        if (date.getTime() > this.range.start.getTime()) {
                            this.range.end = date;
                        } else {
                            this.range.start = date;
                            this.range.end = null;
                        }
                    }
                }
            }, {
                key: "updateSelectedRange",
                value: function updateSelectedRange() {
                    var calendar = this.elements.calendar;

                    // Удаляем все классы диапазона и выделения
                    calendar.querySelectorAll("." + DATE_IN_RAGE).forEach(function (el) {
                        el.classList.remove(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                    });

                    calendar.querySelectorAll("." + DATE_SELECTED).forEach(function (el) {
                        el.classList.remove(DATE_SELECTED);
                    });

                    // Если выбраны обе границы диапазона
                    if (this.range.start && this.range.end) {
                        var current = new Date(this.range.start);
                        while (current <= this.range.end) {
                            var cell = this.getCell(current);
                            if (!cell) {
                                current.setDate(current.getDate() + 1);
                                continue;
                            }

                            if (this.isSameDate(current, this.range.start)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START);
                            } else if (this.isSameDate(current, this.range.end)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_END);
                            } else {
                                cell.classList.add(DATE_IN_RAGE);
                            }

                            current.setDate(current.getDate() + 1);
                        }

                        var endCell = this.getCell(this.range.end);
                        if (endCell) {
                            endCell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_END);
                        }
                    }
                    // Если выбрана только начальная дата
                    else if (this.range.start) {
                            var startCell = this.getCell(this.range.start);
                            if (startCell) {
                                startCell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                            }
                        }
                }
            }, {
                key: "clearRange",
                value: function clearRange() {
                    this.range = { start: null, end: null };
                    this.updateSelectedRange();
                }
            }, {
                key: "renderContainer",
                value: function renderContainer() {
                    this.container.innerHTML = "\n        <div class=\"brx-datepicker__container\">\n            <div class=\"brx-datepicker__controls\">\n                <div class=\"brx-datepicker__control previous\" role=\"button\">\n                    <span class=\"sr-only\">\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439</span>\n                </div>\n                <div class=\"brx-datepicker__control next\" role=\"button\">\n                    <span class=\"sr-only\">\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439</span>\n                </div>\n            </div>\n            <div class=\"brx-datepicker__content\"></div>\n        </div>\n    ";
                }
            }, {
                key: "renderCalendar",
                value: function renderCalendar() {
                    if (this.viewMode === MODE_FULL_RANGE) {
                        this._renderCalendarFullRange();
                    }
                }
            }, {
                key: "_renderCalendarFullRange",
                value: function _renderCalendarFullRange() {
                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    if (!minDate || !maxDate) {
                        var renderMonths = 11;
                        minDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
                        maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths, 0);
                    }

                    var renderTillMonth = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 1);
                    var renderFromMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

                    var calendarHtml = '';

                    do {
                        calendarHtml += this.calendar.renderMonth(renderFromMonth.getMonth(), renderFromMonth.getFullYear());
                        renderFromMonth = new Date(renderFromMonth.getFullYear(), renderFromMonth.getMonth() + 1, 1);
                    } while (!this.isSameMonth(renderFromMonth, renderTillMonth));

                    this.elements.calendar.innerHTML = calendarHtml;
                    this.renderedMaxMonthStart = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
                    // this.scrollToActiveMonth();

                    if (this.on.onReadyCalendar) {
                        this.on.onReadyCalendar();
                    }
                }
            }, {
                key: "appendMonthsTo",
                value: function appendMonthsTo(maxDate) {
                    var targetMaxDate = maxDate instanceof Date ? maxDate : new Date(maxDate);
                    if (isNaN(targetMaxDate)) {
                        return;
                    }

                    if (!this.renderedMaxMonthStart) {
                        this.renderCalendar();
                        return;
                    }

                    var targetMonthStart = new Date(targetMaxDate.getFullYear(), targetMaxDate.getMonth(), 1);

                    if (this.renderedMaxMonthStart.getTime() >= targetMonthStart.getTime()) {
                        return;
                    }

                    var nextMonthStart = new Date(this.renderedMaxMonthStart.getFullYear(), this.renderedMaxMonthStart.getMonth() + 1, 1);
                    var appendHtml = '';

                    while (nextMonthStart.getTime() <= targetMonthStart.getTime()) {
                        appendHtml += this.calendar.renderMonth(nextMonthStart.getMonth(), nextMonthStart.getFullYear());
                        nextMonthStart = new Date(nextMonthStart.getFullYear(), nextMonthStart.getMonth() + 1, 1);
                    }

                    if (appendHtml) {
                        this.elements.calendar.insertAdjacentHTML('beforeend', appendHtml);
                        this.renderedMaxMonthStart = targetMonthStart;
                    }
                }
            }, {
                key: "scrollToActiveMonth",
                value: function scrollToActiveMonth() {
                    var firstDateCell = this.getCell(this.currentMonth);
                    if (!firstDateCell) return;

                    var month = firstDateCell.closest('.brx-calendar__wrapper');
                    if (!month) return;

                    var offsetTop = this.getContainerOffsetTop();

                    window.scrollTo({
                        top: month.getBoundingClientRect().top + window.scrollY - offsetTop,
                        behavior: 'smooth'
                    });
                }
            }, {
                key: "getContainerOffsetTop",
                value: function getContainerOffsetTop() {
                    if (!this.containerOffsetTop) {
                        var datepickerContainer = this.container.querySelector('.brx-datepicker__container');
                        this.containerOffsetTop = datepickerContainer ? datepickerContainer.offsetTop : 50;
                    }
                    return this.containerOffsetTop;
                }
            }, {
                key: "isSameMonth",
                value: function isSameMonth(date1, date2) {
                    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
                }
            }, {
                key: "isSameDate",
                value: function isSameDate(date1, date2) {
                    return this.isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
                }
            }, {
                key: "setSelectedDates",
                value: function setSelectedDates(date) {
                    this.range = {
                        start: date.start ? new Date(date.start) : null,
                        end: date.end ? new Date(date.end) : null
                    };
                    this.updateSelectedRange();
                }
            }, {
                key: "settings",
                get: function get() {
                    return this.calendar.settings;
                }
            }]);

            return NewAviaDatepicker;
        }();

        module.exports = {
            NewAviaDatepicker: NewAviaDatepicker
        };
    }, { "./NewCalendarMonth": 2 }], 2: [function (require, module, exports) {
        var _require4 = require('./calendar-labels-ru'),
            monthNames = _require4.monthNames,
            weekDayNamesShort = _require4.weekDayNamesShort;

        var NewCalendarSettings = require('./NewCalendarSettings');

        var NewCalendarMonth = function () {
            /**
             * @param {CalendarSettings|null} settings
             */
            function NewCalendarMonth() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _classCallCheck(this, NewCalendarMonth);

                /** @type {CalendarSettings} */
                this.settings = settings !== null ? settings : new NewCalendarSettings();
                var messages = this.settings.messages;
                this.monthNames = messages ? messages.monthNames : monthNames;
                this.weekDayNamesShort = messages ? messages.weekDayNamesShort : weekDayNamesShort;
            }

            /**
             * @param {number} month - 0-11
             * @param {number} fullYear
             * @return {string}
             */


            _createClass(NewCalendarMonth, [{
                key: "renderMonth",
                value: function renderMonth(month, fullYear) {
                    var baseDate = new Date(fullYear, month, 1);
                    // Первый день месяца
                    var firstDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
                    // последний день месяца
                    var lastDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
                    // Последний день предыдущего месяца
                    var lastDateOfPrevMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

                    var firstDay = this.settings.firstDay;

                    var i = void 0;
                    var weekDay = void 0;
                    var weekDaysCellsHtml = '';
                    var startWeekDay = null;
                    var endWeekDay = null;
                    for (i = 0; i < 7; i++) {
                        weekDay = i + firstDay;
                        weekDay = weekDay > 6 ? weekDay - 7 : weekDay;
                        if (startWeekDay === null) {
                            startWeekDay = weekDay;
                        }
                        endWeekDay = weekDay;
                        weekDaysCellsHtml += '<td class="brx-calendar__day-name">' + this.weekDayNamesShort[i] + '</td>';
                    }

                    // Пустые клетки предыдущего месяца
                    var prevMonthEmptyCellCount = firstDateOfMonth.getDay() - firstDay;
                    if (prevMonthEmptyCellCount < 0) {
                        prevMonthEmptyCellCount = prevMonthEmptyCellCount + 7;
                    }
                    // Пустые клетки следующего месяца
                    // Если месяц заканчивается последним дней недели - 0
                    var nextMonthEmptyCellCount = lastDateOfMonth.getDay() === endWeekDay ? 0 : 7 + 1 - lastDateOfMonth.getDay() - firstDay;
                    // Кол-во дней в календаре
                    var datesCount = prevMonthEmptyCellCount + nextMonthEmptyCellCount + lastDateOfMonth.getDate();

                    // День предыдущего месяца, с которого начинается календарь
                    var prevMonthStartDate = lastDateOfPrevMonth.getDate() - prevMonthEmptyCellCount + 1;
                    // Начинаем рисовать с этой даты
                    var dateInstance = new Date(lastDateOfPrevMonth.getFullYear(), lastDateOfPrevMonth.getMonth(), prevMonthStartDate);
                    // dataInstance.getDay() === startWeekDay // Должно быть true

                    var calendarDatesHtml = '';
                    var rowHtml = '';
                    for (i = 0; i < datesCount; i++) {
                        rowHtml += this.getDateCell(dateInstance, dateInstance.getMonth() !== baseDate.getMonth());
                        if (endWeekDay === dateInstance.getDay()) {
                            // Конец недели
                            calendarDatesHtml += '<tr class="brx-calendar__row">' + rowHtml + '</tr>';
                            rowHtml = '';
                        }
                        // сдвигаем дату на след. день
                        dateInstance = new Date(dateInstance.getFullYear(), dateInstance.getMonth(), dateInstance.getDate() + 1);
                    }

                    var monthLabel = this.monthNames[baseDate.getMonth()] + (this.settings.showYear ? ' ' + baseDate.getFullYear() : '');
                    return '<div class="brx-calendar__wrapper">' + '<div class="brx-calendar__month">' + monthLabel + '</div>' + '<table class="brx-calendar__dates">' + '<thead><tr class="brx-calendar__row">' + weekDaysCellsHtml + '</tr></thead>' + '<tbody>' + calendarDatesHtml + '</tbody>' + '</table>' + '</div>';
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {string} - table cell html
                 */

            }, {
                key: "getDateCell",
                value: function getDateCell(date, empty) {
                    var today = new Date();
                    var settings = this.getDateSettings(date, empty);

                    var classList = 'brx-calendar__date' + (empty ? ' brx-calendar__date-empty' : '');

                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    var disabled = empty;
                    if (minDate && minDate.getTime() > date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }
                    if (maxDate && maxDate.getTime() < date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }

                    if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
                        classList += ' today';
                    }
                    classList += settings.cssClass !== '' ? ' ' + settings.cssClass : '';

                    return '<td class="' + classList + '">' + (empty && !this.settings.showEmptyDate ? '&nbsp;' : this.renderDateCellButton(date)) + '</td>';
                }

                /**
                 * @private
                 * @param {Date} date
                 */

            }, {
                key: "renderDateCellButton",
                value: function renderDateCellButton(date) {
                    var dateStringValue = this.dateToStringValue(date);
                    return "<button type=\"button\"\n                        class=\"brx-calendar__date-button\"\n                        data-date=\"" + dateStringValue + "\"\n                        data-date-day=\"" + date.getDate() + "\">" + date.getDate() + "</button>";
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {{cssClass: string}}
                 * @private
                 */

            }, {
                key: "getDateSettings",
                value: function getDateSettings(date, empty) {
                    var cssClass = this.settings.getDateCellCustomCssClass ? this.settings.getDateCellCustomCssClass(date, empty) : '';
                    return { cssClass: cssClass };
                }

                /**
                 * Формат значения в data-date
                 * @param {Date} date
                 * @return {string}
                 */

            }, {
                key: "dateToStringValue",
                value: function dateToStringValue(date) {
                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);

                    return day + '.' + month + '.' + date.getFullYear();
                }

                /**
                 * relates to this.dateToStringValue()
                 * @param {string} dateStringValue - Формат как и в dateToStringValue
                 * @return {Date}
                 */

            }, {
                key: "getDateFromValue",
                value: function getDateFromValue(dateStringValue) {
                    var values = dateStringValue.split('.');
                    return new Date(values[2], values[1] - 1, values[0]);
                }
            }]);

            return NewCalendarMonth;
        }();

        module.exports = NewCalendarMonth;
    }, { "./NewCalendarSettings": 3, "./calendar-labels-ru": 4 }], 3: [function (require, module, exports) {
        var NewCalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function NewCalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, NewCalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(NewCalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages3 = settings.messages,
                            monthNames = _settings$messages3.monthNames,
                            weekDayNamesShort = _settings$messages3.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return NewCalendarSettings;
        }();

        module.exports = NewCalendarSettings;
    }, {}], 4: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewAviaCalendarDateUtils = function () {
            function NewAviaCalendarDateUtils() {
                _classCallCheck(this, NewAviaCalendarDateUtils);
            }

            _createClass(NewAviaCalendarDateUtils, null, [{
                key: "parseIsoDate",
                value: function parseIsoDate(value) {
                    if (!value) return null;
                    if (value instanceof Date) {
                        return this.normalizeDate(value);
                    }

                    if (typeof value === 'string') {
                        var match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
                        if (match) {
                            var year = Number(match[1]);
                            var month = Number(match[2]) - 1;
                            var day = Number(match[3]);
                            return new Date(year, month, day);
                        }
                    }

                    var date = new Date(value);
                    if (isNaN(date)) return null;
                    return this.normalizeDate(date);
                }
            }, {
                key: "normalizeDate",
                value: function normalizeDate(value) {
                    var date = value instanceof Date ? new Date(value) : new Date(value);
                    if (isNaN(date)) return null;

                    date.setHours(0, 0, 0, 0);
                    return date;
                }
            }, {
                key: "formatIsoDate",
                value: function formatIsoDate(value) {
                    var date = this.parseIsoDate(value);
                    if (!date) return '';

                    var yyyy = date.getFullYear();
                    var mm = String(date.getMonth() + 1).padStart(2, '0');
                    var dd = String(date.getDate()).padStart(2, '0');
                    return yyyy + '-' + mm + '-' + dd;
                }
            }]);

            return NewAviaCalendarDateUtils;
        }();

        window.NewAviaCalendarDateUtils = NewAviaCalendarDateUtils;
        module.exports = NewAviaCalendarDateUtils;
    }, {}], 2: [function (require, module, exports) {
        var NewAviaCalendarDateUtils = require('./NewAviaCalendarDateUtils');

        var NewAviaCalendarDates = function () {
            function NewAviaCalendarDates(props) {
                _classCallCheck(this, NewAviaCalendarDates);

                var departDate = document.querySelector('.avia-calendar-depart-date');
                var arrivalDate = document.querySelector('.avia-calendar-arrival-date');

                this.elements = {
                    departDate: departDate,
                    departDateValue: departDate ? departDate.querySelector('.value') : null,
                    resetDepartDateBtn: departDate ? departDate.querySelector('.reset-depart-date') : null,

                    arrivalDate: arrivalDate,
                    arrivalDateValue: arrivalDate ? arrivalDate.querySelector('.value') : null,
                    resetArrivalDateBtn: arrivalDate ? arrivalDate.querySelector('.reset-arrival-date') : null
                };

                this.ruDayMonthFormatter = new Intl.DateTimeFormat('ru-RU', {
                    day: 'numeric',
                    month: 'long'
                });

                this.departDate = null;

                this.bindEventListeners();
            }

            _createClass(NewAviaCalendarDates, [{
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this24 = this;

                    // слушаем пользовательское событие "_change-calendar"
                    document.body.addEventListener('_change-calendar', function (event) {
                        var params = event.detail;

                        if (params && params.start) {
                            _this24.setDepartDate(NewAviaCalendarDateUtils.formatIsoDate(params.start));
                        }

                        if (params && params.end) {
                            _this24.setArrivalDate(NewAviaCalendarDateUtils.formatIsoDate(params.end));
                        } else {
                            _this24.resetArrivalDate();
                        }
                    });

                    // делегирование кликов по кнопкам сброса
                    document.body.addEventListener('click', function (e) {
                        var target = e.target;

                        // Сброс даты вылета
                        if (target.closest('.reset-depart-date')) {
                            _this24.resetDepartDate();
                            document.body.dispatchEvent(new CustomEvent('_reset-depart-date'));
                            return;
                        }

                        // Сброс даты возвращения
                        if (target.closest('.reset-arrival-date')) {
                            _this24.resetArrivalDate();
                            document.body.dispatchEvent(new CustomEvent('_reset-arrival-date', {
                                detail: _this24.departDate
                            }));
                        }
                    });
                }
            }, {
                key: "setDepartDate",
                value: function setDepartDate(date) {
                    var formatted = this.formatDayMonth(date);
                    this.departDate = date || null;

                    if (this.elements.departDate) {
                        this.elements.departDate.classList.toggle('selected', !!date);
                    }

                    if (this.elements.resetDepartDateBtn) {
                        this.elements.resetDepartDateBtn.classList.toggle('hidden', !date);
                    }

                    if (this.elements.departDateValue) {
                        this.elements.departDateValue.textContent = formatted;
                    }
                }
            }, {
                key: "setArrivalDate",
                value: function setArrivalDate(date) {
                    var formatted = this.formatDayMonth(date);

                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.toggle('selected', !!date);
                    }

                    if (this.elements.resetArrivalDateBtn) {
                        this.elements.resetArrivalDateBtn.classList.toggle('hidden', !date);
                    }

                    if (this.elements.arrivalDateValue) {
                        this.elements.arrivalDateValue.textContent = formatted;
                    }
                }
            }, {
                key: "resetDepartDate",
                value: function resetDepartDate() {
                    this.departDate = null;

                    if (this.elements.departDate) {
                        this.elements.departDate.classList.remove('selected');
                    }

                    if (this.elements.resetDepartDateBtn) {
                        this.elements.resetDepartDateBtn.classList.add('hidden');
                    }

                    if (this.elements.departDateValue) {
                        this.elements.departDateValue.textContent = '';
                    }

                    this.resetArrivalDate();
                }
            }, {
                key: "showArrivalDate",
                value: function showArrivalDate() {
                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.remove('hidden');
                    }

                    if (this.elements.departDate) {
                        this.elements.departDate.classList.remove('full');
                    }
                }
            }, {
                key: "hideArrivalDate",
                value: function hideArrivalDate() {
                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.add('hidden');
                    }

                    if (this.elements.departDate) {
                        this.elements.departDate.classList.add('full');
                    }
                }
            }, {
                key: "resetArrivalDate",
                value: function resetArrivalDate() {
                    if (this.elements.arrivalDate) {
                        this.elements.arrivalDate.classList.remove('selected');
                    }

                    if (this.elements.resetArrivalDateBtn) {
                        this.elements.resetArrivalDateBtn.classList.add('hidden');
                    }

                    if (this.elements.arrivalDateValue) {
                        this.elements.arrivalDateValue.textContent = '';
                    }
                }
            }, {
                key: "formatDayMonth",
                value: function formatDayMonth(dateStr) {
                    if (!dateStr) return '';
                    var d = NewAviaCalendarDateUtils.parseIsoDate(dateStr);
                    if (isNaN(d)) return ''; // защита от битых дат
                    return this.ruDayMonthFormatter.format(d);
                }
            }]);

            return NewAviaCalendarDates;
        }();

        window.NewAviaCalendarDates = NewAviaCalendarDates;
    }, { "./NewAviaCalendarDateUtils": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewAviaCalendarApplyButton = function () {
            function NewAviaCalendarApplyButton(props) {
                _classCallCheck(this, NewAviaCalendarApplyButton);

                this.translations = props.translations;

                this.params = {
                    start: null, end: null, price: null, flyType: null
                };
                this.button = null;

                this.bindHandlers();
            }

            _createClass(NewAviaCalendarApplyButton, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this25 = this;

                    // Слушаем пользовательские события на body
                    document.body.addEventListener('_change-calendar', function (event) {
                        _this25.params = event.detail;
                        _this25.renderButton();
                    });

                    document.body.addEventListener('_reset-depart-date', function (event) {
                        var departDate = event.detail;
                        _this25.params.end = null;
                        _this25.params.start = departDate;
                        _this25.params.price = 0;
                        _this25.renderButton();
                    });

                    document.body.addEventListener('_reset-arrival-date', function (event) {
                        var departDate = event.detail;
                        _this25.params.end = null;
                        _this25.params.start = departDate;
                        _this25.params.price = 0;
                        _this25.renderButton();
                    });

                    // Делегирование клика по кнопке .apply-dates
                    document.body.addEventListener('click', function (e) {

                        var target = e.target.closest('.apply-dates');
                        var currentTarget = e.currentTarget.closest('.apply-dates');
                        if (target || currentTarget) {
                            _this25.apply();
                        }
                    });
                }
            }, {
                key: "renderButton",
                value: function renderButton() {
                    this.button = document.querySelector('.modal2-footer .apply-dates');
                    if (!this.button) return;

                    var departDate = this.formatDate(this.params.start);
                    var arrivalDate = this.formatDate(this.params.end);

                    if (!this.params.start) {
                        this.button.classList.add('hidden');
                        return;
                    }

                    if (this.params.start && !this.params.end) {
                        this.renderNoReturnButton();
                        return;
                    }

                    this.renderSelectButton(departDate, arrivalDate);
                }
            }, {
                key: "renderNoReturnButton",
                value: function renderNoReturnButton() {
                    this.button.classList.remove('hidden');
                    this.button.disabled = false;
                    this.button.innerHTML = "<span>" + this.translations.noNeedGoBack + "</span>";
                }
            }, {
                key: "renderSelectButton",
                value: function renderSelectButton(departDate, arrivalDate) {
                    var textPrice = this.params.price ? this.translations.of + " " + (+this.params.price).toLocaleString('ru-RU') + " \u20B8" : '';

                    this.button.classList.remove('hidden');
                    this.button.disabled = false;
                    this.button.innerHTML = "\n        <span>" + this.translations.select + ": " + departDate + " - " + arrivalDate + "</span>\n        <span class=\"price\">" + textPrice + "</span>\n    ";
                }
            }, {
                key: "formatDate",
                value: function formatDate(value) {
                    if (!value) return '';
                    return new Date(value).toLocaleDateString('ru-RU', {
                        day: 'numeric',
                        month: 'long'
                    });
                }
            }, {
                key: "resetParams",
                value: function resetParams() {
                    this.params = {
                        start: null, end: null, price: null, flyType: null
                    };
                }
            }, {
                key: "apply",
                value: function apply() {
                    var event = new CustomEvent('_change-avia-dates', {
                        detail: {
                            dateFrom: this.params.start,
                            dateTo: this.params.end,
                            flyType: this.params.flyType,
                            minPrice: this.params.price
                        }
                    });

                    document.body.dispatchEvent(event);

                    if (window.modal && typeof window.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }]);

            return NewAviaCalendarApplyButton;
        }();

        window.NewAviaCalendarApplyButton = NewAviaCalendarApplyButton;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewCalendarSettings = require("./NewCalendarSettings");

        var _require5 = require("./NewAviaDatepicker"),
            NewAviaDatepicker = _require5.NewAviaDatepicker;

        var NewAviaCalendarDateUtils = require("./NewAviaCalendarDateUtils");

        var NewAviaCalendar = function () {
            function NewAviaCalendar(props) {
                _classCallCheck(this, NewAviaCalendar);

                this.startDateWithPrice = new Date();
                this.endDateWithPrice = new Date();
                this.prices = {};
                this.bestPricesDates = new Set();
                this.flyType = null;
                this.currency = null;

                this.bindHandlers();
            }

            _createClass(NewAviaCalendar, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this26 = this;

                    document.body.addEventListener('_reset-depart-date', function (event) {
                        _this26.setSelectedDates(null, null);
                        _this26.renderPrices();
                    });

                    document.body.addEventListener('_reset-arrival-date', function (event) {
                        var date = event.detail;
                        _this26.setSelectedDates(date, null);
                        _this26.renderPrices();
                    });
                }
            }, {
                key: "init",
                value: function init(prices, flyType) {
                    var _this27 = this;

                    this.prices = prices && prices.prices ? prices.prices : {};
                    this.currency = prices && prices.currency ? prices.currency : null;
                    this.bestPricesDates = new Set(prices && Array.isArray(prices.bestPricesDates) ? prices.bestPricesDates : []);
                    this.flyType = flyType;
                    this.minDate = NewAviaCalendarDateUtils.parseIsoDate(prices && prices.dateFrom ? prices.dateFrom : null);
                    this.maxDate = NewAviaCalendarDateUtils.parseIsoDate(prices && prices.dateTo ? prices.dateTo : null);

                    this.startDateWithPrice = null;
                    this.endDateWithPrice = null;

                    this.getStartDateWithPrice();

                    this.datepicker = new NewAviaDatepicker({
                        containerId: 'aviaCalendarContent',
                        selectedDate: this.startDateWithPrice,
                        viewMode: 'range',
                        onChange: function onChange(data) {
                            _this27.renderPrices();

                            document.body.dispatchEvent(new CustomEvent('_change-calendar', { detail: data }));
                        },
                        onReadyCalendar: function onReadyCalendar() {
                            _this27.renderPrices();
                        }
                    }, this.calendarSettings());

                    this.datepicker.init();
                }
            }, {
                key: "getStartDateWithPrice",
                value: function getStartDateWithPrice() {
                    if (this.minDate && this.maxDate) {
                        this.startDateWithPrice = new Date(this.minDate);
                        this.endDateWithPrice = new Date(this.maxDate);
                        return;
                    }

                    var allDates = Object.keys(this.prices || {});
                    if (!allDates.length) {
                        this.startDateWithPrice = new Date();
                        this.endDateWithPrice = new Date();
                        return;
                    }

                    var minDateStr = allDates.reduce(function (min, current) {
                        return current < min ? current : min;
                    });
                    var maxDateStr = allDates.reduce(function (max, current) {
                        return current > max ? current : max;
                    });

                    this.startDateWithPrice = new Date(minDateStr);
                    this.endDateWithPrice = new Date(maxDateStr);
                }
            }, {
                key: "calendarSettings",
                value: function calendarSettings() {
                    var _createCalendarDateBo2 = this.createCalendarDateBounds(),
                        minDate = _createCalendarDateBo2.minDate,
                        maxDate = _createCalendarDateBo2.maxDate;

                    return new NewCalendarSettings({
                        minDate: minDate,
                        maxDate: maxDate,
                        showYear: true,
                        showEmptyDate: false
                    });
                }
            }, {
                key: "createCalendarDateBounds",
                value: function createCalendarDateBounds() {
                    var renderMonths = 11;
                    var minDate = new Date();
                    var fallbackMaxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths + 1, 0);
                    var priceMaxDate = new Date(this.endDateWithPrice);
                    var priceMaxMonthEnd = !isNaN(priceMaxDate) ? new Date(priceMaxDate.getFullYear(), priceMaxDate.getMonth() + 1, 0) : null;
                    var maxDate = priceMaxMonthEnd && priceMaxMonthEnd.getTime() > fallbackMaxDate.getTime() ? priceMaxMonthEnd : fallbackMaxDate;

                    minDate.setHours(0, 0, 0, 0);
                    maxDate.setHours(23, 59, 59);

                    return { minDate: minDate, maxDate: maxDate };
                }
            }, {
                key: "renderPrices",
                value: function renderPrices() {
                    this.renderPricesHtml(this.prices);
                }
            }, {
                key: "updateData",
                value: function updateData(prices) {
                    var prevMaxDate = this.maxDate ? new Date(this.maxDate) : null;
                    this.prices = prices && prices.prices ? prices.prices : {};
                    this.currency = prices && prices.currency ? prices.currency : this.currency;
                    this.bestPricesDates = new Set(prices && Array.isArray(prices.bestPricesDates) ? prices.bestPricesDates : []);
                    this.flyType = prices && prices.flyType ? prices.flyType : this.flyType;
                    this.minDate = NewAviaCalendarDateUtils.parseIsoDate(prices && prices.dateFrom ? prices.dateFrom : null);
                    this.maxDate = NewAviaCalendarDateUtils.parseIsoDate(prices && prices.dateTo ? prices.dateTo : null);

                    if (this.datepicker && this.maxDate && this.datepicker.appendMonthsTo && (!prevMaxDate || this.maxDate.getTime() > prevMaxDate.getTime())) {
                        this.datepicker.appendMonthsTo(this.maxDate);
                    }

                    this.renderPrices();
                }
            }, {
                key: "renderPricesHtml",
                value: function renderPricesHtml(pricesMap) {
                    var _this28 = this;

                    var dateButtons = document.querySelectorAll('.brx-calendar__date-button');
                    var normalizedPrices = pricesMap || {};

                    dateButtons.forEach(function (btn) {
                        var parent = btn.closest('.brx-calendar__date');
                        var date = btn.dataset.date;
                        var normalizedDate = _this28.parseUIDateToYMD(date);
                        var isBeforeToday = _this28.isDateBeforeToday(normalizedDate);
                        var rawPrice = Object.prototype.hasOwnProperty.call(normalizedPrices, normalizedDate) ? normalizedPrices[normalizedDate] : null;
                        var fullPrice = Number(rawPrice);
                        var hasPrice = rawPrice !== null && rawPrice !== '' && isFinite(fullPrice);
                        var isBestPriceDate = hasPrice && _this28.bestPricesDates.has(normalizedDate);

                        btn.querySelectorAll('.price').forEach(function (priceEl) {
                            return priceEl.remove();
                        });
                        btn.classList.remove('best-price-date');
                        btn.style.removeProperty('color');
                        btn.style.removeProperty('border-color');
                        btn.style.removeProperty('background-color');
                        parent.classList.remove('best-price-date');

                        if (!isBeforeToday) {
                            parent.classList.remove('brx-calendar__date-disabled');
                            btn.classList.remove('disabled-date');

                            if (hasPrice) {
                                var shortPrice = _this28.formatCalendarPrice(fullPrice);

                                btn.insertAdjacentHTML('beforeend', "<span class=\"price price--formatted\" data-price=\"" + fullPrice + "\">" + shortPrice + "</span>");
                            }

                            if (isBestPriceDate) {
                                parent.classList.add('best-price-date');
                                btn.classList.add('best-price-date');
                                btn.style.color = '#169b62';
                                btn.style.borderColor = '#169b62';

                                var priceElement = btn.querySelector('.price');
                                if (priceElement) {
                                    priceElement.style.color = '#169b62';
                                    priceElement.style.fontWeight = '700';
                                }
                            }
                        }
                    });
                }
            }, {
                key: "formatCalendarPrice",
                value: function formatCalendarPrice(price) {
                    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currency;

                    var fullPrice = Number(price);
                    if (!isFinite(fullPrice)) {
                        return '';
                    }

                    if (this.isKztCurrency(currency)) {
                        return Math.round(fullPrice / 1000).toLocaleString('ru-RU') + 'K';
                    }

                    if (Math.abs(fullPrice) < 1000) {
                        return Math.round(fullPrice).toLocaleString('ru-RU');
                    }

                    return (Math.round(fullPrice / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'K';
                }
            }, {
                key: "isKztCurrency",
                value: function isKztCurrency(currency) {
                    var normalizedCurrency = String(currency || '').toLowerCase();
                    return normalizedCurrency === 'kzt' || normalizedCurrency === '₸';
                }
            }, {
                key: "setSelectedDates",
                value: function setSelectedDates(dateFrom, dateTo) {
                    if (!this.datepicker) return;

                    this.datepicker.setSelectedDates({ start: dateFrom, end: dateTo });
                    this.renderPrices();
                }
            }, {
                key: "parseUIDateToYMD",
                value: function parseUIDateToYMD(dateStr) {
                    // из "10.07.2025" сделаем "2025-07-10"
                    var _dateStr$split3 = dateStr.split('.'),
                        _dateStr$split4 = _slicedToArray(_dateStr$split3, 3),
                        day = _dateStr$split4[0],
                        month = _dateStr$split4[1],
                        year = _dateStr$split4[2];

                    return year + "-" + month + "-" + day;
                }
            }, {
                key: "isDateInCalendarRange",
                value: function isDateInCalendarRange(dateString) {
                    var date = NewAviaCalendarDateUtils.parseIsoDate(dateString);
                    if (!date) return false;

                    return !this.isDateBeforeToday(dateString);
                }
            }, {
                key: "isDateBeforeToday",
                value: function isDateBeforeToday(dateString) {
                    var date = NewAviaCalendarDateUtils.parseIsoDate(dateString);
                    var today = NewAviaCalendarDateUtils.normalizeDate(new Date());

                    if (!date || !today) return true;

                    return date.getTime() < today.getTime();
                }
            }, {
                key: "isSelectedDate",
                value: function isSelectedDate(dateString, selectedDate) {
                    if (!dateString || !selectedDate) return false;
                    return dateString === NewAviaCalendarDateUtils.formatIsoDate(selectedDate);
                }
            }]);

            return NewAviaCalendar;
        }();

        window.NewAviaCalendar = NewAviaCalendar;
    }, { "./NewAviaCalendarDateUtils": 2, "./NewAviaDatepicker": 3, "./NewCalendarSettings": 5 }], 2: [function (require, module, exports) {
        var NewAviaCalendarDateUtils = function () {
            function NewAviaCalendarDateUtils() {
                _classCallCheck(this, NewAviaCalendarDateUtils);
            }

            _createClass(NewAviaCalendarDateUtils, null, [{
                key: "parseIsoDate",
                value: function parseIsoDate(value) {
                    if (!value) return null;
                    if (value instanceof Date) {
                        return this.normalizeDate(value);
                    }

                    if (typeof value === 'string') {
                        var match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
                        if (match) {
                            var year = Number(match[1]);
                            var month = Number(match[2]) - 1;
                            var day = Number(match[3]);
                            return new Date(year, month, day);
                        }
                    }

                    var date = new Date(value);
                    if (isNaN(date)) return null;
                    return this.normalizeDate(date);
                }
            }, {
                key: "normalizeDate",
                value: function normalizeDate(value) {
                    var date = value instanceof Date ? new Date(value) : new Date(value);
                    if (isNaN(date)) return null;

                    date.setHours(0, 0, 0, 0);
                    return date;
                }
            }, {
                key: "formatIsoDate",
                value: function formatIsoDate(value) {
                    var date = this.parseIsoDate(value);
                    if (!date) return '';

                    var yyyy = date.getFullYear();
                    var mm = String(date.getMonth() + 1).padStart(2, '0');
                    var dd = String(date.getDate()).padStart(2, '0');
                    return yyyy + '-' + mm + '-' + dd;
                }
            }]);

            return NewAviaCalendarDateUtils;
        }();

        window.NewAviaCalendarDateUtils = NewAviaCalendarDateUtils;
        module.exports = NewAviaCalendarDateUtils;
    }, {}], 3: [function (require, module, exports) {
        // ... Оставим тут require без изменений
        var NewCalendarMonth = require('./NewCalendarMonth');

        var DATE_IN_RAGE = 'date-in-range';
        var DATE_IN_RAGE_START = 'date-in-range-start';
        var DATE_IN_RAGE_END = 'date-in-range-end';
        var DATE_SELECTED = 'selected';
        var DATE_SELECTED_ONE = 'selected--one';

        var MODE_FULL_RANGE = 'range';

        var NewAviaDatepicker = function () {
            function NewAviaDatepicker(params) {
                var calendarSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                _classCallCheck(this, NewAviaDatepicker);

                this.containerId = params.containerId;
                this.container = document.querySelector('#' + this.containerId);
                this.container.classList.add('brx-datepicker-container');
                this.viewMode = params.viewMode;

                this.silentMode = false;

                this.calendar = new NewCalendarMonth(calendarSettings);

                this.selectedDate = params.selectedDate;
                this.currentMonth = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);

                this.range = { start: null, end: null };
                this.selectionMode = params.selectionMode ? params.selectionMode : 'single';

                this.on = {
                    change: 'onChange' in params ? params.onChange : null,
                    changeMonth: 'changeMonth' in params ? params.changeMonth : null,
                    onReadyCalendar: 'onReadyCalendar' in params ? params.onReadyCalendar : null
                };

                this.elements = { calendar: null, controls: null };
                this.renderedMaxMonthStart = null;
            }

            _createClass(NewAviaDatepicker, [{
                key: "init",
                value: function init() {
                    this.renderContainer();
                    this.elements = {
                        calendar: this.container.querySelector('.brx-datepicker__content'),
                        controls: this.container.querySelector('.brx-datepicker__controls')
                    };
                    this.renderCalendar();
                    this.bindEventListeners();
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    this.renderCalendar();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.container.remove();
                }
            }, {
                key: "getCell",
                value: function getCell(date) {
                    var dateStrValue = this.calendar.dateToStringValue(date);
                    return this.elements.calendar.querySelector('.brx-calendar__date-button[data-date="' + dateStrValue + '"]');
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this29 = this;

                    this.elements.calendar.addEventListener('click', function (e) {
                        var cellButton = e.target.closest('.brx-calendar__date-button');
                        if (!cellButton || !_this29.elements.calendar.contains(cellButton)) return;

                        var dateCell = cellButton.parentElement;
                        if (dateCell.classList.contains('brx-calendar__date-disabled') || dateCell.classList.contains('brx-calendar__date-empty')) {
                            return;
                        }

                        var dateValue = cellButton.dataset.date;
                        if (!dateValue) return;

                        var priceEl = cellButton.querySelector('.price');
                        var price = priceEl ? priceEl.dataset.price : 0;
                        var allow = cellButton.dataset.allow;

                        var clickedDate = _this29.calendar.getDateFromValue(dateValue);

                        if (_this29.selectionMode === 'range') {
                            _this29.selectRangeDate(clickedDate);
                            _this29.updateSelectedRange();

                            if (!_this29.silentMode && _this29.on.change) {
                                _this29.on.change({
                                    start: _this29.range.start,
                                    end: _this29.range.end,
                                    price: price,
                                    allow: allow
                                });
                            }
                        }
                    });
                }
            }, {
                key: "selectRangeDate",
                value: function selectRangeDate(date) {
                    if (!this.range.start || this.range.start && this.range.end) {
                        this.range.start = date;
                        this.range.end = null;
                    } else if (this.range.start && !this.range.end) {
                        if (date.getTime() > this.range.start.getTime()) {
                            this.range.end = date;
                        } else {
                            this.range.start = date;
                            this.range.end = null;
                        }
                    }
                }
            }, {
                key: "updateSelectedRange",
                value: function updateSelectedRange() {
                    var calendar = this.elements.calendar;

                    // Удаляем все классы диапазона и выделения
                    calendar.querySelectorAll("." + DATE_IN_RAGE).forEach(function (el) {
                        el.classList.remove(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                    });

                    calendar.querySelectorAll("." + DATE_SELECTED).forEach(function (el) {
                        el.classList.remove(DATE_SELECTED);
                    });

                    // Если выбраны обе границы диапазона
                    if (this.range.start && this.range.end) {
                        var current = new Date(this.range.start);
                        while (current <= this.range.end) {
                            var cell = this.getCell(current);
                            if (!cell) {
                                current.setDate(current.getDate() + 1);
                                continue;
                            }

                            if (this.isSameDate(current, this.range.start)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START);
                            } else if (this.isSameDate(current, this.range.end)) {
                                cell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_END);
                            } else {
                                cell.classList.add(DATE_IN_RAGE);
                            }

                            current.setDate(current.getDate() + 1);
                        }

                        var endCell = this.getCell(this.range.end);
                        if (endCell) {
                            endCell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_END);
                        }
                    }
                    // Если выбрана только начальная дата
                    else if (this.range.start) {
                            var startCell = this.getCell(this.range.start);
                            if (startCell) {
                                startCell.classList.add(DATE_IN_RAGE, DATE_IN_RAGE_START, DATE_IN_RAGE_END, DATE_SELECTED_ONE);
                            }
                        }
                }
            }, {
                key: "clearRange",
                value: function clearRange() {
                    this.range = { start: null, end: null };
                    this.updateSelectedRange();
                }
            }, {
                key: "renderContainer",
                value: function renderContainer() {
                    this.container.innerHTML = "\n        <div class=\"brx-datepicker__container\">\n            <div class=\"brx-datepicker__controls\">\n                <div class=\"brx-datepicker__control previous\" role=\"button\">\n                    <span class=\"sr-only\">\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439</span>\n                </div>\n                <div class=\"brx-datepicker__control next\" role=\"button\">\n                    <span class=\"sr-only\">\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439</span>\n                </div>\n            </div>\n            <div class=\"brx-datepicker__content\"></div>\n        </div>\n    ";
                }
            }, {
                key: "renderCalendar",
                value: function renderCalendar() {
                    if (this.viewMode === MODE_FULL_RANGE) {
                        this._renderCalendarFullRange();
                    }
                }
            }, {
                key: "_renderCalendarFullRange",
                value: function _renderCalendarFullRange() {
                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    if (!minDate || !maxDate) {
                        var renderMonths = 11;
                        minDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
                        maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths, 0);
                    }

                    var renderTillMonth = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 1);
                    var renderFromMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

                    var calendarHtml = '';

                    do {
                        calendarHtml += this.calendar.renderMonth(renderFromMonth.getMonth(), renderFromMonth.getFullYear());
                        renderFromMonth = new Date(renderFromMonth.getFullYear(), renderFromMonth.getMonth() + 1, 1);
                    } while (!this.isSameMonth(renderFromMonth, renderTillMonth));

                    this.elements.calendar.innerHTML = calendarHtml;
                    this.renderedMaxMonthStart = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
                    // this.scrollToActiveMonth();

                    if (this.on.onReadyCalendar) {
                        this.on.onReadyCalendar();
                    }
                }
            }, {
                key: "appendMonthsTo",
                value: function appendMonthsTo(maxDate) {
                    var targetMaxDate = maxDate instanceof Date ? maxDate : new Date(maxDate);
                    if (isNaN(targetMaxDate)) {
                        return;
                    }

                    if (!this.renderedMaxMonthStart) {
                        this.renderCalendar();
                        return;
                    }

                    var targetMonthStart = new Date(targetMaxDate.getFullYear(), targetMaxDate.getMonth(), 1);

                    if (this.renderedMaxMonthStart.getTime() >= targetMonthStart.getTime()) {
                        return;
                    }

                    var nextMonthStart = new Date(this.renderedMaxMonthStart.getFullYear(), this.renderedMaxMonthStart.getMonth() + 1, 1);
                    var appendHtml = '';

                    while (nextMonthStart.getTime() <= targetMonthStart.getTime()) {
                        appendHtml += this.calendar.renderMonth(nextMonthStart.getMonth(), nextMonthStart.getFullYear());
                        nextMonthStart = new Date(nextMonthStart.getFullYear(), nextMonthStart.getMonth() + 1, 1);
                    }

                    if (appendHtml) {
                        this.elements.calendar.insertAdjacentHTML('beforeend', appendHtml);
                        this.renderedMaxMonthStart = targetMonthStart;
                    }
                }
            }, {
                key: "scrollToActiveMonth",
                value: function scrollToActiveMonth() {
                    var firstDateCell = this.getCell(this.currentMonth);
                    if (!firstDateCell) return;

                    var month = firstDateCell.closest('.brx-calendar__wrapper');
                    if (!month) return;

                    var offsetTop = this.getContainerOffsetTop();

                    window.scrollTo({
                        top: month.getBoundingClientRect().top + window.scrollY - offsetTop,
                        behavior: 'smooth'
                    });
                }
            }, {
                key: "getContainerOffsetTop",
                value: function getContainerOffsetTop() {
                    if (!this.containerOffsetTop) {
                        var datepickerContainer = this.container.querySelector('.brx-datepicker__container');
                        this.containerOffsetTop = datepickerContainer ? datepickerContainer.offsetTop : 50;
                    }
                    return this.containerOffsetTop;
                }
            }, {
                key: "isSameMonth",
                value: function isSameMonth(date1, date2) {
                    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
                }
            }, {
                key: "isSameDate",
                value: function isSameDate(date1, date2) {
                    return this.isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
                }
            }, {
                key: "setSelectedDates",
                value: function setSelectedDates(date) {
                    this.range = {
                        start: date.start ? new Date(date.start) : null,
                        end: date.end ? new Date(date.end) : null
                    };
                    this.updateSelectedRange();
                }
            }, {
                key: "settings",
                get: function get() {
                    return this.calendar.settings;
                }
            }]);

            return NewAviaDatepicker;
        }();

        module.exports = {
            NewAviaDatepicker: NewAviaDatepicker
        };
    }, { "./NewCalendarMonth": 4 }], 4: [function (require, module, exports) {
        var _require6 = require('./calendar-labels-ru'),
            monthNames = _require6.monthNames,
            weekDayNamesShort = _require6.weekDayNamesShort;

        var NewCalendarSettings = require('./NewCalendarSettings');

        var NewCalendarMonth = function () {
            /**
             * @param {CalendarSettings|null} settings
             */
            function NewCalendarMonth() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _classCallCheck(this, NewCalendarMonth);

                /** @type {CalendarSettings} */
                this.settings = settings !== null ? settings : new NewCalendarSettings();
                var messages = this.settings.messages;
                this.monthNames = messages ? messages.monthNames : monthNames;
                this.weekDayNamesShort = messages ? messages.weekDayNamesShort : weekDayNamesShort;
            }

            /**
             * @param {number} month - 0-11
             * @param {number} fullYear
             * @return {string}
             */


            _createClass(NewCalendarMonth, [{
                key: "renderMonth",
                value: function renderMonth(month, fullYear) {
                    var baseDate = new Date(fullYear, month, 1);
                    // Первый день месяца
                    var firstDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
                    // последний день месяца
                    var lastDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
                    // Последний день предыдущего месяца
                    var lastDateOfPrevMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

                    var firstDay = this.settings.firstDay;

                    var i = void 0;
                    var weekDay = void 0;
                    var weekDaysCellsHtml = '';
                    var startWeekDay = null;
                    var endWeekDay = null;
                    for (i = 0; i < 7; i++) {
                        weekDay = i + firstDay;
                        weekDay = weekDay > 6 ? weekDay - 7 : weekDay;
                        if (startWeekDay === null) {
                            startWeekDay = weekDay;
                        }
                        endWeekDay = weekDay;
                        weekDaysCellsHtml += '<td class="brx-calendar__day-name">' + this.weekDayNamesShort[i] + '</td>';
                    }

                    // Пустые клетки предыдущего месяца
                    var prevMonthEmptyCellCount = firstDateOfMonth.getDay() - firstDay;
                    if (prevMonthEmptyCellCount < 0) {
                        prevMonthEmptyCellCount = prevMonthEmptyCellCount + 7;
                    }
                    // Пустые клетки следующего месяца
                    // Если месяц заканчивается последним дней недели - 0
                    var nextMonthEmptyCellCount = lastDateOfMonth.getDay() === endWeekDay ? 0 : 7 + 1 - lastDateOfMonth.getDay() - firstDay;
                    // Кол-во дней в календаре
                    var datesCount = prevMonthEmptyCellCount + nextMonthEmptyCellCount + lastDateOfMonth.getDate();

                    // День предыдущего месяца, с которого начинается календарь
                    var prevMonthStartDate = lastDateOfPrevMonth.getDate() - prevMonthEmptyCellCount + 1;
                    // Начинаем рисовать с этой даты
                    var dateInstance = new Date(lastDateOfPrevMonth.getFullYear(), lastDateOfPrevMonth.getMonth(), prevMonthStartDate);
                    // dataInstance.getDay() === startWeekDay // Должно быть true

                    var calendarDatesHtml = '';
                    var rowHtml = '';
                    for (i = 0; i < datesCount; i++) {
                        rowHtml += this.getDateCell(dateInstance, dateInstance.getMonth() !== baseDate.getMonth());
                        if (endWeekDay === dateInstance.getDay()) {
                            // Конец недели
                            calendarDatesHtml += '<tr class="brx-calendar__row">' + rowHtml + '</tr>';
                            rowHtml = '';
                        }
                        // сдвигаем дату на след. день
                        dateInstance = new Date(dateInstance.getFullYear(), dateInstance.getMonth(), dateInstance.getDate() + 1);
                    }

                    var monthLabel = this.monthNames[baseDate.getMonth()] + (this.settings.showYear ? ' ' + baseDate.getFullYear() : '');
                    return '<div class="brx-calendar__wrapper">' + '<div class="brx-calendar__month">' + monthLabel + '</div>' + '<table class="brx-calendar__dates">' + '<thead><tr class="brx-calendar__row">' + weekDaysCellsHtml + '</tr></thead>' + '<tbody>' + calendarDatesHtml + '</tbody>' + '</table>' + '</div>';
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {string} - table cell html
                 */

            }, {
                key: "getDateCell",
                value: function getDateCell(date, empty) {
                    var today = new Date();
                    var settings = this.getDateSettings(date, empty);

                    var classList = 'brx-calendar__date' + (empty ? ' brx-calendar__date-empty' : '');

                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    var disabled = empty;
                    if (minDate && minDate.getTime() > date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }
                    if (maxDate && maxDate.getTime() < date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }

                    if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
                        classList += ' today';
                    }
                    classList += settings.cssClass !== '' ? ' ' + settings.cssClass : '';

                    return '<td class="' + classList + '">' + (empty && !this.settings.showEmptyDate ? '&nbsp;' : this.renderDateCellButton(date)) + '</td>';
                }

                /**
                 * @private
                 * @param {Date} date
                 */

            }, {
                key: "renderDateCellButton",
                value: function renderDateCellButton(date) {
                    var dateStringValue = this.dateToStringValue(date);
                    return "<button type=\"button\"\n                        class=\"brx-calendar__date-button\"\n                        data-date=\"" + dateStringValue + "\"\n                        data-date-day=\"" + date.getDate() + "\">" + date.getDate() + "</button>";
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {{cssClass: string}}
                 * @private
                 */

            }, {
                key: "getDateSettings",
                value: function getDateSettings(date, empty) {
                    var cssClass = this.settings.getDateCellCustomCssClass ? this.settings.getDateCellCustomCssClass(date, empty) : '';
                    return { cssClass: cssClass };
                }

                /**
                 * Формат значения в data-date
                 * @param {Date} date
                 * @return {string}
                 */

            }, {
                key: "dateToStringValue",
                value: function dateToStringValue(date) {
                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);

                    return day + '.' + month + '.' + date.getFullYear();
                }

                /**
                 * relates to this.dateToStringValue()
                 * @param {string} dateStringValue - Формат как и в dateToStringValue
                 * @return {Date}
                 */

            }, {
                key: "getDateFromValue",
                value: function getDateFromValue(dateStringValue) {
                    var values = dateStringValue.split('.');
                    return new Date(values[2], values[1] - 1, values[0]);
                }
            }]);

            return NewCalendarMonth;
        }();

        module.exports = NewCalendarMonth;
    }, { "./NewCalendarSettings": 5, "./calendar-labels-ru": 6 }], 5: [function (require, module, exports) {
        var NewCalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function NewCalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, NewCalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(NewCalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages4 = settings.messages,
                            monthNames = _settings$messages4.monthNames,
                            weekDayNamesShort = _settings$messages4.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return NewCalendarSettings;
        }();

        module.exports = NewCalendarSettings;
    }, {}], 6: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewAviaCalendarDateUtils = require('./calendar/NewAviaCalendarDateUtils');

        var INITIAL_MONTHS_AHEAD = 3;
        var APPEND_MONTHS_AHEAD = 2;
        var MAX_MONTHS_AHEAD = 11;
        var SCROLL_BOTTOM_OFFSET_PX = 180;

        var NewAviaDateCalendarSheet = function () {
            function NewAviaDateCalendarSheet(props) {
                _classCallCheck(this, NewAviaDateCalendarSheet);

                this.translations = props.translations;
                this.utils = window.brxUtils;
                this.modal = window.modal;

                this.dateFrom = null;
                this.dateTo = null;
                this.departure = null;
                this.destination = null;
                this.flyType = null;
                this.minPrice = 0;

                this.prices = {
                    currency: null,
                    prices: {},
                    bestPricesDates: [],
                    dateFrom: null,
                    dateTo: null
                };

                this.elements = {
                    calendarContent: document.querySelector('#aviaCalendarContent')
                };

                this.aviaRequestService = null;
                this.isModalOpen = false;
                this.isLoadingPrices = false;
                this.requestCounter = 0;
                this.calendarDataCache = {};
                this.scrollContainer = null;
                this.onModalScroll = null;
                this.shouldScrollToSelectedDateOnOpen = false;
                this.calendarRange = {
                    dateFrom: null,
                    dateTo: null,
                    maxDateTo: null
                };
                this.appendSkeletonClass = 'brx-calendar__wrapper append-month-skeleton';
                this.loadingOverlayClass = 'brx-calendar__loading-overlay';
                this.loadingOverlayVisibleClass = 'visible';

                this.init();
                this.bindEventListeners();
            }

            _createClass(NewAviaDateCalendarSheet, [{
                key: "init",
                value: function init() {
                    this.aviaRequestService = new window.NewAviaCalendarPriceRequest();
                    this.aviaCalendarApplyButton = new window.NewAviaCalendarApplyButton({
                        translations: this.translations
                    });

                    this.calendar = new window.NewAviaCalendar({
                        translations: this.translations,
                        aviaCalendarApplyButton: this.aviaCalendarApplyButton
                    });

                    this.aviaCalendarDates = new window.NewAviaCalendarDates({
                        translations: this.translations
                    });
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this30 = this;

                    document.body.addEventListener('_change-calendar', function (event) {
                        if (!_this30.isModalOpen || _this30.isLoadingPrices) return;

                        var params = event.detail || {};
                        var startDate = params.start ? _this30.formatDate(params.start) : null;
                        var endDate = params.end ? _this30.formatDate(params.end) : null;

                        _this30.dateFrom = startDate;
                        _this30.dateTo = endDate;
                        _this30.minPrice = params.price ? Number(params.price) : 0;

                        if (startDate && !endDate) {
                            _this30.loadOrRenderPrices({ departureDate: startDate }, { showSkeleton: false });
                        }
                    });

                    document.body.addEventListener('_reset-depart-date', function () {
                        if (!_this30.isModalOpen) return;

                        _this30.dateFrom = null;
                        _this30.dateTo = null;
                        _this30.minPrice = 0;

                        _this30.loadOrRenderPrices(null, { showSkeleton: false });
                    });

                    document.body.addEventListener('_reset-arrival-date', function (event) {
                        if (!_this30.isModalOpen) return;

                        _this30.dateFrom = event.detail ? _this30.formatDate(event.detail) : _this30.dateFrom;
                        _this30.dateTo = null;
                        _this30.minPrice = 0;
                    });
                }
            }, {
                key: "openModal",
                value: function openModal(dateFrom, dateTo, departure, destination, flyType, minPrice) {
                    var self = this;
                    this.dateFrom = this.formatDate(dateFrom) || null;
                    this.dateTo = this.formatDate(dateTo) || null;
                    this.departure = departure;
                    this.destination = destination;
                    this.flyType = flyType;
                    this.minPrice = minPrice;
                    this.isModalOpen = true;
                    this.shouldScrollToSelectedDateOnOpen = Boolean(this.dateFrom);
                    this.initCalendarRangeState();

                    this.modal.open({
                        content: { htmlDetachSelectorId: 'aviaCalendarSheet' },
                        parentCssClass: 'search-avia-form-modal',
                        footer: {
                            buttonLabel: this.translations.select,
                            buttonCssClass: 'apply-dates hidden'
                        },
                        type: 'bottom',
                        onBeforeClose: function onBeforeClose() {
                            self.isModalOpen = false;
                            self.unbindModalScrollListener();
                            self.resetData();
                        },
                        onAfterShow: function onAfterShow() {
                            self.bindModalScrollListener();
                            self.loadOrRenderPrices(self.dateFrom ? { departureDate: self.dateFrom } : null, { showSkeleton: true });
                        }
                    });
                }
            }, {
                key: "loadOrRenderPrices",
                value: function loadOrRenderPrices(extraParams, options) {
                    var requestParams = this.createCalendarRequestParams(extraParams || {}, this.getCurrentCalendarRange());
                    var cacheKey = this.getCacheKey(requestParams);
                    var cachedPrices = this.calendarDataCache[cacheKey];
                    var localOptions = Object.assign({ showSkeleton: false }, options);

                    if (cachedPrices) {
                        this.hideCalendarLoadingOverlay();
                        this.prices = cachedPrices;
                        this.renderCalendarResponse();
                        return;
                    }

                    if (localOptions.showSkeleton) {
                        this.renderSkeletons();
                    }

                    this.loadPrices(requestParams, cacheKey, localOptions);
                }
            }, {
                key: "loadPrices",
                value: function loadPrices(requestParams, cacheKey, options) {
                    var self = this;
                    var requestId = ++this.requestCounter;
                    var localOptions = Object.assign({ showSkeleton: false }, options);
                    var shouldSoftUpdate = this.shouldSoftUpdateCalendar(requestParams);
                    var isDepartureDateRequest = Boolean(requestParams.departureDate);

                    this.isLoadingPrices = true;
                    if (isDepartureDateRequest) {
                        this.showCalendarLoadingOverlay();
                    }

                    this.aviaRequestService.loadCalendarPriceSearchResult(requestParams).then(function (result) {
                        if (requestId !== self.requestCounter) {
                            return;
                        }

                        if (isDepartureDateRequest) {
                            self.hideCalendarLoadingOverlay();
                        }
                        self.prices = self.normalizeCalendarResponse(result, requestParams);
                        self.calendarDataCache[cacheKey] = self.prices;
                        self.syncCalendarRangeByResponse(self.prices);
                        self.isLoadingPrices = false;

                        if (localOptions.showSkeleton) {
                            self.removeSkeletons();
                        }

                        if (self.hasCalendarData()) {
                            if (shouldSoftUpdate && self.canSoftUpdateCalendar()) {
                                self.calendar.updateData(self.prices);
                                self.renderSelectedDatesState();
                            } else {
                                self.renderData();
                            }
                        } else {
                            self.renderEmptyResult();
                        }
                    }).catch(function (err) {
                        if (requestId !== self.requestCounter) {
                            return;
                        }

                        if (isDepartureDateRequest) {
                            self.hideCalendarLoadingOverlay();
                        }
                        self.isLoadingPrices = false;
                        console.error('Ошибка при поиске направлений', err);

                        if (localOptions.showSkeleton) {
                            self.removeSkeletons();
                        }

                        self.renderEmptyResult();
                    });
                }
            }, {
                key: "hasCalendarData",
                value: function hasCalendarData() {
                    return Boolean(this.prices.dateFrom && this.prices.dateTo);
                }
            }, {
                key: "createCalendarRequestParams",
                value: function createCalendarRequestParams(extraParams, range) {
                    var requestRange = range || this.getCurrentCalendarRange();
                    var params = {
                        from: this.departure,
                        to: this.destination,
                        dateFrom: requestRange.dateFrom,
                        dateTo: requestRange.dateTo
                    };

                    var currency = this.getCurrency();
                    if (currency) {
                        params.currency = currency;
                    }

                    if (extraParams && extraParams.departureDate) {
                        var normalizedDepartureDate = this.formatDate(extraParams.departureDate);
                        if (normalizedDepartureDate) {
                            params.departureDate = normalizedDepartureDate;
                        }
                    }

                    return params;
                }
            }, {
                key: "getCacheKey",
                value: function getCacheKey(requestParams) {
                    return [requestParams.from || '', requestParams.to || '', requestParams.dateFrom || '', requestParams.dateTo || '', requestParams.departureDate || '', requestParams.currency || ''].join('|');
                }
            }, {
                key: "initCalendarRangeState",
                value: function initCalendarRangeState() {
                    var today = NewAviaCalendarDateUtils.normalizeDate(new Date());
                    var initialDateTo = this.addMonths(today, INITIAL_MONTHS_AHEAD);
                    var maxDateTo = this.addMonths(today, MAX_MONTHS_AHEAD);
                    var selectedDateTo = this.getSelectedCalendarRangeEndDate();
                    var calendarDateTo = selectedDateTo && selectedDateTo.getTime() > initialDateTo.getTime() ? selectedDateTo : initialDateTo;
                    var calendarMaxDateTo = selectedDateTo && selectedDateTo.getTime() > maxDateTo.getTime() ? selectedDateTo : maxDateTo;

                    this.calendarRange = {
                        dateFrom: NewAviaCalendarDateUtils.formatIsoDate(today),
                        dateTo: NewAviaCalendarDateUtils.formatIsoDate(calendarDateTo),
                        maxDateTo: NewAviaCalendarDateUtils.formatIsoDate(calendarMaxDateTo)
                    };
                }
            }, {
                key: "getSelectedCalendarRangeEndDate",
                value: function getSelectedCalendarRangeEndDate() {
                    var selectedDates = [this.dateFrom, this.dateTo].map(function (date) {
                        return NewAviaCalendarDateUtils.parseIsoDate(date);
                    }).filter(Boolean);

                    if (!selectedDates.length) {
                        return null;
                    }

                    return selectedDates.reduce(function (maxDate, date) {
                        return date.getTime() > maxDate.getTime() ? date : maxDate;
                    });
                }
            }, {
                key: "getCurrentCalendarRange",
                value: function getCurrentCalendarRange() {
                    if (!this.calendarRange || !this.calendarRange.dateFrom || !this.calendarRange.dateTo) {
                        this.initCalendarRangeState();
                    }

                    return {
                        dateFrom: this.calendarRange.dateFrom,
                        dateTo: this.calendarRange.dateTo
                    };
                }
            }, {
                key: "syncCalendarRangeByResponse",
                value: function syncCalendarRangeByResponse(response) {
                    if (!response || !response.dateTo) {
                        return;
                    }

                    this.calendarRange.dateFrom = this.calendarRange.dateFrom || response.dateFrom;
                    this.calendarRange.dateTo = response.dateTo;
                }
            }, {
                key: "bindModalScrollListener",
                value: function bindModalScrollListener() {
                    var container = document.querySelector('.search-avia-form-modal .modal2-body');
                    if (!container) {
                        return;
                    }

                    this.unbindModalScrollListener();
                    this.scrollContainer = container;
                    this.onModalScroll = this.handleModalScroll.bind(this);
                    this.scrollContainer.addEventListener('scroll', this.onModalScroll);
                }
            }, {
                key: "unbindModalScrollListener",
                value: function unbindModalScrollListener() {
                    if (this.scrollContainer && this.onModalScroll) {
                        this.scrollContainer.removeEventListener('scroll', this.onModalScroll);
                    }

                    this.scrollContainer = null;
                    this.onModalScroll = null;
                }
            }, {
                key: "handleModalScroll",
                value: function handleModalScroll() {
                    if (!this.isModalOpen || this.isLoadingPrices || !this.scrollContainer) {
                        return;
                    }

                    if (!this.canLoadMoreCalendarRange()) {
                        return;
                    }

                    var container = this.scrollContainer;
                    var reachedBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - SCROLL_BOTTOM_OFFSET_PX;

                    if (reachedBottom) {
                        this.loadNextCalendarChunk();
                    }
                }
            }, {
                key: "canLoadMoreCalendarRange",
                value: function canLoadMoreCalendarRange() {
                    if (!this.calendarRange || !this.calendarRange.dateTo || !this.calendarRange.maxDateTo) {
                        return false;
                    }

                    return this.calendarRange.dateTo < this.calendarRange.maxDateTo;
                }
            }, {
                key: "getNextCalendarRange",
                value: function getNextCalendarRange() {
                    if (!this.canLoadMoreCalendarRange()) {
                        return null;
                    }

                    var currentDateTo = NewAviaCalendarDateUtils.parseIsoDate(this.calendarRange.dateTo);
                    var maxDateTo = NewAviaCalendarDateUtils.parseIsoDate(this.calendarRange.maxDateTo);
                    if (!currentDateTo || !maxDateTo) {
                        return null;
                    }

                    var nextDateFrom = this.addDays(currentDateTo, 1);
                    var rawNextDateTo = this.addMonths(nextDateFrom, APPEND_MONTHS_AHEAD);
                    var nextDateTo = rawNextDateTo.getTime() > maxDateTo.getTime() ? maxDateTo : rawNextDateTo;

                    return {
                        dateFrom: NewAviaCalendarDateUtils.formatIsoDate(nextDateFrom),
                        dateTo: NewAviaCalendarDateUtils.formatIsoDate(nextDateTo)
                    };
                }
            }, {
                key: "loadNextCalendarChunk",
                value: function loadNextCalendarChunk() {
                    var _this31 = this;

                    var nextRange = this.getNextCalendarRange();
                    if (!nextRange) {
                        return;
                    }

                    var requestParams = this.createCalendarRequestParams({}, nextRange);
                    var cacheKey = this.getCacheKey(requestParams);
                    var cachedPrices = this.calendarDataCache[cacheKey];

                    if (cachedPrices) {
                        this.applyAppendedCalendarChunk(cachedPrices, nextRange);
                        return;
                    }

                    var requestId = ++this.requestCounter;
                    this.isLoadingPrices = true;
                    this.renderAppendSkeleton();

                    this.aviaRequestService.loadCalendarPriceSearchResult(requestParams).then(function (result) {
                        if (requestId !== _this31.requestCounter) {
                            return;
                        }

                        _this31.removeAppendSkeleton();
                        var normalizedChunk = _this31.normalizeCalendarResponse(result, requestParams);
                        _this31.calendarDataCache[cacheKey] = normalizedChunk;
                        _this31.applyAppendedCalendarChunk(normalizedChunk, nextRange);
                    }).catch(function (err) {
                        if (requestId !== _this31.requestCounter) {
                            return;
                        }

                        _this31.removeAppendSkeleton();
                        _this31.isLoadingPrices = false;
                        console.error('Ошибка при поиске направлений', err);
                    });
                }
            }, {
                key: "applyAppendedCalendarChunk",
                value: function applyAppendedCalendarChunk(chunk, nextRange) {
                    this.prices = this.mergeCalendarResponses(this.prices, chunk);
                    this.isLoadingPrices = false;
                    this.calendarRange.dateTo = nextRange.dateTo;

                    if (!this.hasCalendarData()) {
                        return;
                    }

                    if (this.canSoftUpdateCalendar()) {
                        this.calendar.updateData(this.prices);
                        this.renderSelectedDatesState();
                        return;
                    }

                    this.renderData();
                }
            }, {
                key: "mergeCalendarResponses",
                value: function mergeCalendarResponses(currentData, nextData) {
                    if (!currentData || !currentData.dateFrom || !currentData.dateTo) {
                        return nextData;
                    }

                    var currentPrices = currentData.prices || {};
                    var nextPrices = nextData && nextData.prices ? nextData.prices : {};
                    var mergedBestDates = new Set((currentData.bestPricesDates || []).concat(nextData && nextData.bestPricesDates ? nextData.bestPricesDates : []));
                    var currentDateTo = currentData.dateTo || '';
                    var nextDateTo = nextData && nextData.dateTo ? nextData.dateTo : '';

                    return {
                        currency: currentData.currency || (nextData ? nextData.currency : null),
                        prices: Object.assign({}, currentPrices, nextPrices),
                        bestPricesDates: Array.from(mergedBestDates),
                        dateFrom: currentData.dateFrom,
                        dateTo: currentDateTo > nextDateTo ? currentDateTo : nextDateTo
                    };
                }
            }, {
                key: "addDays",
                value: function addDays(date, days) {
                    var result = NewAviaCalendarDateUtils.normalizeDate(date);
                    result.setDate(result.getDate() + days);
                    return result;
                }
            }, {
                key: "addMonths",
                value: function addMonths(date, months) {
                    var result = NewAviaCalendarDateUtils.normalizeDate(date);
                    result.setMonth(result.getMonth() + months);
                    return result;
                }
            }, {
                key: "shouldSoftUpdateCalendar",
                value: function shouldSoftUpdateCalendar(requestParams) {
                    if (!this.canSoftUpdateCalendar() || !this.prices) {
                        return false;
                    }

                    var currentDateFrom = this.prices.dateFrom || '';
                    var currentDateTo = this.prices.dateTo || '';

                    return currentDateFrom === (requestParams.dateFrom || '') && currentDateTo === (requestParams.dateTo || '');
                }
            }, {
                key: "canSoftUpdateCalendar",
                value: function canSoftUpdateCalendar() {
                    if (!this.calendar || !this.calendar.datepicker || !this.elements.calendarContent) {
                        return false;
                    }

                    var datepicker = this.calendar.datepicker;
                    var calendarElement = datepicker.elements ? datepicker.elements.calendar : null;

                    if (!calendarElement || !this.elements.calendarContent.contains(calendarElement)) {
                        return false;
                    }

                    return Boolean(calendarElement.querySelector('.brx-calendar__date-button'));
                }
            }, {
                key: "normalizeCalendarResponse",
                value: function normalizeCalendarResponse(result, requestParams) {
                    return {
                        currency: result && result.currency ? result.currency : requestParams.currency || null,
                        prices: result && result.prices ? result.prices : {},
                        bestPricesDates: result && Array.isArray(result.bestPricesDates) ? result.bestPricesDates : [],
                        dateFrom: result && result.dateFrom ? result.dateFrom : requestParams.dateFrom,
                        dateTo: result && result.dateTo ? result.dateTo : requestParams.dateTo
                    };
                }
            }, {
                key: "getCurrency",
                value: function getCurrency() {
                    if (window.app && window.app.currency) {
                        return String(window.app.currency).toLowerCase();
                    }

                    return '';
                }
            }, {
                key: "formatDate",
                value: function formatDate(date) {
                    if (!date) {
                        return '';
                    }

                    if (typeof date === 'string') {
                        var match = date.match(/^(\d{4}-\d{2}-\d{2})/);
                        if (match) {
                            return match[1];
                        }
                    }

                    return NewAviaCalendarDateUtils.formatIsoDate(date);
                }
            }, {
                key: "resetData",
                value: function resetData() {
                    this.aviaCalendarDates.resetDepartDate();
                    this.aviaCalendarDates.resetArrivalDate();
                    this.calendar.setSelectedDates(null, null);
                    this.aviaCalendarApplyButton.resetParams();
                    this.hideCalendarLoadingOverlay();
                    this.removeAppendSkeleton();
                    this.requestCounter += 1;
                    this.isLoadingPrices = false;
                    this.shouldScrollToSelectedDateOnOpen = false;
                    this.calendarRange = {
                        dateFrom: null,
                        dateTo: null,
                        maxDateTo: null
                    };

                    if (this.elements.calendarContent) {
                        this.elements.calendarContent.innerHTML = '';
                    }
                }
            }, {
                key: "renderData",
                value: function renderData() {
                    this.calendar.init(this.prices, this.flyType);
                    this.renderSelectedDatesState();

                    this.aviaCalendarApplyButton.params = {
                        start: this.dateFrom,
                        end: this.dateTo,
                        flyType: this.flyType,
                        price: this.minPrice
                    };

                    this.aviaCalendarApplyButton.renderButton();
                }
            }, {
                key: "renderSelectedDatesState",
                value: function renderSelectedDatesState() {
                    this.calendar.datepicker.selectionMode = 'range';
                    this.calendar.setSelectedDates(this.dateFrom, this.dateTo);

                    if (this.dateFrom) {
                        this.aviaCalendarDates.setDepartDate(this.dateFrom);
                    } else {
                        this.aviaCalendarDates.resetDepartDate();
                    }

                    this.aviaCalendarDates.showArrivalDate();
                    if (this.dateTo) {
                        this.aviaCalendarDates.setArrivalDate(this.dateTo);
                    } else {
                        this.aviaCalendarDates.resetArrivalDate();
                    }

                    if (this.shouldScrollToSelectedDateOnOpen) {
                        this.shouldScrollToSelectedDateOnOpen = false;
                        this.scrollToSelectedDateMonth();
                    }
                }
            }, {
                key: "scrollToSelectedDateMonth",
                value: function scrollToSelectedDateMonth() {
                    if (!this.dateFrom || !this.calendar || !this.calendar.datepicker) {
                        return;
                    }

                    var selectedDate = NewAviaCalendarDateUtils.parseIsoDate(this.dateFrom);
                    if (!selectedDate || typeof this.calendar.datepicker.getCell !== 'function') {
                        return;
                    }

                    var selectedCell = this.calendar.datepicker.getCell(selectedDate);
                    var selectedMonth = selectedCell ? selectedCell.closest('.brx-calendar__wrapper') : null;
                    var scrollContainer = this.getCalendarScrollContainer();

                    if (!selectedMonth || !scrollContainer) {
                        return;
                    }

                    var stickyHeader = scrollContainer.querySelector('.avia-calendar-dates');
                    var stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
                    var targetScrollTop = scrollContainer.scrollTop + selectedMonth.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top - stickyHeaderHeight - 8;

                    if (typeof scrollContainer.scrollTo === 'function') {
                        scrollContainer.scrollTo({ top: Math.max(0, targetScrollTop) });
                        return;
                    }

                    scrollContainer.scrollTop = Math.max(0, targetScrollTop);
                }
            }, {
                key: "getCalendarScrollContainer",
                value: function getCalendarScrollContainer() {
                    if (this.scrollContainer) {
                        return this.scrollContainer;
                    }

                    return document.querySelector('.search-avia-form-modal .modal2-body');
                }
            }, {
                key: "renderCalendarResponse",
                value: function renderCalendarResponse() {
                    if (this.shouldSoftUpdateCalendar(this.prices) && this.canSoftUpdateCalendar()) {
                        this.calendar.updateData(this.prices);
                        this.renderSelectedDatesState();
                        return;
                    }

                    this.renderData();
                }
            }, {
                key: "renderEmptyResult",
                value: function renderEmptyResult() {
                    var parent = this.elements.calendarContent;
                    if (!parent) return;

                    // удалить старые блоки
                    var old = parent.querySelector('.avia-direction-empty-search');
                    if (old) old.remove();

                    var container = document.createElement('div');
                    container.className = 'avia-form-container avia-direction-empty-search';

                    var html = '' + '<div class="empty-title">' + this.translations.notFoundPrices + '</div>' + '<div class="empty-subtitle">' + this.translations.reloadPage + '</div>' + '<button type="button" class="clear-search-input reload-page-btn">' + this.translations.reloadBtn + '</button>';

                    container.innerHTML = html;
                    parent.innerHTML = '';
                    parent.appendChild(container);
                }
            }, {
                key: "renderSkeletons",
                value: function renderSkeletons() {
                    var parent = this.elements.calendarContent;
                    if (!parent) return;
                    parent.innerHTML = '';

                    for (var i = 0; i < 2; i++) {
                        var wrapper = document.createElement('div');
                        wrapper.className = 'brx-calendar__wrapper';

                        var month = document.createElement('div');
                        month.className = 'brx-calendar__month skeleton';

                        var table = document.createElement('table');
                        table.className = 'brx-calendar__dates';

                        var tbody = document.createElement('tbody');

                        for (var r = 0; r < 5; r++) {
                            var tr = document.createElement('tr');
                            tr.className = 'brx-calendar__row';

                            for (var c = 0; c < 7; c++) {
                                var td = document.createElement('td');
                                td.className = 'brx-calendar__date skeleton';
                                var span = document.createElement('span');
                                td.appendChild(span);
                                tr.appendChild(td);
                            }
                            tbody.appendChild(tr);
                        }

                        table.appendChild(tbody);
                        wrapper.appendChild(month);
                        wrapper.appendChild(table);
                        parent.appendChild(wrapper);
                    }
                }
            }, {
                key: "removeSkeletons",
                value: function removeSkeletons() {
                    var parent = this.elements.calendarContent;
                    if (parent) {
                        parent.innerHTML = '';
                    }

                    var skeletons = document.querySelectorAll('.avia-calendar-dates .skeleton');
                    for (var i = 0; i < skeletons.length; i++) {
                        skeletons[i].classList.remove('skeleton');
                    }
                }
            }, {
                key: "showCalendarLoadingOverlay",
                value: function showCalendarLoadingOverlay() {
                    var overlay = this.getCalendarLoadingOverlayElement(true);
                    if (!overlay) {
                        return;
                    }

                    overlay.classList.add(this.loadingOverlayVisibleClass);
                }
            }, {
                key: "hideCalendarLoadingOverlay",
                value: function hideCalendarLoadingOverlay() {
                    var overlay = this.getCalendarLoadingOverlayElement(false);
                    if (!overlay) {
                        return;
                    }

                    overlay.classList.remove(this.loadingOverlayVisibleClass);
                }
            }, {
                key: "getCalendarLoadingOverlayElement",
                value: function getCalendarLoadingOverlayElement() {
                    var createIfMissing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    if (!this.calendar || !this.calendar.datepicker || !this.calendar.datepicker.elements || !this.calendar.datepicker.elements.calendar) {
                        return null;
                    }

                    var calendarContent = this.calendar.datepicker.elements.calendar;
                    var overlay = calendarContent.querySelector('.' + this.loadingOverlayClass);

                    if (!overlay && createIfMissing) {
                        overlay = document.createElement('div');
                        overlay.className = this.loadingOverlayClass;
                        calendarContent.appendChild(overlay);
                    }

                    return overlay;
                }
            }, {
                key: "renderAppendSkeleton",
                value: function renderAppendSkeleton() {
                    this.removeAppendSkeleton();

                    var parent = this.getAppendSkeletonTarget();
                    if (!parent) {
                        return;
                    }

                    var wrapper = document.createElement('div');
                    wrapper.className = this.appendSkeletonClass;

                    var month = document.createElement('div');
                    month.className = 'brx-calendar__month skeleton';

                    var table = document.createElement('table');
                    table.className = 'brx-calendar__dates';
                    var tbody = document.createElement('tbody');

                    for (var r = 0; r < 5; r++) {
                        var tr = document.createElement('tr');
                        tr.className = 'brx-calendar__row';

                        for (var c = 0; c < 7; c++) {
                            var td = document.createElement('td');
                            td.className = 'brx-calendar__date skeleton';
                            var span = document.createElement('span');
                            td.appendChild(span);
                            tr.appendChild(td);
                        }

                        tbody.appendChild(tr);
                    }

                    table.appendChild(tbody);
                    wrapper.appendChild(month);
                    wrapper.appendChild(table);
                    parent.appendChild(wrapper);
                }
            }, {
                key: "removeAppendSkeleton",
                value: function removeAppendSkeleton() {
                    var skeleton = document.querySelector('.append-month-skeleton');
                    if (skeleton && skeleton.parentNode) {
                        skeleton.parentNode.removeChild(skeleton);
                    }
                }
            }, {
                key: "getAppendSkeletonTarget",
                value: function getAppendSkeletonTarget() {
                    if (this.calendar && this.calendar.datepicker && this.calendar.datepicker.elements && this.calendar.datepicker.elements.calendar) {
                        return this.calendar.datepicker.elements.calendar;
                    }

                    return this.elements.calendarContent;
                }
            }]);

            return NewAviaDateCalendarSheet;
        }();

        window.NewAviaDateCalendarSheet = NewAviaDateCalendarSheet;
    }, { "./calendar/NewAviaCalendarDateUtils": 2 }], 2: [function (require, module, exports) {
        var NewAviaCalendarDateUtils = function () {
            function NewAviaCalendarDateUtils() {
                _classCallCheck(this, NewAviaCalendarDateUtils);
            }

            _createClass(NewAviaCalendarDateUtils, null, [{
                key: "parseIsoDate",
                value: function parseIsoDate(value) {
                    if (!value) return null;
                    if (value instanceof Date) {
                        return this.normalizeDate(value);
                    }

                    if (typeof value === 'string') {
                        var match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
                        if (match) {
                            var year = Number(match[1]);
                            var month = Number(match[2]) - 1;
                            var day = Number(match[3]);
                            return new Date(year, month, day);
                        }
                    }

                    var date = new Date(value);
                    if (isNaN(date)) return null;
                    return this.normalizeDate(date);
                }
            }, {
                key: "normalizeDate",
                value: function normalizeDate(value) {
                    var date = value instanceof Date ? new Date(value) : new Date(value);
                    if (isNaN(date)) return null;

                    date.setHours(0, 0, 0, 0);
                    return date;
                }
            }, {
                key: "formatIsoDate",
                value: function formatIsoDate(value) {
                    var date = this.parseIsoDate(value);
                    if (!date) return '';

                    var yyyy = date.getFullYear();
                    var mm = String(date.getMonth() + 1).padStart(2, '0');
                    var dd = String(date.getDate()).padStart(2, '0');
                    return yyyy + '-' + mm + '-' + dd;
                }
            }]);

            return NewAviaCalendarDateUtils;
        }();

        window.NewAviaCalendarDateUtils = NewAviaCalendarDateUtils;
        module.exports = NewAviaCalendarDateUtils;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewAviaDateCalendarControl = function () {
            function NewAviaDateCalendarControl(props) {
                _classCallCheck(this, NewAviaDateCalendarControl);

                this.utils = window.brxUtils;
                this.values = null;
                this.destination = null;
                this.translations = props.translations;

                this.elements = {
                    form: props.form,
                    dateFrom: document.querySelector('#aviaHiddenDateFrom'),
                    dateTo: document.querySelector('#aviaHiddenDateTo'),
                    datesLabel: props.form.querySelector('.form-field--fly-date .form-field__value')
                };

                this.calendarSheet = null;

                this.bindHandlers();
            }

            _createClass(NewAviaDateCalendarControl, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var self = this;
                    if (!this.elements.form) return;

                    this.elements.form.addEventListener('click', function (event) {
                        if (event.target.closest('.form-field--fly-date')) {
                            self.openCalendar();
                        }
                    });
                }
            }, {
                key: "init",
                value: function init() {
                    this.calendarSheet = new window.NewAviaDateCalendarSheet({
                        translations: this.translations
                    });
                }
            }, {
                key: "onChange",
                value: function onChange(params) {
                    if (!params || !params.dateFrom) return;

                    var field = this.elements.datesLabel.closest('.form-field');
                    if (field) field.classList.remove('error');

                    if (this.elements.datesLabel) {
                        this.elements.datesLabel.classList.remove('default');
                    }

                    this.renderDatesLabel(params);
                    this.setValue(params);
                }
            }, {
                key: "setValue",
                value: function setValue(params) {
                    if (!params || !params.dateFrom) {
                        if (this.elements.dateFrom) this.elements.dateFrom.value = '';
                        if (this.elements.dateTo) this.elements.dateTo.value = '';

                        if (this.values) {
                            this.values.dateFrom = null;
                            this.values.dateTo = null;
                            this.values.flyType = null;
                            this.values.minPrice = 0;
                        }
                        return;
                    }

                    var formatDate = function formatDate(d) {
                        var date = new Date(d);
                        if (isNaN(date)) return '';
                        var y = date.getFullYear();
                        var m = String(date.getMonth() + 1).padStart(2, '0');
                        var day = String(date.getDate()).padStart(2, '0');
                        return y + '-' + m + '-' + day;
                    };

                    var dateFromStr = formatDate(params.dateFrom);
                    if (this.elements.dateFrom) this.elements.dateFrom.value = dateFromStr;

                    var dateToStr = '';
                    if (params.dateTo && this.elements.dateTo) {
                        dateToStr = formatDate(params.dateTo);
                        this.elements.dateTo.value = dateToStr;
                    }

                    if (!this.values) this.values = {};
                    this.values.dateFrom = dateFromStr || null;
                    this.values.dateTo = dateToStr || null;
                    this.values.flyType = params.flyType;
                    this.values.minPrice = params.minPrice;
                }
            }, {
                key: "renderDatesLabel",
                value: function renderDatesLabel(params) {
                    if (!params || !params.dateFrom) return;

                    var options = { day: 'numeric', month: 'long' };
                    var dateFrom = new Date(params.dateFrom).toLocaleDateString('ru-RU', options);
                    var dateTo = '';

                    if (params.dateTo) {
                        dateTo = new Date(params.dateTo).toLocaleDateString('ru-RU', options);
                        dateTo = ' - ' + dateTo;
                    }

                    var label = this.elements.form.querySelector('.form-field--fly-date .form-field__value');
                    if (label) {
                        label.textContent = dateFrom + dateTo;
                    }
                }
            }, {
                key: "openCalendar",
                value: function openCalendar() {
                    if (this.values && this.values.departure && this.values.destination) {
                        this.calendarSheet.openModal(this.values.dateFrom, this.values.dateTo, this.values.departure, this.values.destination, this.values.flyType, this.values.minPrice || 0);
                    } else if (this.destination && this.destination.elements && this.destination.elements.destinationLabel) {
                        var field = this.destination.elements.destinationLabel.closest('.form-field');
                        if (field) field.classList.add('error');
                    }
                }
            }, {
                key: "reset",
                value: function reset() {
                    var field = this.elements.datesLabel.closest('.form-field');
                    if (field) field.classList.remove('error');

                    if (this.elements.datesLabel) {
                        this.elements.datesLabel.classList.add('default');
                        this.elements.datesLabel.textContent = this.translations.selectDates;
                    }

                    this.setValue({});
                }
            }]);

            return NewAviaDateCalendarControl;
        }();

        window.NewAviaDateCalendarControl = NewAviaDateCalendarControl;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaTouristsSheet = function () {
            function AviaTouristsSheet(params) {
                _classCallCheck(this, AviaTouristsSheet);

                this.utils = window.brxUtils;
                this.modal = window.modal;
                this.translations = params.translations;

                this.elements = {
                    sheet: document.querySelector('#aviaTouristsSheet'),
                    ages: document.querySelector('#aviaChildrenAges'),
                    addChildBtn: document.querySelector('#aviaAddChild'),
                    childrenAgesCancel: document.querySelector('#aviaChildrenAgesCancel'),
                    childrenList: document.querySelector('#childrenList'),
                    counterControls: document.querySelectorAll('.avia-counter .control'),
                    counterValue: document.querySelector('.avia-counter .value')
                };

                this.values = {
                    adults: 2,
                    children: 0,
                    ages: []
                };

                this.minAdults = 1;
                this.maxAdults = 10;
                this.maxChildren = 4;

                this.bindEventListeners();
            }

            _createClass(AviaTouristsSheet, [{
                key: "open",
                value: function open(values) {
                    if (!values) return;
                    this.adults = values.adults || 2;
                    this.children = values.children || 0;
                    this.ages = Array.isArray(values.childAges) ? [].concat(_toConsumableArray(values.childAges)) : [];

                    this.update();
                    this.openModal();
                }
            }, {
                key: "openModal",
                value: function openModal() {
                    if (!this.modal || typeof this.modal.open !== 'function') return;

                    this.modal.open({
                        header: { title: this.translations.whoFlying },
                        content: { htmlDetachSelectorId: 'aviaTouristsSheet' },
                        parentCssClass: 'search-avia-form-modal',
                        footer: {
                            theme: window.modal.TYPE_BOTTOM,
                            buttonLabel: this.translations.select,
                            buttonCssClass: 'apply-tourists'
                        },
                        type: 'bottom'
                    });
                }
            }, {
                key: "onChange",
                value: function onChange() {
                    var event = new CustomEvent('_change-avia-tourists', {
                        detail: {
                            adults: this.adults,
                            children: this.children,
                            childAges: this.ages
                        }
                    });

                    document.body.dispatchEvent(event);

                    if (this.modal && typeof this.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }, {
                key: "update",
                value: function update() {
                    if (this.elements.counterValue) {
                        this.elements.counterValue.textContent = this.adults;
                    }
                    if (this.elements.childrenList) {
                        this.elements.childrenList.innerHTML = '';
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = this.ages[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var age = _step4.value;

                                this.addChild(age);
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this32 = this;

                    var els = this.elements;

                    if (els.addChildBtn) {
                        els.addChildBtn.addEventListener('click', function (e) {
                            e.currentTarget.classList.add('hidden');
                            if (els.ages) els.ages.classList.remove('hidden');
                        });
                    }

                    if (els.childrenList) {
                        els.childrenList.addEventListener('click', function (e) {
                            var removeBtn = e.target.closest('.avia-child-remove');
                            if (!removeBtn) return;

                            var closest = removeBtn.closest('.avia-child');
                            if (!closest) return;

                            var value = closest.dataset.value;
                            closest.remove();

                            _this32.children = Math.max(0, _this32.children - 1);

                            var index = _this32.ages.indexOf(value);
                            if (index !== -1) _this32.ages.splice(index, 1);

                            if (els.childrenAgesCancel) els.childrenAgesCancel.click();
                        });
                    }

                    if (els.ages) {
                        els.ages.addEventListener('click', function (e) {
                            var item = e.target.closest('.age-item');
                            if (!item) return;

                            var value = item.dataset.value;
                            _this32.children += 1;
                            _this32.ages.push(value);
                            _this32.addChild(value);

                            if (els.childrenAgesCancel) els.childrenAgesCancel.click();
                        });
                    }

                    if (els.childrenAgesCancel) {
                        els.childrenAgesCancel.addEventListener('click', function () {
                            if (els.ages) els.ages.classList.add('hidden');
                            if (els.addChildBtn && _this32.children < _this32.maxChildren) {
                                els.addChildBtn.classList.remove('hidden');
                            }
                        });
                    }

                    // Счётчик взрослых
                    if (els.counterControls) {
                        els.counterControls.forEach(function (control) {
                            control.addEventListener('click', function () {
                                var currentValue = parseInt(els.counterValue.textContent, 10) || _this32.minAdults;
                                var newValue = currentValue;

                                if (control.classList.contains('control--down') && currentValue > _this32.minAdults) {
                                    newValue = currentValue - 1;
                                } else if (control.classList.contains('control--up') && currentValue < _this32.maxAdults) {
                                    newValue = currentValue + 1;
                                }

                                els.counterValue.textContent = newValue;
                                _this32.adults = newValue;
                            });
                        });
                    }

                    // Применить туристов
                    document.body.addEventListener('click', function (e) {
                        var applyBtn = e.target.closest('.apply-tourists');
                        if (applyBtn) _this32.onChange();
                    });
                }
            }, {
                key: "addChild",
                value: function addChild(age) {
                    if (!this.elements.childrenList) return;

                    var container = document.createElement('div');
                    container.className = 'avia-form-container avia-child';
                    container.dataset.value = age;

                    var childInfo = this.childAge(age);

                    container.innerHTML = "\n            <div>\n                <span class=\"avia-child-title\">" + childInfo.title + "</span>\n                <span class=\"avia-child-subtitle\">" + childInfo.subtitle + "</span>\n            </div>\n            <button type=\"button\" class=\"avia-child-remove\"></button>\n        ";

                    this.elements.childrenList.append(container);
                }
            }, {
                key: "childAge",
                value: function childAge(age) {
                    var parts = this.translations.countYears ? this.translations.countYears.split(',').map(function (s) {
                        return s.trim();
                    }) : ['', '', ''];

                    var _parts3 = _slicedToArray(parts, 3),
                        yearOne = _parts3[0],
                        yearFew = _parts3[1],
                        yearMany = _parts3[2];

                    var ageString = this.utils.getnoun(age, yearOne, yearFew, yearMany);

                    var title = this.translations.child;
                    var subtitle = age + " " + ageString;

                    if (age < 3) {
                        var place = this.translations.noPlace;
                        title = this.translations.infant;
                        subtitle = age === 0 ? this.translations.upToYear + ", " + place : age + " " + ageString + ", " + place;
                    }

                    return { title: title, subtitle: subtitle };
                }
            }]);

            return AviaTouristsSheet;
        }();

        window.AviaTouristsSheet = AviaTouristsSheet;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var AviaTouristsSheet = window.AviaTouristsSheet;

        var AviaTouristsControl = function () {
            function AviaTouristsControl(params) {
                _classCallCheck(this, AviaTouristsControl);

                this.utils = window.brxUtils;

                this.elements = {
                    form: params.form,
                    adultsInput: document.querySelector('#aviaHiddenAdults'),
                    childrenInput: document.querySelector('#aviaHiddenChildren'),
                    childAgesInput: document.querySelector('#aviaHiddenChildAges')
                };

                this.touristsSheet = null;
                this.values = null;
                this.translations = params.translations;

                this.bindHandlers();
            }

            _createClass(AviaTouristsControl, [{
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this33 = this;

                    if (!this.elements.form) return;

                    this.elements.form.addEventListener('click', function (event) {
                        var target = event.target.closest('.form-field--tourists');
                        if (target) _this33.openTourists();
                    });
                }
            }, {
                key: "init",
                value: function init() {
                    this.touristsSheet = new AviaTouristsSheet({
                        translations: this.translations
                    });
                }
            }, {
                key: "onChange",
                value: function onChange(params) {
                    this.renderTouristsLabel(params);
                    this.setValue(params);
                }
            }, {
                key: "setValue",
                value: function setValue(params) {
                    if (this.elements.adultsInput) {
                        this.elements.adultsInput.value = params.adults;
                    }
                    if (this.elements.childrenInput) {
                        this.elements.childrenInput.value = params.children;
                    }
                    if (this.elements.childAgesInput) {
                        this.elements.childAgesInput.value = Array.isArray(params.childAges) ? params.childAges.join(',') : '';
                    }
                }
            }, {
                key: "renderTouristsLabel",
                value: function renderTouristsLabel(params) {
                    var adultsParts = this.translations.adultsCount ? this.translations.adultsCount.split(',').map(function (s) {
                        return s.trim();
                    }) : ['', '', ''];

                    var _adultsParts = _slicedToArray(adultsParts, 3),
                        adultsOne = _adultsParts[0],
                        adultsFew = _adultsParts[1],
                        adultsMany = _adultsParts[2];

                    var adultsString = this.utils.getnoun(params.adults, adultsOne, adultsFew, adultsMany);
                    var adults = params.adults + " " + adultsString;

                    var childParts = this.translations.childCount ? this.translations.childCount.split(',').map(function (s) {
                        return s.trim();
                    }) : ['', '', ''];

                    var _childParts = _slicedToArray(childParts, 3),
                        childrenOne = _childParts[0],
                        childrenFew = _childParts[1],
                        childrenMany = _childParts[2];

                    var childrenString = this.utils.getnoun(params.children, childrenOne, childrenFew, childrenMany);
                    var children = params.children + " " + childrenString;

                    var fieldValueEl = this.elements.form ? this.elements.form.querySelector('.form-field--tourists .form-field__value') : null;

                    if (fieldValueEl) {
                        fieldValueEl.innerHTML = adults + (params.children > 0 ? ", " + children : '');
                    }
                }
            }, {
                key: "openTourists",
                value: function openTourists() {
                    if (this.touristsSheet && typeof this.touristsSheet.open === 'function') {
                        this.touristsSheet.open(this.values);
                    }
                }
            }]);

            return AviaTouristsControl;
        }();

        window.AviaTouristsControl = AviaTouristsControl;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var _window2 = window,
            AviaDepartureControl = _window2.AviaDepartureControl,
            AviaDestinationControl = _window2.AviaDestinationControl,
            AviaTouristsControl = _window2.AviaTouristsControl,
            AviaDirectionsRequest = _window2.AviaDirectionsRequest,
            AviaDirectionSearch = _window2.AviaDirectionSearch,
            AviaRestoreFormParams = _window2.AviaRestoreFormParams;

        var FindAviaForm = function () {
            function FindAviaForm(params) {
                _classCallCheck(this, FindAviaForm);

                this.departure = null;
                this.destination = null;
                this.directions = null;
                this.tourists = null;
                this.calendar = null;

                this.elements = {
                    form: document.querySelector('.search-avia-form')
                };

                this.values = Object.assign({}, params.values);
                this.labels = Object.assign({}, params.labels);

                this.directions = {};
                this.aviaRequestService = null;
                this.directionSearch = null;
                this.restoreFormParams = null;

                this.freeMode = false;
                this.translations = params.translations;
                this.isPreviewMode = Boolean(window.app && window.app.isPreview);
            }

            _createClass(FindAviaForm, [{
                key: "getScrollTop",
                value: function getScrollTop() {
                    if (typeof window === 'undefined') return 0;

                    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                }
            }, {
                key: "restoreScrollTop",
                value: function restoreScrollTop(scrollTop) {
                    if (typeof window === 'undefined' || typeof scrollTop !== 'number') return;

                    var scrollToSavedPosition = function scrollToSavedPosition() {
                        window.scrollTo(0, scrollTop);
                    };

                    scrollToSavedPosition();
                    requestAnimationFrame(scrollToSavedPosition);
                    setTimeout(scrollToSavedPosition, 0);
                }
            }, {
                key: "init",
                value: function init() {
                    this.aviaRequestService = new AviaDirectionsRequest();
                    this.loadDirections();

                    this.restoreFormParams = new AviaRestoreFormParams({
                        values: this.values,
                        labels: this.labels,
                        isPreviewMode: this.isPreviewMode
                    });

                    this.departure = new AviaDepartureControl({
                        form: this.elements.form,
                        translations: this.translations
                    });
                    this.destination = new AviaDestinationControl({
                        form: this.elements.form,
                        translations: this.translations
                    });
                    this.tourists = new AviaTouristsControl({
                        form: this.elements.form,
                        translations: this.translations
                    });

                    var isPreviewMode = Boolean(window.app && window.app.isPreview);

                    var CalendarControl = isPreviewMode ? window.NewAviaDateCalendarControl : window.AviaDateCalendarControl;

                    this.calendar = new CalendarControl({
                        form: this.elements.form,
                        translations: this.translations
                    });

                    this.bindHandlers();
                }
            }, {
                key: "initDeparture",
                value: function initDeparture() {
                    this.departure.init();
                    this.departure.onChange(this.labels.departure, this.values.departure, this.values.departureType);
                }
            }, {
                key: "initDestination",
                value: function initDestination() {
                    this.destination.values = this.values;
                    this.destination.departure = this.values.departure;
                    this.destination.init();
                    this.destination.onChange(this.labels.destination, this.values.destination, this.values.destinationType);
                }
            }, {
                key: "initTourists",
                value: function initTourists() {
                    this.tourists.values = this.values;
                    this.tourists.init();
                    this.tourists.onChange({
                        adults: this.values.adults,
                        children: this.values.children,
                        childAges: this.values.childAges
                    });
                }
            }, {
                key: "initDates",
                value: function initDates() {
                    this.calendar.values = this.values;
                    this.calendar.destination = this.destination;
                    this.calendar.init();
                    this.calendar.onChange({
                        dateFrom: this.values.dateFrom,
                        dateTo: this.values.dateTo
                    });
                }
            }, {
                key: "initControls",
                value: function initControls() {
                    this.directionSearch = new AviaDirectionSearch({
                        translations: this.translations
                    });
                    this.directionSearch.init();

                    this.initDeparture();
                    this.initDestination();
                    this.initTourists();
                    this.initDates();
                }
            }, {
                key: "loadDirections",
                value: function loadDirections() {
                    var _this34 = this;

                    Promise.all([this.aviaRequestService.getDepartures(), this.aviaRequestService.getDestinations(), this.aviaRequestService.getDirections()]).then(function (_ref10) {
                        var _ref11 = _slicedToArray(_ref10, 3),
                            departures = _ref11[0],
                            destinations = _ref11[1],
                            directions = _ref11[2];

                        _this34.departure.departuresData = departures;
                        _this34.departure.directions = directions;

                        _this34.destination.destinationsData = destinations;
                        _this34.destination.directions = directions;
                        _this34.directions = directions;

                        var params = _this34.restoreFormParams.restore(directions, _this34.values, _this34.labels);
                        _this34.values = params.values;
                        _this34.labels = params.labels;

                        _this34.matchDirection();
                        _this34.initControls();

                        eventDispatcher.dispatchEvent('_load-avia-form-data');
                    }).catch(function (err) {
                        console.error('Ошибка при загрузке направлений:', err);
                    });
                }
            }, {
                key: "matchDirection",
                value: function matchDirection() {
                    var _this35 = this;

                    var matchedDirection = this.directions.find(function (d) {
                        return d.from === _this35.values.departure && d.to === _this35.values.destination;
                    });

                    if (matchedDirection && matchedDirection.flyType) {
                        this.values.flyType = matchedDirection.flyType;
                        return;
                    }

                    if (matchedDirection && matchedDirection.availability) {
                        var availability = matchedDirection.availability;

                        if (availability.length === 1) {
                            this.values.flyType = availability[0];
                        } else if (availability.length > 1) {
                            this.values.flyType = 'any';
                        }
                    }
                }
            }, {
                key: "bindHandlers",
                value: function bindHandlers() {
                    var _this36 = this;

                    var handlers = {
                        '_change-avia-departure': function _changeAviaDeparture(params) {
                            var scrollTop = params && params.preserveScroll ? _this36.getScrollTop() : null;

                            _this36.values.departure = params.value;
                            if (_this36.isPreviewMode) {
                                _this36.values.departureType = _this36.waypointType(params.waypointType);
                            }
                            _this36.departure.onChange(params.label, params.value, _this36.values.departureType);
                            _this36.destination.departure = params.value;
                            _this36.destination.reset();
                            if (_this36.isPreviewMode) {
                                _this36.values.destinationType = null;
                            }
                            _this36.values.flyType = null;
                            _this36.values.minPrice = 0;

                            if (scrollTop !== null) {
                                _this36.restoreScrollTop(scrollTop);
                            }
                        },
                        '_change-avia-destination': function _changeAviaDestination(params) {
                            _this36.values.destination = params.value;
                            _this36.values.flyType = params.flyType;
                            if (_this36.isPreviewMode) {
                                _this36.values.destinationType = _this36.waypointType(params.waypointType);
                            }
                            _this36.destination.onChange(params.label, params.value, _this36.values.destinationType);
                            _this36.values.minPrice = 0;
                            _this36.matchDirection();
                        },
                        '_change-avia-tourists': function _changeAviaTourists(params) {
                            Object.assign(_this36.values, {
                                adults: params.adults,
                                children: params.children,
                                childAges: params.childAges
                            });
                            _this36.tourists.onChange(params);
                        },
                        '_change-avia-dates': function _changeAviaDates(params) {
                            Object.assign(_this36.values, {
                                dateFrom: params.dateFrom,
                                dateTo: params.dateTo,
                                flyType: params.flyType,
                                minPrice: params.minPrice
                            });
                            _this36.calendar.onChange(params);
                        }
                    };

                    var _loop2 = function _loop2(eventName, handler) {
                        document.body.addEventListener(eventName, function (event) {
                            handler.call(_this36, event.detail);
                        });
                    };

                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = Object.entries(handlers)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var _ref12 = _step5.value;

                            var _ref13 = _slicedToArray(_ref12, 2);

                            var eventName = _ref13[0];
                            var handler = _ref13[1];

                            _loop2(eventName, handler);
                        }

                        // обработчик отправки формы
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }

                    eventDispatcher.addAllEvent('click', '.find-avia-form-submit-button', function (e) {
                        var parent = e.currentTarget.closest('.search-avia-form');

                        parent.classList.add('loading', 'sending');

                        var _values = _this36.values,
                            departure = _values.departure,
                            destination = _values.destination,
                            dateFrom = _values.dateFrom;

                        // Валидация полей

                        var destLabel = _this36.destination.elements.destinationLabel;
                        var dateLabel = _this36.calendar.elements.datesLabel;

                        if (destLabel) {
                            var destField = destLabel.closest('.form-field');
                            if (!destination) destField.classList.add('error');else destField.classList.remove('error');
                        }

                        if (dateLabel) {
                            var dateField = dateLabel.closest('.form-field');
                            if (!dateFrom) dateField.classList.add('error');else dateField.classList.remove('error');
                        }

                        if (!(departure && destination && dateFrom)) {
                            console.log('🚫 Не все данные введены, форма не отправляется');
                            parent.classList.remove('loading', 'sending');
                            e.preventDefault();
                            return;
                        }

                        window.brxTracking.sendAnalyticsEvent('click_avia_find_form_submit_btn');

                        _this36.saveRestoreParams();
                        console.log('🚀 Отправляем форму!');
                    });
                }
            }, {
                key: "saveRestoreParams",
                value: function saveRestoreParams() {
                    var fields = document.querySelectorAll('.search-avia-form .form-field__value');
                    if (!fields.length) return;

                    var labels = {
                        departure: fields[0] ? fields[0].textContent : '',
                        destination: fields[1] ? fields[1].textContent : '',
                        dates: fields[2] ? fields[2].textContent : '',
                        tourists: fields[3] ? fields[3].textContent : ''
                    };

                    this.restoreFormParams.save(this.values, labels);
                }
            }, {
                key: "waypointType",
                value: function waypointType(type) {
                    return type === 'airport' ? 'airport' : 'city';
                }
            }]);

            return FindAviaForm;
        }();

        window.FindAviaForm = FindAviaForm;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var _require7 = require('./calendar-labels-ru'),
            monthNames = _require7.monthNames,
            weekDayNamesShort = _require7.weekDayNamesShort;

        var CalendarSettings = require('./CalendarSettings');

        var CalendarMonth = function () {
            /**
             * @param {CalendarSettings|null} settings
             */
            function CalendarMonth() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _classCallCheck(this, CalendarMonth);

                /** @type {CalendarSettings} */
                this.settings = settings !== null ? settings : new CalendarSettings();
                var messages = this.settings.messages;
                this.monthNames = messages ? messages.monthNames : monthNames;
                this.weekDayNamesShort = messages ? messages.weekDayNamesShort : weekDayNamesShort;
            }

            /**
             * @param {number} month - 0-11
             * @param {number} fullYear
             * @return {string}
             */


            _createClass(CalendarMonth, [{
                key: "renderMonth",
                value: function renderMonth(month, fullYear) {
                    var baseDate = new Date(fullYear, month, 1);
                    // Первый день месяца
                    var firstDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
                    // последний день месяца
                    var lastDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
                    // Последний день предыдущего месяца
                    var lastDateOfPrevMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

                    var firstDay = this.settings.firstDay;

                    var i = void 0;
                    var weekDay = void 0;
                    var weekDaysCellsHtml = '';
                    var startWeekDay = null;
                    var endWeekDay = null;
                    for (i = 0; i < 7; i++) {
                        weekDay = i + firstDay;
                        weekDay = weekDay > 6 ? weekDay - 7 : weekDay;
                        if (startWeekDay === null) {
                            startWeekDay = weekDay;
                        }
                        endWeekDay = weekDay;
                        weekDaysCellsHtml += '<td class="brx-calendar__day-name">' + this.weekDayNamesShort[i] + '</td>';
                    }

                    // Пустые клетки предыдущего месяца
                    var prevMonthEmptyCellCount = firstDateOfMonth.getDay() - firstDay;
                    if (prevMonthEmptyCellCount < 0) {
                        prevMonthEmptyCellCount = prevMonthEmptyCellCount + 7;
                    }
                    // Пустые клетки следующего месяца
                    // Если месяц заканчивается последним дней недели - 0
                    var nextMonthEmptyCellCount = lastDateOfMonth.getDay() === endWeekDay ? 0 : 7 + 1 - lastDateOfMonth.getDay() - firstDay;
                    // Кол-во дней в календаре
                    var datesCount = prevMonthEmptyCellCount + nextMonthEmptyCellCount + lastDateOfMonth.getDate();

                    // День предыдущего месяца, с которого начинается календарь
                    var prevMonthStartDate = lastDateOfPrevMonth.getDate() - prevMonthEmptyCellCount + 1;
                    // Начинаем рисовать с этой даты
                    var dateInstance = new Date(lastDateOfPrevMonth.getFullYear(), lastDateOfPrevMonth.getMonth(), prevMonthStartDate);
                    // dataInstance.getDay() === startWeekDay // Должно быть true

                    var calendarDatesHtml = '';
                    var rowHtml = '';
                    for (i = 0; i < datesCount; i++) {
                        rowHtml += this.getDateCell(dateInstance, dateInstance.getMonth() !== baseDate.getMonth());
                        if (endWeekDay === dateInstance.getDay()) {
                            // Конец недели
                            calendarDatesHtml += '<tr class="brx-calendar__row">' + rowHtml + '</tr>';
                            rowHtml = '';
                        }
                        // сдвигаем дату на след. день
                        dateInstance = new Date(dateInstance.getFullYear(), dateInstance.getMonth(), dateInstance.getDate() + 1);
                    }

                    var monthLabel = this.monthNames[baseDate.getMonth()] + (this.settings.showYear ? ' ' + baseDate.getFullYear() : '');
                    return '<div class="brx-calendar__wrapper">' + '<div class="brx-calendar__month">' + monthLabel + '</div>' + '<table class="brx-calendar__dates">' + '<thead><tr class="brx-calendar__row">' + weekDaysCellsHtml + '</tr></thead>' + '<tbody>' + calendarDatesHtml + '</tbody>' + '</table>' + '</div>';
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {string} - table cell html
                 */

            }, {
                key: "getDateCell",
                value: function getDateCell(date, empty) {
                    var today = new Date();
                    var settings = this.getDateSettings(date, empty);

                    var classList = 'brx-calendar__date' + (empty ? ' brx-calendar__date-empty' : '');

                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    var disabled = empty;
                    if (minDate && minDate.getTime() > date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }
                    if (maxDate && maxDate.getTime() < date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }

                    if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
                        classList += ' today';
                    }
                    classList += settings.cssClass !== '' ? ' ' + settings.cssClass : '';

                    return '<td class="' + classList + '">' + (empty && !this.settings.showEmptyDate ? '&nbsp;' : this.renderDateCellButton(date)) + '</td>';
                }

                /**
                 * @private
                 * @param {Date} date
                 */

            }, {
                key: "renderDateCellButton",
                value: function renderDateCellButton(date) {
                    var dateStringValue = this.dateToStringValue(date);
                    return "<button type=\"button\"\n                        class=\"brx-calendar__date-button\"\n                        data-date=\"" + dateStringValue + "\"\n                        data-date-day=\"" + date.getDate() + "\">" + date.getDate() + "</button>";
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {{cssClass: string}}
                 * @private
                 */

            }, {
                key: "getDateSettings",
                value: function getDateSettings(date, empty) {
                    var cssClass = this.settings.getDateCellCustomCssClass ? this.settings.getDateCellCustomCssClass(date, empty) : '';
                    return { cssClass: cssClass };
                }

                /**
                 * Формат значения в data-date
                 * @param {Date} date
                 * @return {string}
                 */

            }, {
                key: "dateToStringValue",
                value: function dateToStringValue(date) {
                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);

                    return day + '.' + month + '.' + date.getFullYear();
                }

                /**
                 * relates to this.dateToStringValue()
                 * @param {string} dateStringValue - Формат как и в dateToStringValue
                 * @return {Date}
                 */

            }, {
                key: "getDateFromValue",
                value: function getDateFromValue(dateStringValue) {
                    var values = dateStringValue.split('.');
                    return new Date(values[2], values[1] - 1, values[0]);
                }
            }]);

            return CalendarMonth;
        }();

        module.exports = CalendarMonth;
    }, { "./CalendarSettings": 2, "./calendar-labels-ru": 3 }], 2: [function (require, module, exports) {
        var CalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function CalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, CalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(CalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages5 = settings.messages,
                            monthNames = _settings$messages5.monthNames,
                            weekDayNamesShort = _settings$messages5.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return CalendarSettings;
        }();

        module.exports = CalendarSettings;
    }, {}], 3: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var CalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function CalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, CalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(CalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages6 = settings.messages,
                            monthNames = _settings$messages6.monthNames,
                            weekDayNamesShort = _settings$messages6.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return CalendarSettings;
        }();

        module.exports = CalendarSettings;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewAviaCalendarDateUtils = function () {
            function NewAviaCalendarDateUtils() {
                _classCallCheck(this, NewAviaCalendarDateUtils);
            }

            _createClass(NewAviaCalendarDateUtils, null, [{
                key: "parseIsoDate",
                value: function parseIsoDate(value) {
                    if (!value) return null;
                    if (value instanceof Date) {
                        return this.normalizeDate(value);
                    }

                    if (typeof value === 'string') {
                        var match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
                        if (match) {
                            var year = Number(match[1]);
                            var month = Number(match[2]) - 1;
                            var day = Number(match[3]);
                            return new Date(year, month, day);
                        }
                    }

                    var date = new Date(value);
                    if (isNaN(date)) return null;
                    return this.normalizeDate(date);
                }
            }, {
                key: "normalizeDate",
                value: function normalizeDate(value) {
                    var date = value instanceof Date ? new Date(value) : new Date(value);
                    if (isNaN(date)) return null;

                    date.setHours(0, 0, 0, 0);
                    return date;
                }
            }, {
                key: "formatIsoDate",
                value: function formatIsoDate(value) {
                    var date = this.parseIsoDate(value);
                    if (!date) return '';

                    var yyyy = date.getFullYear();
                    var mm = String(date.getMonth() + 1).padStart(2, '0');
                    var dd = String(date.getDate()).padStart(2, '0');
                    return yyyy + '-' + mm + '-' + dd;
                }
            }]);

            return NewAviaCalendarDateUtils;
        }();

        window.NewAviaCalendarDateUtils = NewAviaCalendarDateUtils;
        module.exports = NewAviaCalendarDateUtils;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var _require8 = require('./calendar-labels-ru'),
            monthNames = _require8.monthNames,
            weekDayNamesShort = _require8.weekDayNamesShort;

        var NewCalendarSettings = require('./NewCalendarSettings');

        var NewCalendarMonth = function () {
            /**
             * @param {CalendarSettings|null} settings
             */
            function NewCalendarMonth() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _classCallCheck(this, NewCalendarMonth);

                /** @type {CalendarSettings} */
                this.settings = settings !== null ? settings : new NewCalendarSettings();
                var messages = this.settings.messages;
                this.monthNames = messages ? messages.monthNames : monthNames;
                this.weekDayNamesShort = messages ? messages.weekDayNamesShort : weekDayNamesShort;
            }

            /**
             * @param {number} month - 0-11
             * @param {number} fullYear
             * @return {string}
             */


            _createClass(NewCalendarMonth, [{
                key: "renderMonth",
                value: function renderMonth(month, fullYear) {
                    var baseDate = new Date(fullYear, month, 1);
                    // Первый день месяца
                    var firstDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
                    // последний день месяца
                    var lastDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
                    // Последний день предыдущего месяца
                    var lastDateOfPrevMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

                    var firstDay = this.settings.firstDay;

                    var i = void 0;
                    var weekDay = void 0;
                    var weekDaysCellsHtml = '';
                    var startWeekDay = null;
                    var endWeekDay = null;
                    for (i = 0; i < 7; i++) {
                        weekDay = i + firstDay;
                        weekDay = weekDay > 6 ? weekDay - 7 : weekDay;
                        if (startWeekDay === null) {
                            startWeekDay = weekDay;
                        }
                        endWeekDay = weekDay;
                        weekDaysCellsHtml += '<td class="brx-calendar__day-name">' + this.weekDayNamesShort[i] + '</td>';
                    }

                    // Пустые клетки предыдущего месяца
                    var prevMonthEmptyCellCount = firstDateOfMonth.getDay() - firstDay;
                    if (prevMonthEmptyCellCount < 0) {
                        prevMonthEmptyCellCount = prevMonthEmptyCellCount + 7;
                    }
                    // Пустые клетки следующего месяца
                    // Если месяц заканчивается последним дней недели - 0
                    var nextMonthEmptyCellCount = lastDateOfMonth.getDay() === endWeekDay ? 0 : 7 + 1 - lastDateOfMonth.getDay() - firstDay;
                    // Кол-во дней в календаре
                    var datesCount = prevMonthEmptyCellCount + nextMonthEmptyCellCount + lastDateOfMonth.getDate();

                    // День предыдущего месяца, с которого начинается календарь
                    var prevMonthStartDate = lastDateOfPrevMonth.getDate() - prevMonthEmptyCellCount + 1;
                    // Начинаем рисовать с этой даты
                    var dateInstance = new Date(lastDateOfPrevMonth.getFullYear(), lastDateOfPrevMonth.getMonth(), prevMonthStartDate);
                    // dataInstance.getDay() === startWeekDay // Должно быть true

                    var calendarDatesHtml = '';
                    var rowHtml = '';
                    for (i = 0; i < datesCount; i++) {
                        rowHtml += this.getDateCell(dateInstance, dateInstance.getMonth() !== baseDate.getMonth());
                        if (endWeekDay === dateInstance.getDay()) {
                            // Конец недели
                            calendarDatesHtml += '<tr class="brx-calendar__row">' + rowHtml + '</tr>';
                            rowHtml = '';
                        }
                        // сдвигаем дату на след. день
                        dateInstance = new Date(dateInstance.getFullYear(), dateInstance.getMonth(), dateInstance.getDate() + 1);
                    }

                    var monthLabel = this.monthNames[baseDate.getMonth()] + (this.settings.showYear ? ' ' + baseDate.getFullYear() : '');
                    return '<div class="brx-calendar__wrapper">' + '<div class="brx-calendar__month">' + monthLabel + '</div>' + '<table class="brx-calendar__dates">' + '<thead><tr class="brx-calendar__row">' + weekDaysCellsHtml + '</tr></thead>' + '<tbody>' + calendarDatesHtml + '</tbody>' + '</table>' + '</div>';
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {string} - table cell html
                 */

            }, {
                key: "getDateCell",
                value: function getDateCell(date, empty) {
                    var today = new Date();
                    var settings = this.getDateSettings(date, empty);

                    var classList = 'brx-calendar__date' + (empty ? ' brx-calendar__date-empty' : '');

                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    var disabled = empty;
                    if (minDate && minDate.getTime() > date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }
                    if (maxDate && maxDate.getTime() < date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }

                    if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
                        classList += ' today';
                    }
                    classList += settings.cssClass !== '' ? ' ' + settings.cssClass : '';

                    return '<td class="' + classList + '">' + (empty && !this.settings.showEmptyDate ? '&nbsp;' : this.renderDateCellButton(date)) + '</td>';
                }

                /**
                 * @private
                 * @param {Date} date
                 */

            }, {
                key: "renderDateCellButton",
                value: function renderDateCellButton(date) {
                    var dateStringValue = this.dateToStringValue(date);
                    return "<button type=\"button\"\n                        class=\"brx-calendar__date-button\"\n                        data-date=\"" + dateStringValue + "\"\n                        data-date-day=\"" + date.getDate() + "\">" + date.getDate() + "</button>";
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {{cssClass: string}}
                 * @private
                 */

            }, {
                key: "getDateSettings",
                value: function getDateSettings(date, empty) {
                    var cssClass = this.settings.getDateCellCustomCssClass ? this.settings.getDateCellCustomCssClass(date, empty) : '';
                    return { cssClass: cssClass };
                }

                /**
                 * Формат значения в data-date
                 * @param {Date} date
                 * @return {string}
                 */

            }, {
                key: "dateToStringValue",
                value: function dateToStringValue(date) {
                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);

                    return day + '.' + month + '.' + date.getFullYear();
                }

                /**
                 * relates to this.dateToStringValue()
                 * @param {string} dateStringValue - Формат как и в dateToStringValue
                 * @return {Date}
                 */

            }, {
                key: "getDateFromValue",
                value: function getDateFromValue(dateStringValue) {
                    var values = dateStringValue.split('.');
                    return new Date(values[2], values[1] - 1, values[0]);
                }
            }]);

            return NewCalendarMonth;
        }();

        module.exports = NewCalendarMonth;
    }, { "./NewCalendarSettings": 2, "./calendar-labels-ru": 3 }], 2: [function (require, module, exports) {
        var NewCalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function NewCalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, NewCalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(NewCalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages7 = settings.messages,
                            monthNames = _settings$messages7.monthNames,
                            weekDayNamesShort = _settings$messages7.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return NewCalendarSettings;
        }();

        module.exports = NewCalendarSettings;
    }, {}], 3: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var NewCalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function NewCalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, NewCalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(NewCalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages8 = settings.messages,
                            monthNames = _settings$messages8.monthNames,
                            weekDayNamesShort = _settings$messages8.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return NewCalendarSettings;
        }();

        module.exports = NewCalendarSettings;
    }, {}] }, {}, [1]);